(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basket-pdp-v2a"] && !Shopify.designMode) return;
  try {
    
const relationMap = {
  '父親':{title:'父親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '母親':{title:'母親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '丈夫':{title:'夫君大人',hon:'千古',prefix:'妻',suffix:'哀輓'},
  '妻子':{title:'賢妻',hon:'千古',prefix:'夫',suffix:'哀輓'},
  '兄':{title:'胞兄大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '弟':{title:'賢弟',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '姊':{title:'胞姊大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '妹':{title:'賢妹',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '家翁':{title:'家翁大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '家姑':{title:'家姑大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '岳父':{title:'岳父大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '岳母':{title:'岳母大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '伯父':{title:'伯父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '叔父':{title:'叔父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '伯娘':{title:'伯娘',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑姐':{title:'姑媽',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑丈':{title:'姑丈',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '舅父':{title:'舅父大人',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '舅母':{title:'舅母',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨媽':{title:'姨媽',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨丈':{title:'姨丈',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '祖父':{title:'祖父大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '祖母':{title:'祖母大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '外祖父':{title:'外祖父大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '外祖母':{title:'外祖母大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '朋友男':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '朋友女':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '同事男':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '同事女':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '公司':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '教會弟兄':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '教會姊妹':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '子姪男':{title:'賢姪',hon:'千古',prefix:'',suffix:'痛輓'},
  '子姪女':{title:'賢姪女',hon:'千古',prefix:'',suffix:'痛輓'},
};
const relationGender = {
  '父親':'M','母親':'F','丈夫':'M','妻子':'F',
  '兄':'M','弟':'M','姊':'F','妹':'F',
  '家翁':'M','家姑':'F','岳父':'M','岳母':'F',
  '伯父':'M','叔父':'M','伯娘':'F','姑姐':'F','姑丈':'M',
  '舅父':'M','舅母':'F','姨媽':'F','姨丈':'M',
  '祖父':'M','祖母':'F','外祖父':'M','外祖母':'F',
  '表兄弟':'M','表姊妹':'F','姐夫':'M',
  '朋友男':'M','朋友女':'F','同事男':'M','同事女':'F',
  '公司':'M','教會弟兄':'M','教會姊妹':'F',
  '子姪男':'M','子姪女':'F',
};
const prefixLevel = {
  '妻':0,'夫':0,
  '胞兄':0,'胞弟':0,'胞姊':0,'胞妹':0,
  '孝子':1,'孝女':1,'孝媳':1,'孝婿':1,
  '姪':1,'姪女':1,'外甥':1,'外甥女':1,
  '表兄':1,'表弟':1,'表姊':1,'表妹':1,
  '孫男':2,'孫女':2,'外孫男':2,'外孫女':2,
  '孝孫':2,'孝孫女':2,'孝外孫':2,'孝外孫女':2,
  '姪孫':2,'姪孫女':2,'外甥孫':2,'外甥孫女':2,
  '表姪':2,'表姪女':2,
  '曾孫男':3,'曾孫女':3,'外曾孫男':3,'外曾孫女':3,
  '姪曾孫':3,'姪曾孫女':3,
  '玄孫男':4,'玄孫女':4,
};
const rankableSet = new Set(['孝子','孝女','孝媳','孝婿','孝孫','孝孫女','孝外孫','孝外孫女']);
function applyRank(prefix, rank){
  if(!rank||!rankableSet.has(prefix))return prefix;
  return prefix[0]+rank+prefix.slice(1);
}
function prefixGender(p){
  if(/(妻|女|媳|姊|妹|姪女|甥女|孫女|曾孫女|玄孫女|姪曾孫女|外甥孫女|姪孫女)/.test(p))return 1;
  return 0;
}
const rankOrder={'長':1,'次':2,'三':3,'四':4,'五':5,'六':6,'':7};
const phrases = {
  '通用': {
    neutral: ['永遠懷念','沈痛悼念','千古不朽','一路好走','駕鶴西歸','福壽全歸','哀思永念','風範長存'],
    male: ['典範長存','德澤永存','英名永存','浩氣長存','流芳百世','萬古流芳','英靈不泯','典型猶存'],
    female: ['母儀千古','懿範永存','慈暉永昭','音容宛在','音容宛存','寶婺光寒','慈雲歸西','慈竹風悲'],
  },
  '佛教': {
    neutral: ['蓮邦極樂','往生極樂','西方接引','倒駕慈航','早登蓮邦','同登彼岸','早歸極樂','蓮座飄香'],
    male: [],
    female: [],
  },
  '基督教': {
    neutral: ['主懷安息','蒙主恩召','安息主懷','永居天家','平安歸主','主賜安寧','永生安息','在主裡睡了'],
    male: [],
    female: [],
  },
  '天主教': {
    neutral: ['蒙主寵召','永享主光','安息天國','復活享福','永享天國','諸聖之福'],
    male: [],
    female: [],
  },
};
const phraseExplain = {
  '永遠懷念':'長存於心的思念 · 最普世的悼念詞 · 適用所有親疏關係',
  '沈痛悼念':'表達深切哀痛之意 · 適用所有關係',
  '千古不朽':'永世長存 · 永不磨滅 · 中性通用',
  '一路好走':'願先人一路平安 · 口語親切 · 中性通用',
  '駕鶴西歸':'仙鶴載歸西方 · 典雅 · 適合長者善終',
  '福壽全歸':'福分壽命圓滿 · 適合高壽善終',
  '哀思永念':'哀痛思念永遠長存',
  '風範長存':'先人風範永存後人心中',
  '典範長存':'先人風範永存 · 多用於男性長輩',
  '德澤永存':'恩德與蔭澤永遠存在 · 適合男性',
  '英名永存':'英明事跡永誌不忘 · 適合男性 / 英雄人物',
  '浩氣長存':'浩然正氣永存 · 適合公職 / 英烈男性',
  '流芳百世':'美好聲名流傳百世 · 多用於男性',
  '萬古流芳':'美名永遠流傳 · 多用於男性',
  '英靈不泯':'英魂永不磨滅 · 適合男性',
  '典型猶存':'典範樣本尚存 · 適合男性長輩',
  '母儀千古':'慈母典範永流傳 · 適合母親',
  '懿範永存':'美好德行典範永存 · 適合女性長輩',
  '慈暉永昭':'慈愛光輝永遠照耀 · 適合母親',
  '音容宛在':'容貌聲音猶如尚存 · 傳統用於女性 · 形容深切思念',
  '音容宛存':'容貌音聲尚在 · 女性異體',
  '寶婺光寒':'婺女星（女性星宿）光暗 · 形容德高女性離世',
  '慈雲歸西':'慈愛之雲歸西 · 適合女性長輩',
  '慈竹風悲':'慈母如竹 · 風中悲傷 · 適合母親',
  '蓮邦極樂':'蓮邦即西方極樂淨土',
  '往生極樂':'往生阿彌陀佛西方極樂世界',
  '西方接引':'阿彌陀佛接引往西方淨土',
  '倒駕慈航':'已脫生死返回度化眾生',
  '早登蓮邦':'早日登入極樂蓮花世界',
  '同登彼岸':'共同到達覺悟彼岸',
  '早歸極樂':'早日歸於極樂淨土',
  '蓮座飄香':'蓮花座發出芬芳',
  '主懷安息':'安睡在主懷抱',
  '蒙主恩召':'蒙主慈愛召喚回天家',
  '安息主懷':'安睡在主懷抱',
  '永居天家':'永遠居住天國家中',
  '平安歸主':'安然回歸主裡',
  '主賜安寧':'主賜予永遠安寧',
  '永生安息':'永恆生命中的安息',
  '在主裡睡了':'聖經用語 · 指逝世（哥前 15:18）',
  '蒙主寵召':'蒙主寵愛召喚回天家',
  '永享主光':'永遠享有主的榮光',
  '安息天國':'在天國中安息',
  '復活享福':'復活並享永福',
  '永享天國':'永遠享有天國之福',
  '諸聖之福':'與諸聖一同享福',
};
const banner=document.querySelector('.banner-canvas');
const bp=document.getElementById('bp-phrase');
const bpReltitle=document.getElementById('bp-reltitle'),bpName=document.getElementById('bp-name'),bpHon=document.getElementById('bp-hon');
const bpSenders=document.getElementById('bp-senders'),bpSuffix=document.getElementById('bp-suffix');
const inRel=document.getElementById('in-relation'),inName=document.getElementById('in-name'),inGender=document.getElementById('in-gender'),inSuffix=document.getElementById('in-suffix');
const sendersGroup=document.getElementById('senders-group'),addSenderBtn=document.getElementById('add-sender');
const autoHint=document.getElementById('auto-hint'),autoHintText=document.getElementById('auto-hint-text');
const chipContainer=document.getElementById('chip-container'),chipSuggested=document.getElementById('chip-suggested');
const pmPhrase=document.getElementById('pm-phrase'),pmText=document.getElementById('pm-text');
const slot30=document.getElementById('slot30');
const priceDisp=document.getElementById('price-display'),priceSize=document.getElementById('price-size');
const sumSize=document.getElementById('sum-size'),sumFlower=document.getElementById('sum-flower'),sumZone=document.getElementById('sum-zone'),sumShip=document.getElementById('sum-ship'),sumUpLabel=document.getElementById('sum-up-label'),sumUp=document.getElementById('sum-up'),sumTotal=document.getElementById('sum-total');
const zoneName=document.getElementById('zone-name'),zoneFee=document.getElementById('zone-fee'),venueName=document.getElementById('venue-name');
let _initPrice = 0, _initLabel = '—';
const _multiData = document.getElementById('tfk-variants-data');
if(_multiData){
  try {
    const _d = JSON.parse(_multiData.textContent);
    const _opt1 = document.querySelector('.opt1-grid .opt-size-btn.is-active');
    const _opt2 = document.querySelector('.opt2-grid .cv-btn.is-active');
    const _v1 = _opt1 ? _opt1.getAttribute('data-opt-value') : null;
    const _v2 = _opt2 ? _opt2.getAttribute('data-opt-value') : null;
    let _match = (_d.variants||[]).find(v => v.opt1===_v1 && v.opt2===_v2);
    if(!_match && _v1){ var _cand=(_d.variants||[]).filter(function(v){return v.opt1===_v1;}); _cand.sort(function(a,b){return a.price-b.price;}); if(_cand.length) _match=_cand[0]; }
    if(_match){ _initPrice = _match.price; _initLabel = _v1 + (_v2? ' · ' + _v2 : ''); }
  } catch(e){}
} else {
  const _activeSize=document.querySelector('.size.is-active')||document.querySelector('.size');
  _initPrice=_activeSize?parseFloat((_activeSize.dataset.price||'0').replace(/,/g,'')):0;
  _initLabel=_activeSize?(_activeSize.dataset.cn||(_activeSize.querySelector('.cn')?_activeSize.querySelector('.cn').textContent:'—')):'—';
}
const state={flower:_initPrice||0,sizeLabel:_initLabel,ship:0,shipLabel:'免費',upLabel:'—',up:0,timeFee:0,timeLabel:'',activePhrase:''}; window.__tfkState=state;
function recalc(){
  const t=state.flower+state.ship+state.up+(state.timeFee||0);
  sumSize.textContent=state.sizeLabel;sumFlower.textContent=`HK$${state.flower.toLocaleString()}`;
  sumShip.textContent=state.shipLabel;var _ad=state.up+(state.timeFee||0);sumUpLabel.textContent=[state.timeLabel,(state.upLabel&&state.upLabel!=='—')?state.upLabel:''].filter(Boolean).join(' + ')||'—';sumUp.textContent=_ad?'HK$'+_ad.toLocaleString():'—';
  sumTotal.textContent=`HK$${t.toLocaleString()}`;
}
recalc();
window.tfkRecalc=recalc;
document.querySelectorAll('.size').forEach(s=>s.addEventListener('click',()=>{
  if(s.hasAttribute('data-opt-value')) return;
  const grid=s.parentElement;
  if(grid) grid.querySelectorAll('.size').forEach(x=>x.classList.remove('is-active'));
  s.classList.add('is-active');
  const raw=(s.dataset.price||'').replace(/,/g,'');
  const p=parseFloat(raw);
  if(!isFinite(p)) return;
  state.flower=p;
  state.sizeLabel=s.dataset.cn||s.querySelector('.cn').textContent;
  priceDisp.textContent='HK$'+p.toLocaleString();priceSize.textContent=s.dataset.cn;
  const idIn=document.getElementById('v2a-variant-id');if(idIn)idIn.value=s.dataset.variantId;
  recalc();
}));
const zoneFees={1:[0,'免費','Zone 1 · 港島 + 九龍','Same-day standard'],2:[150,'HK$150','Zone 2 · 新界主區','New Territories'],3:[250,'HK$250','Zone 3 · 新界遠郊 + 離島','Outer NT / islands']};
venueName.addEventListener('change',()=>{
  const z=+venueName.options[venueName.selectedIndex].dataset.zone||1;
  const [fee,feeLabel,zname,zsub]=zoneFees[z];
  state.ship=fee;state.shipLabel=feeLabel;
  zoneName.innerHTML=zname+' <em>'+zsub+'</em>';zoneFee.textContent=feeLabel+(fee===0?' · Free':'');
  zoneFee.classList.toggle('free',fee===0);sumZone.textContent=zname;recalc();
});
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',()=>{
  if(u.classList.contains('is-active')){u.classList.remove('is-active');state.up=0;state.upLabel='—';}
  else{document.querySelectorAll('.upgrade').forEach(x=>x.classList.remove('is-active'));u.classList.add('is-active');state.up=+u.dataset.fee;state.upLabel=u.querySelector('.cn').textContent;}
  recalc();
}));
document.querySelectorAll('.quick,.time-cat,.hour').forEach(b=>b.addEventListener('click',(e)=>{
  if(b.classList.contains('is-disabled'))return;
  e.stopPropagation();
  const peers=b.parentElement.querySelectorAll(':scope > .quick, :scope > .time-cat, :scope > .hour');
  peers.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
}));
function getSenders(){
  return Array.from(sendersGroup.querySelectorAll('.sender-row')).map(row=>({
    prefix:row.querySelector('.sender-prefix').value,
    rank:row.querySelector('.sender-rank')?.value||'',
    name:row.querySelector('.sender-name').value.trim(),
  })).filter(s=>s.name||s.prefix);
}
function sortSenders(senders){
  return senders.slice().sort((a,b)=>{
    const la=prefixLevel[a.prefix]??99, lb=prefixLevel[b.prefix]??99;
    if(la!==lb)return la-lb;
    const ga=prefixGender(a.prefix),gb=prefixGender(b.prefix);
    if(ga!==gb)return ga-gb;
    return (rankOrder[a.rank]||7)-(rankOrder[b.rank]||7);
  });
}
function syncBanner(){
  const m=relationMap[inRel.value];
  bpReltitle.textContent=m?.title?m.title:'';
  bpName.textContent=inName.value||'先人名稱';
  bpHon.textContent=m?.hon||'千古';
  const rawSenders=getSenders();
  const senders=sortSenders(rawSenders);
  bpSenders.innerHTML='';
  if(senders.length===0){
    bpSenders.innerHTML=`<div class="bnr-sender"><span class="sname" style="color:var(--muted)">送花人名稱</span></div>`;
  }else{
    const firstLevel=prefixLevel[senders[0].prefix]??99;
    senders.forEach((s,idx)=>{
      const div=document.createElement('div');
      div.className='bnr-sender';
      const displayPrefix=applyRank(s.prefix,s.rank);
      const senderLevel=prefixLevel[s.prefix]??99;
      const rate=(idx>0&&senderLevel!==firstLevel)?`<span class="srate">率</span>`:'';
      const px=displayPrefix?`<span class="sprefix">${displayPrefix}</span>`:'';
      const nm=`<span class="sname">${s.name||'（未填名稱）'}</span>`;
      div.innerHTML=rate+px+nm;
      bpSenders.appendChild(div);
    });
  }
  bpSuffix.textContent=inSuffix.value;
  autoShrink();
}
function autoShrink(){
  const senderCount=Math.max(1,getSenders().length);
  let scale=1;
  if(senderCount>=5)scale=.62;
  else if(senderCount===4)scale=.72;
  else if(senderCount===3)scale=.82;
  else if(senderCount===2)scale=.92;
  const suffixLen=bpSuffix.textContent.length;
  let l4Scale=scale;
  if(suffixLen>=4)l4Scale*=.92;
  const L1_MAX=15;
  banner.style.setProperty('--l1',`${L1_MAX}cqw`);
  banner.style.setProperty('--l2',`${17*scale}cqw`);
  banner.style.setProperty('--l3',`${8*scale}cqw`);
  banner.style.setProperty('--l4',`${6*l4Scale}cqw`);
  banner.style.setProperty('--gap',`${2.5*scale}cqw`);
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    const cw=banner.clientWidth;
    if(cw<10)return;
    const availW=cw*0.84; // 84% safety margin
    const l1El=document.querySelector('.bnr-line1');
    const l2El=bp;
    const l3Els=Array.from(bpSenders.querySelectorAll('.bnr-sender'));
    const l4El=bpSuffix;
    let lo=3,hi=L1_MAX,best=3;
    for(let i=0;i < 10;i++){
      const mid=(lo+hi)/2;
      banner.style.setProperty('--l1',`${mid}cqw`);
      void l1El.offsetWidth; // force reflow
      if(l1El.scrollWidth<=availW){best=mid;lo=mid;}
      else{hi=mid;}
    }
    banner.style.setProperty('--l1',`${best}cqw`);
    let furtherL2=1,furtherL3=1,furtherL4=1;
    if(l2El.scrollWidth>availW)furtherL2=Math.max(.55,availW/l2El.scrollWidth);
    l3Els.forEach(e=>{if(e.scrollWidth>availW){furtherL3=Math.min(furtherL3,Math.max(.55,availW/e.scrollWidth));}});
    if(l4El.scrollWidth>availW)furtherL4=Math.max(.55,availW/l4El.scrollWidth);
    if(furtherL2<1)banner.style.setProperty('--l2',`${17*scale*furtherL2}cqw`);
    if(furtherL3<1)banner.style.setProperty('--l3',`${8*scale*furtherL3}cqw`);
    if(furtherL4<1)banner.style.setProperty('--l4',`${6*l4Scale*furtherL4}cqw`);
    const overflowReduced=Math.min(furtherL2,furtherL3,furtherL4);
    updateShrinkBadge(scale,overflowReduced);
  }));
  function updateShrinkBadge(senderScale,overflowScale){
    const tag=document.querySelector('.preview-foot .shrink-tag');
    const totalScale=senderScale*overflowScale;
    if(totalScale<.99){
      let label=`Auto-shrink ${Math.round(totalScale*100)}%`;
      if(overflowScale<.99 && senderScale<.99)label+=' (多人+名長)';
      else if(overflowScale<.99)label+=' (字過長)';
      else label+=` (${getSenders().length} 位送花人)`;
      if(!tag){
        const t=document.createElement('span');t.className='shrink-tag';t.textContent=label;
        document.querySelector('.preview-foot').appendChild(t);
      }else{tag.textContent=label;}
    }else if(tag){tag.remove();}
  }
}
inName.addEventListener('input',syncBanner);
inSuffix.addEventListener('change',syncBanner);
sendersGroup.addEventListener('input',syncBanner);
sendersGroup.addEventListener('change',syncBanner);
const relSenderCats = {
  '父親':['子女輩','孫輩','曾孫 / 玄孫'],
  '母親':['子女輩','孫輩','曾孫 / 玄孫'],
  '家翁':['子女輩','孫輩'],
  '家姑':['子女輩','孫輩'],
  '岳父':['子女輩','孫輩'],
  '岳母':['子女輩','孫輩'],
  '丈夫':['子女輩','孫輩'],
  '妻子':['子女輩','孫輩'],
  '兄':['兄弟姊妹','父系姪輩'],
  '弟':['兄弟姊妹','父系姪輩'],
  '姊':['兄弟姊妹','父系姪輩'],
  '妹':['兄弟姊妹','父系姪輩'],
  '伯父':['父系姪輩'],
  '叔父':['父系姪輩'],
  '伯娘':['父系姪輩'],
  '姑姐':['父系姪輩'],
  '姑丈':['父系姪輩'],
  '舅父':['母系外甥輩'],
  '舅母':['母系外甥輩'],
  '姨媽':['母系外甥輩'],
  '姨丈':['母系外甥輩'],
  '祖父':['孫輩','曾孫 / 玄孫'],
  '祖母':['孫輩','曾孫 / 玄孫'],
  '外祖父':['孫輩','曾孫 / 玄孫'],
  '外祖母':['孫輩','曾孫 / 玄孫'],
  '表兄弟':['表親'],
  '表姊妹':['表親'],
  '姐夫':['表親'],
  '朋友男':[],
  '朋友女':[],
  '同事男':[],
  '同事女':[],
  '公司':[],
  '教會弟兄':[],
  '教會姊妹':[],
  '子姪男':[],
  '子姪女':[],
};
function buildPrefixSelectHTML(relation, includeBlank=true){
  const allowedCats=relSenderCats[relation];
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  let html='';
  if(includeBlank){
    html+=`<option value="">（無前綴）</option>`;
    html+=`<option value="（不指定排行）">（不指定排行）</option>`;
  }
  if(!relation||!allowedCats||allowedCats.length===0){
    return primary.innerHTML; // fall back to primary's full list
  }
  const fullOpts=primary.querySelectorAll('optgroup');
  fullOpts.forEach(og=>{
    if(allowedCats.includes(og.label)){
      html+=`<optgroup label="${og.label}">`;
      og.querySelectorAll('option').forEach(o=>html+=`<option value="${o.value}">${o.textContent}</option>`);
      html+=`</optgroup>`;
    }
  });
  return html;
}
const rankOptsHTML=`<option value="">不指定</option><option value="長">長</option><option value="次">次</option><option value="三">三</option><option value="四">四</option><option value="五">五</option><option value="六">六</option>`;
function addSenderRow(prefix='',name='',rank=''){
  const row=document.createElement('div');
  row.className='sender-row';
  const opts=buildPrefixSelectHTML(inRel.value,true);
  row.innerHTML=`
    <div>
      <span class="sender-row-label">前綴</span>
      <select class="uline sender-prefix" aria-label="送贈人稱謂">${opts}</select>
    </div>
    <div>
      <span class="sender-row-label">排行</span>
      <select class="uline sender-rank" aria-label="送贈人輩分">${rankOptsHTML}</select>
    </div>
    <div>
      <span class="sender-row-label">姓名 / 公司</span>
      <input class="uline sender-name" aria-label="送贈人姓名" autocomplete="name" placeholder="例：陳小明" />
    </div>
    <button class="remove" type="button">×</button>
  `;
  sendersGroup.appendChild(row);
  if(prefix)row.querySelector('.sender-prefix').value=prefix;
  if(rank)row.querySelector('.sender-rank').value=rank;
  if(name)row.querySelector('.sender-name').value=name;
  row.querySelector('.remove').addEventListener('click',()=>{row.remove();syncBanner();updateAddSenderHint();});
  updateRowRankAvailability(row);
  syncBanner();
  updateAddSenderHint();
}
function updateRowRankAvailability(row){
  const sel=row.querySelector('.sender-prefix');
  const rank=row.querySelector('.sender-rank');
  if(!rank)return;
  if(!rankableSet.has(sel.value)){
    rank.value='';
    rank.classList.add('is-disabled');
    rank.title='此前綴不支持排行（長/次/三...）';
  }else{
    rank.classList.remove('is-disabled');
    rank.title='';
  }
}
sendersGroup.addEventListener('change',e=>{
  if(e.target.classList.contains('sender-prefix')){
    updateRowRankAvailability(e.target.closest('.sender-row'));
  }
});
addSenderBtn.addEventListener('click',()=>addSenderRow());
sendersGroup.querySelector('.sender-row.primary .remove').addEventListener('click',()=>{});
function updateAddSenderHint(){
  const v=inRel.value;
  let oldHint=document.getElementById('add-sender-hint');
  if(oldHint)oldHint.remove();
  if(!v)return;
  const cats=relSenderCats[v]||[];
  const senderCount=getSenders().length;
  let msg='',color='var(--muted)';
  if(v==='丈夫'||v==='妻子'){
    msg=`💡 夫妻互送一般係 1 位送花人（${v==='丈夫'?'妻':'夫'}）獨送 · 若子女合送可加多人`;
    color='var(--gold-deep)';
  }else if(cats.length===0){
    msg=`💡 朋友 / 同事 / 公司一般唔需要送花人前綴 · 直接輸入姓名 / 公司名`;
    color='var(--gold-deep)';
  }else{
    msg=`💡 揀「${inRel.options[inRel.selectedIndex].text}」· 可加 ${cats.join(' / ')} 嘅親屬合送`;
  }
  const hint=document.createElement('div');hint.id='add-sender-hint';
  hint.style.cssText=`font-family:var(--cjk);font-size:12px;color:${color};letter-spacing:.06em;margin-top:8px;padding:8px 12px;background:rgba(184,153,104,.08);border-left:2px solid var(--gold);line-height:1.6`;
  hint.textContent=msg;
  addSenderBtn.insertAdjacentElement('afterend',hint);
}
function syncAllPrefixLists(){
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  const primaryVal=primary.value;
  Array.from(sendersGroup.querySelectorAll('.sender-row')).forEach((row,i)=>{
    if(i===0)return; // primary
    const sel=row.querySelector('.sender-prefix');
    const oldVal=sel.value;
    sel.innerHTML=buildPrefixSelectHTML(inRel.value,true);
    sel.value=oldVal;
  });
}
inRel.addEventListener('change',()=>{syncAllPrefixLists();updateAddSenderHint();});
inRel.addEventListener('change',()=>{
  const v=inRel.value;
  if(v && relationGender[v]){
    const g=relationGender[v];
    document.getElementById('in-gender').value=g;
    state.gender=g;
    const dg=document.getElementById('derived-gender');
    if(dg){
      const gLabel=g==='M'?'男 ♂':'女 ♀';
      dg.textContent=gLabel+'（由關係推導）';
      dg.style.color=g==='M'?'var(--male)':'var(--female)';
      dg.style.borderColor=g==='M'?'var(--male)':'var(--female)';
    }
    renderChips();
  }
  if(!v||!relationMap[v]){autoHint.style.display='none';syncBanner();return;}
  const m=relationMap[v];
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  primaryPrefix.value=m.prefix||'';
  inSuffix.value=m.suffix;
  updateRowRankAvailability(sendersGroup.querySelector('.sender-row.primary'));
  syncBanner();
  autoHint.style.display='block';
  let txt=`揀「${inRel.options[inRel.selectedIndex].text}」 → 已自動填：<br/>`;
  if(m.title)txt+=`• 上聯稱謂：<span class="tag">${m.title}</span> + 先人名 + 敬稱 <span class="tag">${m.hon}</span><br/>`;
  else txt+=`• 上聯：（先人名）+ 敬稱 <span class="tag">${m.hon}</span><br/>`;
  if(m.prefix)txt+=`• 主送花人前綴：<span class="tag">${m.prefix}</span>`;
  if(m.altPrefix)txt+=` <em>· 若送花人為女性可改用「${m.altPrefix}」</em>`;
  txt+=`<br/>• 下款後綴：<span class="tag">${m.suffix}</span>`;
  txt+=`<br/><em>↺ 仍可手動修改 · 可按「＋ 添加家庭成員」加多人</em>`;
  autoHintText.innerHTML=txt;
});
function update30Min(){
  const has30min=document.querySelector('.upgrade[data-shows-30min].is-active');
  slot30.style.display=has30min?'block':'none';
  if(!has30min){
    slot30.querySelectorAll('.hour').forEach(h=>h.classList.remove('is-active'));
  }
}
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',update30Min));
update30Min();
document.querySelectorAll('.religion button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.religion button').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
  state.religion=b.dataset.rel;renderChips();
}));
inGender.addEventListener('change',()=>{state.gender=inGender.value;renderChips();});
function renderChips(){
  const data=phrases[state.religion];
  let html='';
  if(state.gender==='M' && data.male.length){
    html+=`<div class="chip-section male"><div class="chip-section-label">男性 ♂ Male · ${state.religion}</div><div class="chip-row">`;
    data.male.forEach(p=>html+=`<button type="button" class="chip gM ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♂</span></button>`);
    html+=`</div></div>`;
  }
  if(state.gender==='F' && data.female.length){
    html+=`<div class="chip-section female"><div class="chip-section-label">女性 ♀ Female · ${state.religion}</div><div class="chip-row">`;
    data.female.forEach(p=>html+=`<button type="button" class="chip gF ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♀</span></button>`);
    html+=`</div></div>`;
  }
  html+=`<div class="chip-section neutral"><div class="chip-section-label">中性 ◆ Neutral · ${state.religion}</div><div class="chip-row">`;
  data.neutral.forEach(p=>html+=`<button type="button" class="chip gN ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">◆</span></button>`);
  html+=`</div></div>`;
  chipContainer.innerHTML=html;
  if(state.religion==='通用'){
    chipSuggested.innerHTML=state.gender==='M'?`💡 先人為男性 · 上方建議用男性詞（♂）或中性詞（◆）`:`💡 先人為女性 · 上方建議用女性詞（♀）或中性詞（◆）`;
  }else{
    chipSuggested.innerHTML=`💡 ${state.religion}輓詞通常不分男女 · 任揀`;
  }
  chipContainer.querySelectorAll('.chip[data-p]').forEach(c=>c.addEventListener('click',()=>{
    chipContainer.querySelectorAll('.chip[data-p]').forEach(x=>x.classList.remove('is-active'));
    c.classList.add('is-active');state.activePhrase=c.dataset.p;bp.textContent=c.dataset.p;
    pmPhrase.textContent=c.dataset.p;
    pmText.textContent=phraseExplain[c.dataset.p]||'（暫無解釋）';
    autoShrink();
  }));
}
renderChips();
syncBanner();
const ss1=document.getElementById('ss1'),ss2=document.getElementById('ss2'),ss3=document.getElementById('ss3');
function setStepState(el,state,label){
  el.classList.remove('is-active','is-pending','is-done');
  el.classList.add(state);
  el.querySelector('.sub-step-status').textContent=label;
}
function updateStepStatuses(){
  const has關係=!!inRel.value;
  const has先人名=!!inName.value.trim();
  const has輓詞=!!document.querySelector('.chip[data-p].is-active');
  const senders=getSenders();
  const has送花人=senders.some(s=>s.name);
  if(has關係 && has先人名){setStepState(ss1,'is-done','已完成 ✓');}
  else if(has關係 || has先人名){setStepState(ss1,'is-active','進行中');}
  else{setStepState(ss1,'is-active','進行中');}
  if(has關係 && has先人名 && has輓詞){setStepState(ss2,'is-done','已完成 ✓');}
  else if(has關係 && has先人名){setStepState(ss2,'is-active','進行中');}
  else{setStepState(ss2,'is-pending','待填');}
  if(has關係 && has先人名 && has輓詞 && has送花人){setStepState(ss3,'is-done','已完成 ✓');}
  else if(has關係 && has先人名 && has輓詞){setStepState(ss3,'is-active','進行中');}
  else{setStepState(ss3,'is-pending','待填');}
}
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('input',updateStepStatuses));
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('change',updateStepStatuses));
sendersGroup.addEventListener('input',updateStepStatuses);
sendersGroup.addEventListener('change',updateStepStatuses);
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))setTimeout(updateStepStatuses,50)});
function pulse(el){if(!el)return;el.classList.remove('bnr-pulse');void el.offsetWidth;el.classList.add('bnr-pulse');}
inName.addEventListener('input',()=>pulse(document.querySelector('.bnr-line1')));
inRel.addEventListener('change',()=>{pulse(document.querySelector('.bnr-line1'));setTimeout(()=>pulse(bpSenders),300);setTimeout(()=>pulse(document.querySelector('.bnr-suffix')),550);});
inSuffix.addEventListener('change',()=>pulse(document.querySelector('.bnr-suffix')));
sendersGroup.addEventListener('input',()=>pulse(bpSenders));
sendersGroup.addEventListener('change',()=>pulse(bpSenders));
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))pulse(bp);});
const origRelHandler=inRel.onchange;
inRel.addEventListener('change',()=>{
  if(!inRel.value||!relationMap[inRel.value])return;
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  [primaryPrefix,inSuffix].forEach(el=>{
    el.classList.remove('is-autofilled');void el.offsetWidth;el.classList.add('is-autofilled');
  });
});
updateStepStatuses();
(function setupTimeCutoff(){
  const W = document.querySelector('.basket-pdp-v2a-wrap');
  if(!W) return;
  const PREP_MIN = 150; // 2.5 hours
  const CAT_CUTOFFS = {
    '特早': 8*60,         // 8am — single slot
    '標準': 15*60+30,     // 15:30 (last 3hr window start) — category enabled if 下午 still possible
    '晚間': 19*60,        // 7pm — single slot
    '特晚': 22*60+30,     // 22:30 (last 1.5hr window start) — category enabled if 10:30 still possible
  };
  const WIN_CUTOFFS = {
    '上午': 10*60,        // 10am · 標準 window
    '中午': 12*60+30,     // 12:30 · 標準 window
    '下午': 15*60+30,     // 15:30 · 標準 window
    '9:00': 21*60,        // 9pm · 特晚 window
    '10:30': 22*60+30,    // 22:30 · 特晚 window
  };
  function parseSlotStart(txt){
    const m = txt.match(/(\d+):(\d+)/);
    if(!m) return null;
    let h = +m[1], min = +m[2];
    if(h < 8) h += 12; // assume PM if h < 8 (1:00 = 13:00)
    return h * 60 + min;
  }
  function isToday(){
    const dateRow = W.querySelector('.quick-row');
    if(!dateRow) return true;
    const active = dateRow.querySelector('.quick.is-active');
    if(!active) return true;
    return active.textContent.includes('今日');
  }
  function nowMinutes(){
    const n = new Date();
    return n.getHours()*60 + n.getMinutes();
  }
  function disableOrEnable(btn, startMin, nowM, today){
    const tooLate = today && (nowM + PREP_MIN > startMin);
    btn.classList.toggle('is-disabled', tooLate);
    if(btn.querySelector('.tl-row, .tl-fee, .tl-main, .tl-detail, .tl-hint')) return;
    const baseText = btn.dataset.baseText || btn.textContent.trim();
    if(!btn.dataset.baseText) btn.dataset.baseText = baseText;
    if(tooLate && !baseText.includes('來不及')){
      if(btn.classList.contains('quick')){
        btn.textContent = baseText + ' · 製作來不及';
      }
    }else{
      btn.textContent = baseText;
    }
  }
  function autoPickFirstAvailable(group, activeClass='is-active', disabledClass='is-disabled'){
    const all = Array.from(group.children);
    const current = all.find(b => b.classList.contains(activeClass));
    if(current && current.classList.contains(disabledClass)){
      current.classList.remove(activeClass);
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    } else if(!current){
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    }
  }
  function applyTimeCutoffs(){
    const today = isToday();
    const nowM = nowMinutes();
    W.querySelectorAll('.time-cats .time-cat').forEach(btn => {
      const cn = btn.querySelector('.cn')?.textContent.trim();
      const start = CAT_CUTOFFS[cn];
      if(start !== undefined) disableOrEnable(btn, start, nowM, today);
    });
    W.querySelectorAll('.quick-row').forEach(row => {
      const buttons = Array.from(row.querySelectorAll('.quick'));
      const firstText = buttons[0]?.textContent.trim() || '';
      const isWindowRow = ['上午','中午','下午'].some(w => firstText.startsWith(w));
      if(!isWindowRow) return;
      buttons.forEach(btn => {
        const txt = btn.textContent.trim();
        let win = null;
        Object.keys(WIN_CUTOFFS).forEach(k => { if(txt.startsWith(k)) win = k; });
        if(win) disableOrEnable(btn, WIN_CUTOFFS[win], nowM, today);
      });
      autoPickFirstAvailable(row);
    });
    W.querySelectorAll('.time-cats').forEach(g => autoPickFirstAvailable(g));
    if(today){
      const allCatDisabled = Array.from(W.querySelectorAll('.time-cats .time-cat')).every(b => b.classList.contains('is-disabled'));
      if(allCatDisabled){
        const dateRow = W.querySelector('.quick-row');
        const todayChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('今日'));
        const tmrChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('明日'));
        if(todayChip && tmrChip){
          todayChip.classList.remove('is-active');
          tmrChip.classList.add('is-active');
          setTimeout(applyTimeCutoffs, 30);
        }
      }
    }
    const slot30 = W.querySelector('#slot30');
    if(slot30 && slot30.style.display !== 'none'){
      const slots = Array.from(slot30.querySelectorAll('.hour'));
      slots.forEach(btn => {
        const start = parseSlotStart(btn.textContent);
        if(start) disableOrEnable(btn, start, nowM, today);
      });
    }
  }
  window.__tfkApplyTimeCutoffs=applyTimeCutoffs;
  applyTimeCutoffs();
  W.querySelectorAll('.quick-row .quick').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 50));
  });
  W.querySelectorAll('.time-cat, .upgrade').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 100));
  });
})();
(function(){
  const W = document.querySelector('.basket-pdp-v2a-wrap');
  if(!W) return;
  const form = document.getElementById('v2a-bouquet-form');
  if(!form) return;
  W.querySelectorAll('.size').forEach(btn => {
    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if(vid){
        const idInput = document.getElementById('v2a-variant-id');
        if(idInput) idInput.value = vid;
      }
    });
  });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    const errors = [];
    const sizeActive = W.querySelector('.size.is-active');
    if(!sizeActive) errors.push('請揀尺寸');
    const dateActive = W.querySelector('.quick-row .quick.is-active');
    if(!dateActive) errors.push('請揀送花日期');
    const timeCatActive = W.querySelector('.time-cat.is-active');
    const urgentChosen = !!W.querySelector('.upgrade[data-upgrade="urgent"].is-active');
    if(!urgentChosen && !timeCatActive) errors.push('請揀送花時段');
    let timeWinActive = null;
    if(timeCatActive){
      const winPanel = timeCatActive.querySelector('.tl-windows');
      if(winPanel){
        timeWinActive = winPanel.querySelector('.quick.is-active');
        if(!urgentChosen && !timeWinActive) errors.push('請揀送花時段內 window');
      } else {
        timeWinActive = timeCatActive;
      }
    }
    const venueName = document.getElementById('venue-name')?.value?.trim() || '';
    if(!venueName) errors.push('請填場所名稱');
    const phoneIn = W.querySelector('input[type="tel"]');
    const phone = phoneIn?.value?.trim() || '';
    if(!phone) errors.push('請填訂花人電話');
    const bnrTop = document.getElementById('banner-top-name')?.value?.trim() || '';
    if(!bnrTop) errors.push('請填賀詞上款（受款方）');
    const bnrSender = document.getElementById('banner-sender-name')?.value?.trim() || '';
    if(!bnrSender) errors.push('請填賀詞下款（送禮人）');
    const relValue = '';
    const name = '';
    const primaryPrefix = '';
    const primaryName = '';
    const relSel = null;
    const primaryRow = null;
    if(errors.length){
      showError(errors.join(' · '));
      const target = !dateActive ? W.querySelector('.quick-row')
                   : !timeWinActive ? (timeCatActive?.querySelector('.tl-windows') || timeCatActive)
                   : !venueName ? document.getElementById('venue-name')
                   : !phone ? phoneIn
                   : !relValue ? relSel
                   : !name ? document.getElementById('in-name')
                   : (!primaryPrefix || !primaryName) ? primaryRow?.querySelector('.sender-name')
                   : null;
      if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    try {
      document.getElementById('prop-date').value = dateActive.textContent.trim().replace(/ · 製作來不及/, '');
      document.getElementById('prop-time-cat').value = timeCatActive.textContent.trim();
      document.getElementById('prop-time-win').value = timeWinActive.textContent.trim().replace(/ · 製作來不及/, '');
      const time30Active = W.querySelector('.hour.is-active');
      document.getElementById('prop-time-30').value = time30Active?.textContent.trim() || '';
      const upgradeActive = W.querySelector('.upgrade.is-active');
      document.getElementById('prop-upgrade').value = upgradeActive?.querySelector('.cn')?.textContent.trim() || '';
      const venueTypeSel = W.querySelectorAll('.sub-block select.uline')[0];
      document.getElementById('prop-venue-type').value = venueTypeSel?.value || '';
      document.getElementById('prop-venue-name').value = venueName;
      const floorIn = W.querySelector('input[placeholder*="樓"]');
      document.getElementById('prop-floor').value = floorIn?.value || '';
      const hallIn = W.querySelector('input[placeholder*="A 號"]');
      document.getElementById('prop-hall').value = hallIn?.value || '';
      document.getElementById('prop-phone').value = phone;
      const params = new URLSearchParams({
        reltitle: m.title || '',
        name: name,
        hon: m.hon || '千古',
        phrase: phrase,
        senders: JSON.stringify(senders.map(s => ({prefix: applyRank(s.prefix, s.rank), name: s.name, level: prefixLevel[s.prefix] ?? 99}))),
        suffix: suffix,
      });
      document.getElementById('prop-print-url').value = location.origin + '/pages/funeral-print?' + params.toString();
    } catch(err){
      console.error('V2A property gather error:', err);
      showError('資料整理出錯：' + err.message);
      return;
    }
    const ctaBtn = form.querySelector('.cta');
    if(ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.6'; }
    const properties = {};
    form.querySelectorAll('input[name^="properties"]').forEach(inp => {
      const key = inp.name.match(/\[(.+)\]/)?.[1];
      if(key && inp.value) properties[key] = inp.value;
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        id: document.getElementById('v2a-variant-id').value,
        quantity: 1,
        properties: properties
      })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
    .then(data => {
      showSuccess();
      setTimeout(() => { location.href = '/cart'; }, 1600);
    })
    .catch(err => {
      console.error('Cart add error:', err);
      showError('加入購物車失敗：' + (err.description || err.message || '請再試一次'));
      if(ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = '1'; }
    });
  });
  function showSuccess(){
    let overlay = document.querySelector('.v2a-cart-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'v2a-cart-overlay';
      overlay.innerHTML = '<div class="v2a-cart-card"><div class="v2a-cart-check"><svg viewBox="0 0 24 24"><polyline points="4,12 10,18 20,6"/></svg></div><h3 class="v2a-cart-title">已加入購物車</h3><p class="v2a-cart-sub">Added to cart<br/>正在前往結算頁面…</p></div>';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function showError(msg){
    let bar = document.querySelector('.v2a-cart-error');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'v2a-cart-error';
      document.body.appendChild(bar);
    }
    bar.textContent = '⚠ ' + msg;
    bar.classList.add('is-visible');
    clearTimeout(bar._t);
    bar._t = setTimeout(() => bar.classList.remove('is-visible'), 5000);
  }
})();
(function(){
  const pm = document.getElementById('phrase-meaning');
  if(!pm) return;
  const wrap = pm.closest('.basket-pdp-v2a-wrap') || document;
  wrap.addEventListener('click', function(e){
    const chip = e.target.closest('.chip[data-p]');
    if(!chip) return;
    pm.classList.remove('is-flying');
    void pm.offsetWidth; // force reflow
    pm.classList.add('is-flying');
  });
})();
(function(){
  const inRel2 = document.getElementById('in-relation');
  const inSuf = document.getElementById('in-suffix');
  if(!inRel2 || !inSuf) return;
  inRel2.addEventListener('change', () => {
    setTimeout(() => {
      inSuf.classList.remove('is-autofilled');
      void inSuf.offsetWidth;
      inSuf.classList.add('is-autofilled');
    }, 50);
  });
})();
(function(){
  const W = document.querySelector('.basket-pdp-v2a-wrap');
  if(!W) return;
  W.addEventListener('click', function(e){
    const btn = e.target.closest('.time-cat, .quick, .hour');
    if(!btn) return;
    if(btn.classList.contains('is-disabled')) return;
    const parent = btn.parentElement;
    if(!parent) return;
    let peers;
    if(btn.classList.contains('time-cat')){
      peers = parent.querySelectorAll(':scope > .time-cat');
    } else if(btn.classList.contains('quick')){
      peers = parent.querySelectorAll(':scope > .quick');
    } else if(btn.classList.contains('hour')){
      peers = parent.querySelectorAll(':scope > .hour');
    }
    if(!peers) return;
    peers.forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true); // capture phase so we win over any broken listeners
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bouquet-pdp-v2a"] && !Shopify.designMode) return;
  try {
    
const relationMap = {
  '父親':{title:'父親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '母親':{title:'母親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '丈夫':{title:'夫君大人',hon:'千古',prefix:'妻',suffix:'哀輓'},
  '妻子':{title:'賢妻',hon:'千古',prefix:'夫',suffix:'哀輓'},
  '兄':{title:'胞兄大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '弟':{title:'賢弟',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '姊':{title:'胞姊大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '妹':{title:'賢妹',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '家翁':{title:'家翁大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '家姑':{title:'家姑大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '岳父':{title:'岳父大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '岳母':{title:'岳母大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '伯父':{title:'伯父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '叔父':{title:'叔父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '伯娘':{title:'伯娘',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑姐':{title:'姑媽',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑丈':{title:'姑丈',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '舅父':{title:'舅父大人',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '舅母':{title:'舅母',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨媽':{title:'姨媽',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨丈':{title:'姨丈',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '祖父':{title:'祖父大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '祖母':{title:'祖母大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '外祖父':{title:'外祖父大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '外祖母':{title:'外祖母大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '朋友男':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '朋友女':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '同事男':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '同事女':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '公司':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '教會弟兄':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '教會姊妹':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '子姪男':{title:'賢姪',hon:'千古',prefix:'',suffix:'痛輓'},
  '子姪女':{title:'賢姪女',hon:'千古',prefix:'',suffix:'痛輓'},
};
const relationGender = {
  '父親':'M','母親':'F','丈夫':'M','妻子':'F',
  '兄':'M','弟':'M','姊':'F','妹':'F',
  '家翁':'M','家姑':'F','岳父':'M','岳母':'F',
  '伯父':'M','叔父':'M','伯娘':'F','姑姐':'F','姑丈':'M',
  '舅父':'M','舅母':'F','姨媽':'F','姨丈':'M',
  '祖父':'M','祖母':'F','外祖父':'M','外祖母':'F',
  '表兄弟':'M','表姊妹':'F','姐夫':'M',
  '朋友男':'M','朋友女':'F','同事男':'M','同事女':'F',
  '公司':'M','教會弟兄':'M','教會姊妹':'F',
  '子姪男':'M','子姪女':'F',
};
const prefixLevel = {
  '妻':0,'夫':0,
  '胞兄':0,'胞弟':0,'胞姊':0,'胞妹':0,
  '孝子':1,'孝女':1,'孝媳':1,'孝婿':1,
  '姪':1,'姪女':1,'外甥':1,'外甥女':1,
  '表兄':1,'表弟':1,'表姊':1,'表妹':1,
  '孫男':2,'孫女':2,'外孫男':2,'外孫女':2,
  '孝孫':2,'孝孫女':2,'孝外孫':2,'孝外孫女':2,
  '姪孫':2,'姪孫女':2,'外甥孫':2,'外甥孫女':2,
  '表姪':2,'表姪女':2,
  '曾孫男':3,'曾孫女':3,'外曾孫男':3,'外曾孫女':3,
  '姪曾孫':3,'姪曾孫女':3,
  '玄孫男':4,'玄孫女':4,
};
const rankableSet = new Set(['孝子','孝女','孝媳','孝婿','孝孫','孝孫女','孝外孫','孝外孫女']);
function applyRank(prefix, rank){
  if(!rank||!rankableSet.has(prefix))return prefix;
  return prefix[0]+rank+prefix.slice(1);
}
function prefixGender(p){
  if(/(妻|女|媳|姊|妹|姪女|甥女|孫女|曾孫女|玄孫女|姪曾孫女|外甥孫女|姪孫女)/.test(p))return 1;
  return 0;
}
const rankOrder={'長':1,'次':2,'三':3,'四':4,'五':5,'六':6,'':7};
const phrases = {
  '通用': {
    neutral: ['永遠懷念','沈痛悼念','千古不朽','一路好走','駕鶴西歸','福壽全歸','哀思永念','風範長存'],
    male: ['典範長存','德澤永存','英名永存','浩氣長存','流芳百世','萬古流芳','英靈不泯','典型猶存'],
    female: ['母儀千古','懿範永存','慈暉永昭','音容宛在','音容宛存','寶婺光寒','慈雲歸西','慈竹風悲'],
  },
  '佛教': {
    neutral: ['蓮邦極樂','往生極樂','西方接引','倒駕慈航','早登蓮邦','同登彼岸','早歸極樂','蓮座飄香'],
    male: [],
    female: [],
  },
  '基督教': {
    neutral: ['主懷安息','蒙主恩召','安息主懷','永居天家','平安歸主','主賜安寧','永生安息','在主裡睡了'],
    male: [],
    female: [],
  },
  '天主教': {
    neutral: ['蒙主寵召','永享主光','安息天國','復活享福','永享天國','諸聖之福'],
    male: [],
    female: [],
  },
};
const phraseExplain = {
  '永遠懷念':'長存於心的思念 · 最普世的悼念詞 · 適用所有親疏關係',
  '沈痛悼念':'表達深切哀痛之意 · 適用所有關係',
  '千古不朽':'永世長存 · 永不磨滅 · 中性通用',
  '一路好走':'願先人一路平安 · 口語親切 · 中性通用',
  '駕鶴西歸':'仙鶴載歸西方 · 典雅 · 適合長者善終',
  '福壽全歸':'福分壽命圓滿 · 適合高壽善終',
  '哀思永念':'哀痛思念永遠長存',
  '風範長存':'先人風範永存後人心中',
  '典範長存':'先人風範永存 · 多用於男性長輩',
  '德澤永存':'恩德與蔭澤永遠存在 · 適合男性',
  '英名永存':'英明事跡永誌不忘 · 適合男性 / 英雄人物',
  '浩氣長存':'浩然正氣永存 · 適合公職 / 英烈男性',
  '流芳百世':'美好聲名流傳百世 · 多用於男性',
  '萬古流芳':'美名永遠流傳 · 多用於男性',
  '英靈不泯':'英魂永不磨滅 · 適合男性',
  '典型猶存':'典範樣本尚存 · 適合男性長輩',
  '母儀千古':'慈母典範永流傳 · 適合母親',
  '懿範永存':'美好德行典範永存 · 適合女性長輩',
  '慈暉永昭':'慈愛光輝永遠照耀 · 適合母親',
  '音容宛在':'容貌聲音猶如尚存 · 傳統用於女性 · 形容深切思念',
  '音容宛存':'容貌音聲尚在 · 女性異體',
  '寶婺光寒':'婺女星（女性星宿）光暗 · 形容德高女性離世',
  '慈雲歸西':'慈愛之雲歸西 · 適合女性長輩',
  '慈竹風悲':'慈母如竹 · 風中悲傷 · 適合母親',
  '蓮邦極樂':'蓮邦即西方極樂淨土',
  '往生極樂':'往生阿彌陀佛西方極樂世界',
  '西方接引':'阿彌陀佛接引往西方淨土',
  '倒駕慈航':'已脫生死返回度化眾生',
  '早登蓮邦':'早日登入極樂蓮花世界',
  '同登彼岸':'共同到達覺悟彼岸',
  '早歸極樂':'早日歸於極樂淨土',
  '蓮座飄香':'蓮花座發出芬芳',
  '主懷安息':'安睡在主懷抱',
  '蒙主恩召':'蒙主慈愛召喚回天家',
  '安息主懷':'安睡在主懷抱',
  '永居天家':'永遠居住天國家中',
  '平安歸主':'安然回歸主裡',
  '主賜安寧':'主賜予永遠安寧',
  '永生安息':'永恆生命中的安息',
  '在主裡睡了':'聖經用語 · 指逝世（哥前 15:18）',
  '蒙主寵召':'蒙主寵愛召喚回天家',
  '永享主光':'永遠享有主的榮光',
  '安息天國':'在天國中安息',
  '復活享福':'復活並享永福',
  '永享天國':'永遠享有天國之福',
  '諸聖之福':'與諸聖一同享福',
};
const banner=document.querySelector('.banner-canvas');
const bp=document.getElementById('bp-phrase');
const bpReltitle=document.getElementById('bp-reltitle'),bpName=document.getElementById('bp-name'),bpHon=document.getElementById('bp-hon');
const bpSenders=document.getElementById('bp-senders'),bpSuffix=document.getElementById('bp-suffix');
const inRel=document.getElementById('in-relation'),inName=document.getElementById('in-name'),inGender=document.getElementById('in-gender'),inSuffix=document.getElementById('in-suffix');
const sendersGroup=document.getElementById('senders-group'),addSenderBtn=document.getElementById('add-sender');
const autoHint=document.getElementById('auto-hint'),autoHintText=document.getElementById('auto-hint-text');
const chipContainer=document.getElementById('chip-container'),chipSuggested=document.getElementById('chip-suggested');
const pmPhrase=document.getElementById('pm-phrase'),pmText=document.getElementById('pm-text');
const slot30=document.getElementById('slot30');
const priceDisp=document.getElementById('price-display'),priceSize=document.getElementById('price-size');
const sumSize=document.getElementById('sum-size'),sumFlower=document.getElementById('sum-flower'),sumZone=document.getElementById('sum-zone'),sumShip=document.getElementById('sum-ship'),sumUpLabel=document.getElementById('sum-up-label'),sumUp=document.getElementById('sum-up'),sumTotal=document.getElementById('sum-total');
const zoneName=document.getElementById('zone-name'),zoneFee=document.getElementById('zone-fee'),venueName=document.getElementById('venue-name');
let _initPrice = 0, _initLabel = '—';
const _multiData = document.getElementById('tfk-variants-data');
if(_multiData){
  try {
    const _d = JSON.parse(_multiData.textContent);
    const _opt1 = document.querySelector('.opt1-grid .opt-size-btn.is-active');
    const _opt2 = document.querySelector('.opt2-grid .cv-btn.is-active');
    const _v1 = _opt1 ? _opt1.getAttribute('data-opt-value') : null;
    const _v2 = _opt2 ? _opt2.getAttribute('data-opt-value') : null;
    let _match = (_d.variants||[]).find(v => v.opt1===_v1 && v.opt2===_v2);
    if(!_match && _v1){ var _cand=(_d.variants||[]).filter(function(v){return v.opt1===_v1;}); _cand.sort(function(a,b){return a.price-b.price;}); if(_cand.length) _match=_cand[0]; }
    if(_match){ _initPrice = _match.price; _initLabel = _v1 + (_v2? ' · ' + _v2 : ''); }
  } catch(e){}
} else {
  const _activeSize=document.querySelector('.size.is-active')||document.querySelector('.size');
  _initPrice=_activeSize?parseFloat((_activeSize.dataset.price||'0').replace(/,/g,'')):0;
  _initLabel=_activeSize?(_activeSize.dataset.cn||(_activeSize.querySelector('.cn')?_activeSize.querySelector('.cn').textContent:'—')):'—';
}
const state={flower:_initPrice||0,sizeLabel:_initLabel,ship:0,shipLabel:'免費',upLabel:'—',up:0,timeFee:0,timeLabel:'',activePhrase:''}; window.__tfkState=state;
function recalc(){
  const t=state.flower+state.ship+state.up+(state.timeFee||0);
  sumSize.textContent=state.sizeLabel;sumFlower.textContent=`HK$${state.flower.toLocaleString()}`;
  sumShip.textContent=state.shipLabel;var _ad=state.up+(state.timeFee||0);sumUpLabel.textContent=[state.timeLabel,(state.upLabel&&state.upLabel!=='—')?state.upLabel:''].filter(Boolean).join(' + ')||'—';sumUp.textContent=_ad?'HK$'+_ad.toLocaleString():'—';
  sumTotal.textContent=`HK$${t.toLocaleString()}`;
}
recalc();
window.tfkRecalc=recalc;
document.querySelectorAll('.size').forEach(s=>s.addEventListener('click',()=>{
  if(s.hasAttribute('data-opt-value')) return;
  const grid=s.parentElement;
  if(grid) grid.querySelectorAll('.size').forEach(x=>x.classList.remove('is-active'));
  s.classList.add('is-active');
  const raw=(s.dataset.price||'').replace(/,/g,'');
  const p=parseFloat(raw);
  if(!isFinite(p)) return;
  state.flower=p;
  state.sizeLabel=s.dataset.cn||s.querySelector('.cn').textContent;
  priceDisp.textContent='HK$'+p.toLocaleString();priceSize.textContent=s.dataset.cn;
  const idIn=document.getElementById('v2a-variant-id');if(idIn)idIn.value=s.dataset.variantId;
  recalc();
}));
const zoneFees={1:[0,'免費','Zone 1 · 港島 + 九龍','Same-day standard'],2:[150,'HK$150','Zone 2 · 新界主區','New Territories'],3:[250,'HK$250','Zone 3 · 新界遠郊 + 離島','Outer NT / islands']};
venueName.addEventListener('change',()=>{
  const z=+venueName.options[venueName.selectedIndex].dataset.zone||1;
  const [fee,feeLabel,zname,zsub]=zoneFees[z];
  state.ship=fee;state.shipLabel=feeLabel;
  zoneName.innerHTML=zname+' <em>'+zsub+'</em>';zoneFee.textContent=feeLabel+(fee===0?' · Free':'');
  zoneFee.classList.toggle('free',fee===0);sumZone.textContent=zname;recalc();
});
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',()=>{
  if(u.classList.contains('is-active')){u.classList.remove('is-active');state.up=0;state.upLabel='—';}
  else{document.querySelectorAll('.upgrade').forEach(x=>x.classList.remove('is-active'));u.classList.add('is-active');state.up=+u.dataset.fee;state.upLabel=u.querySelector('.cn').textContent;}
  recalc();
}));
document.querySelectorAll('.quick,.time-cat,.hour').forEach(b=>b.addEventListener('click',(e)=>{
  if(b.classList.contains('is-disabled'))return;
  e.stopPropagation();
  const peers=b.parentElement.querySelectorAll(':scope > .quick, :scope > .time-cat, :scope > .hour');
  peers.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
}));
function getSenders(){
  return Array.from(sendersGroup.querySelectorAll('.sender-row')).map(row=>({
    prefix:row.querySelector('.sender-prefix').value,
    rank:row.querySelector('.sender-rank')?.value||'',
    name:row.querySelector('.sender-name').value.trim(),
  })).filter(s=>s.name||s.prefix);
}
function sortSenders(senders){
  return senders.slice().sort((a,b)=>{
    const la=prefixLevel[a.prefix]??99, lb=prefixLevel[b.prefix]??99;
    if(la!==lb)return la-lb;
    const ga=prefixGender(a.prefix),gb=prefixGender(b.prefix);
    if(ga!==gb)return ga-gb;
    return (rankOrder[a.rank]||7)-(rankOrder[b.rank]||7);
  });
}
function syncBanner(){
  const m=relationMap[inRel.value];
  bpReltitle.textContent=m?.title?m.title:'';
  bpName.textContent=inName.value||'先人名稱';
  bpHon.textContent=m?.hon||'千古';
  const rawSenders=getSenders();
  const senders=sortSenders(rawSenders);
  bpSenders.innerHTML='';
  if(senders.length===0){
    bpSenders.innerHTML=`<div class="bnr-sender"><span class="sname" style="color:var(--muted)">送花人名稱</span></div>`;
  }else{
    const firstLevel=prefixLevel[senders[0].prefix]??99;
    senders.forEach((s,idx)=>{
      const div=document.createElement('div');
      div.className='bnr-sender';
      const displayPrefix=applyRank(s.prefix,s.rank);
      const senderLevel=prefixLevel[s.prefix]??99;
      const rate=(idx>0&&senderLevel!==firstLevel)?`<span class="srate">率</span>`:'';
      const px=displayPrefix?`<span class="sprefix">${displayPrefix}</span>`:'';
      const nm=`<span class="sname">${s.name||'（未填名稱）'}</span>`;
      div.innerHTML=rate+px+nm;
      bpSenders.appendChild(div);
    });
  }
  bpSuffix.textContent=inSuffix.value;
  autoShrink();
}
function autoShrink(){
  const senderCount=Math.max(1,getSenders().length);
  let scale=1;
  if(senderCount>=5)scale=.62;
  else if(senderCount===4)scale=.72;
  else if(senderCount===3)scale=.82;
  else if(senderCount===2)scale=.92;
  const suffixLen=bpSuffix.textContent.length;
  let l4Scale=scale;
  if(suffixLen>=4)l4Scale*=.92;
  const L1_MAX=15;
  banner.style.setProperty('--l1',`${L1_MAX}cqw`);
  banner.style.setProperty('--l2',`${17*scale}cqw`);
  banner.style.setProperty('--l3',`${8*scale}cqw`);
  banner.style.setProperty('--l4',`${6*l4Scale}cqw`);
  banner.style.setProperty('--gap',`${2.5*scale}cqw`);
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    const cw=banner.clientWidth;
    if(cw<10)return;
    const availW=cw*0.84; // 84% safety margin
    const l1El=document.querySelector('.bnr-line1');
    const l2El=bp;
    const l3Els=Array.from(bpSenders.querySelectorAll('.bnr-sender'));
    const l4El=bpSuffix;
    let lo=3,hi=L1_MAX,best=3;
    for(let i=0;i<10;i++){
      const mid=(lo+hi)/2;
      banner.style.setProperty('--l1',`${mid}cqw`);
      void l1El.offsetWidth; // force reflow
      if(l1El.scrollWidth<=availW){best=mid;lo=mid;}
      else{hi=mid;}
    }
    banner.style.setProperty('--l1',`${best}cqw`);
    let furtherL2=1,furtherL3=1,furtherL4=1;
    if(l2El.scrollWidth>availW)furtherL2=Math.max(.55,availW/l2El.scrollWidth);
    l3Els.forEach(e=>{if(e.scrollWidth>availW){furtherL3=Math.min(furtherL3,Math.max(.55,availW/e.scrollWidth));}});
    if(l4El.scrollWidth>availW)furtherL4=Math.max(.55,availW/l4El.scrollWidth);
    if(furtherL2<1)banner.style.setProperty('--l2',`${17*scale*furtherL2}cqw`);
    if(furtherL3<1)banner.style.setProperty('--l3',`${8*scale*furtherL3}cqw`);
    if(furtherL4<1)banner.style.setProperty('--l4',`${6*l4Scale*furtherL4}cqw`);
    const overflowReduced=Math.min(furtherL2,furtherL3,furtherL4);
    updateShrinkBadge(scale,overflowReduced);
  }));
  function updateShrinkBadge(senderScale,overflowScale){
    const tag=document.querySelector('.preview-foot .shrink-tag');
    const totalScale=senderScale*overflowScale;
    if(totalScale<.99){
      let label=`Auto-shrink ${Math.round(totalScale*100)}%`;
      if(overflowScale<.99 && senderScale<.99)label+=' (多人+名長)';
      else if(overflowScale<.99)label+=' (字過長)';
      else label+=` (${getSenders().length} 位送花人)`;
      if(!tag){
        const t=document.createElement('span');t.className='shrink-tag';t.textContent=label;
        document.querySelector('.preview-foot').appendChild(t);
      }else{tag.textContent=label;}
    }else if(tag){tag.remove();}
  }
}
inName.addEventListener('input',syncBanner);
inSuffix.addEventListener('change',syncBanner);
sendersGroup.addEventListener('input',syncBanner);
sendersGroup.addEventListener('change',syncBanner);
const relSenderCats = {
  '父親':['子女輩','孫輩','曾孫 / 玄孫'],
  '母親':['子女輩','孫輩','曾孫 / 玄孫'],
  '家翁':['子女輩','孫輩'],
  '家姑':['子女輩','孫輩'],
  '岳父':['子女輩','孫輩'],
  '岳母':['子女輩','孫輩'],
  '丈夫':['子女輩','孫輩'],
  '妻子':['子女輩','孫輩'],
  '兄':['兄弟姊妹','父系姪輩'],
  '弟':['兄弟姊妹','父系姪輩'],
  '姊':['兄弟姊妹','父系姪輩'],
  '妹':['兄弟姊妹','父系姪輩'],
  '伯父':['父系姪輩'],
  '叔父':['父系姪輩'],
  '伯娘':['父系姪輩'],
  '姑姐':['父系姪輩'],
  '姑丈':['父系姪輩'],
  '舅父':['母系外甥輩'],
  '舅母':['母系外甥輩'],
  '姨媽':['母系外甥輩'],
  '姨丈':['母系外甥輩'],
  '祖父':['孫輩','曾孫 / 玄孫'],
  '祖母':['孫輩','曾孫 / 玄孫'],
  '外祖父':['孫輩','曾孫 / 玄孫'],
  '外祖母':['孫輩','曾孫 / 玄孫'],
  '表兄弟':['表親'],
  '表姊妹':['表親'],
  '姐夫':['表親'],
  '朋友男':[],
  '朋友女':[],
  '同事男':[],
  '同事女':[],
  '公司':[],
  '教會弟兄':[],
  '教會姊妹':[],
  '子姪男':[],
  '子姪女':[],
};
function buildPrefixSelectHTML(relation, includeBlank=true){
  const allowedCats=relSenderCats[relation];
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  let html='';
  if(includeBlank){
    html+=`<option value="">（無前綴）</option>`;
    html+=`<option value="（不指定排行）">（不指定排行）</option>`;
  }
  if(!relation||!allowedCats||allowedCats.length===0){
    return primary.innerHTML; // fall back to primary's full list
  }
  const fullOpts=primary.querySelectorAll('optgroup');
  fullOpts.forEach(og=>{
    if(allowedCats.includes(og.label)){
      html+=`<optgroup label="${og.label}">`;
      og.querySelectorAll('option').forEach(o=>html+=`<option value="${o.value}">${o.textContent}</option>`);
      html+=`</optgroup>`;
    }
  });
  return html;
}
const rankOptsHTML=`<option value="">不指定</option><option value="長">長</option><option value="次">次</option><option value="三">三</option><option value="四">四</option><option value="五">五</option><option value="六">六</option>`;
function addSenderRow(prefix='',name='',rank=''){
  const row=document.createElement('div');
  row.className='sender-row';
  const opts=buildPrefixSelectHTML(inRel.value,true);
  row.innerHTML=`
    <div>
      <span class="sender-row-label">前綴</span>
      <select class="uline sender-prefix">${opts}</select>
    </div>
    <div>
      <span class="sender-row-label">排行</span>
      <select class="uline sender-rank">${rankOptsHTML}</select>
    </div>
    <div>
      <span class="sender-row-label">姓名 / 公司</span>
      <input class="uline sender-name" placeholder="例：陳小明" />
    </div>
    <button class="remove" type="button">×</button>
  `;
  sendersGroup.appendChild(row);
  if(prefix)row.querySelector('.sender-prefix').value=prefix;
  if(rank)row.querySelector('.sender-rank').value=rank;
  if(name)row.querySelector('.sender-name').value=name;
  row.querySelector('.remove').addEventListener('click',()=>{row.remove();syncBanner();updateAddSenderHint();});
  updateRowRankAvailability(row);
  syncBanner();
  updateAddSenderHint();
}
function updateRowRankAvailability(row){
  const sel=row.querySelector('.sender-prefix');
  const rank=row.querySelector('.sender-rank');
  if(!rank)return;
  if(!rankableSet.has(sel.value)){
    rank.value='';
    rank.classList.add('is-disabled');
    rank.title='此前綴不支持排行（長/次/三...）';
  }else{
    rank.classList.remove('is-disabled');
    rank.title='';
  }
}
sendersGroup.addEventListener('change',e=>{
  if(e.target.classList.contains('sender-prefix')){
    updateRowRankAvailability(e.target.closest('.sender-row'));
  }
});
addSenderBtn.addEventListener('click',()=>addSenderRow());
sendersGroup.querySelector('.sender-row.primary .remove').addEventListener('click',()=>{});
function updateAddSenderHint(){
  const v=inRel.value;
  let oldHint=document.getElementById('add-sender-hint');
  if(oldHint)oldHint.remove();
  if(!v)return;
  const cats=relSenderCats[v]||[];
  const senderCount=getSenders().length;
  let msg='',color='var(--muted)';
  if(v==='丈夫'||v==='妻子'){
    msg=`💡 夫妻互送一般係 1 位送花人（${v==='丈夫'?'妻':'夫'}）獨送 · 若子女合送可加多人`;
    color='var(--gold-deep)';
  }else if(cats.length===0){
    msg=`💡 朋友 / 同事 / 公司一般唔需要送花人前綴 · 直接輸入姓名 / 公司名`;
    color='var(--gold-deep)';
  }else{
    msg=`💡 揀「${inRel.options[inRel.selectedIndex].text}」· 可加 ${cats.join(' / ')} 嘅親屬合送`;
  }
  const hint=document.createElement('div');hint.id='add-sender-hint';
  hint.style.cssText=`font-family:var(--cjk);font-size:12px;color:${color};letter-spacing:.06em;margin-top:8px;padding:8px 12px;background:rgba(184,153,104,.08);border-left:2px solid var(--gold);line-height:1.6`;
  hint.textContent=msg;
  addSenderBtn.insertAdjacentElement('afterend',hint);
}
function syncAllPrefixLists(){
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  const primaryVal=primary.value;
  Array.from(sendersGroup.querySelectorAll('.sender-row')).forEach((row,i)=>{
    if(i===0)return; // primary
    const sel=row.querySelector('.sender-prefix');
    const oldVal=sel.value;
    sel.innerHTML=buildPrefixSelectHTML(inRel.value,true);
    sel.value=oldVal;
  });
}
inRel.addEventListener('change',()=>{syncAllPrefixLists();updateAddSenderHint();});
inRel.addEventListener('change',()=>{
  const v=inRel.value;
  if(v && relationGender[v]){
    const g=relationGender[v];
    document.getElementById('in-gender').value=g;
    state.gender=g;
    const dg=document.getElementById('derived-gender');
    if(dg){
      const gLabel=g==='M'?'男 ♂':'女 ♀';
      dg.textContent=gLabel+'（由關係推導）';
      dg.style.color=g==='M'?'var(--male)':'var(--female)';
      dg.style.borderColor=g==='M'?'var(--male)':'var(--female)';
    }
    renderChips();
  }
  if(!v||!relationMap[v]){autoHint.style.display='none';syncBanner();return;}
  const m=relationMap[v];
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  primaryPrefix.value=m.prefix||'';
  inSuffix.value=m.suffix;
  updateRowRankAvailability(sendersGroup.querySelector('.sender-row.primary'));
  syncBanner();
  autoHint.style.display='block';
  let txt=`揀「${inRel.options[inRel.selectedIndex].text}」 → 已自動填：<br/>`;
  if(m.title)txt+=`• 上聯稱謂：<span class="tag">${m.title}</span> + 先人名 + 敬稱 <span class="tag">${m.hon}</span><br/>`;
  else txt+=`• 上聯：（先人名）+ 敬稱 <span class="tag">${m.hon}</span><br/>`;
  if(m.prefix)txt+=`• 主送花人前綴：<span class="tag">${m.prefix}</span>`;
  if(m.altPrefix)txt+=` <em>· 若送花人為女性可改用「${m.altPrefix}」</em>`;
  txt+=`<br/>• 下款後綴：<span class="tag">${m.suffix}</span>`;
  txt+=`<br/><em>↺ 仍可手動修改 · 可按「＋ 添加家庭成員」加多人</em>`;
  autoHintText.innerHTML=txt;
});
function update30Min(){
  const has30min=document.querySelector('.upgrade[data-shows-30min].is-active');
  slot30.style.display=has30min?'block':'none';
  if(!has30min){
    slot30.querySelectorAll('.hour').forEach(h=>h.classList.remove('is-active'));
  }
}
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',update30Min));
update30Min();
function updateUrgentNote(){var u=document.querySelector('.upgrade[data-upgrade="urgent"].is-active');var n=document.getElementById('urgent-note');if(n)n.style.display=u?'block':'none';}
setInterval(updateUrgentNote,400);updateUrgentNote();
document.querySelectorAll('.religion button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.religion button').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
  state.religion=b.dataset.rel;renderChips();
}));
inGender.addEventListener('change',()=>{state.gender=inGender.value;renderChips();});
function renderChips(){
  const data=phrases[state.religion];
  let html='';
  if(state.gender==='M' && data.male.length){
    html+=`<div class="chip-section male"><div class="chip-section-label">男性 ♂ Male · ${state.religion}</div><div class="chip-row">`;
    data.male.forEach(p=>html+=`<button type="button" class="chip gM ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♂</span></button>`);
    html+=`</div></div>`;
  }
  if(state.gender==='F' && data.female.length){
    html+=`<div class="chip-section female"><div class="chip-section-label">女性 ♀ Female · ${state.religion}</div><div class="chip-row">`;
    data.female.forEach(p=>html+=`<button type="button" class="chip gF ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♀</span></button>`);
    html+=`</div></div>`;
  }
  html+=`<div class="chip-section neutral"><div class="chip-section-label">中性 ◆ Neutral · ${state.religion}</div><div class="chip-row">`;
  data.neutral.forEach(p=>html+=`<button type="button" class="chip gN ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">◆</span></button>`);
  html+=`</div></div>`;
  chipContainer.innerHTML=html;
  if(state.religion==='通用'){
    chipSuggested.innerHTML=state.gender==='M'?`💡 先人為男性 · 上方建議用男性詞（♂）或中性詞（◆）`:`💡 先人為女性 · 上方建議用女性詞（♀）或中性詞（◆）`;
  }else{
    chipSuggested.innerHTML=`💡 ${state.religion}輓詞通常不分男女 · 任揀`;
  }
  chipContainer.querySelectorAll('.chip[data-p]').forEach(c=>c.addEventListener('click',()=>{
    chipContainer.querySelectorAll('.chip[data-p]').forEach(x=>x.classList.remove('is-active'));
    c.classList.add('is-active');state.activePhrase=c.dataset.p;bp.textContent=c.dataset.p;
    pmPhrase.textContent=c.dataset.p;
    pmText.textContent=phraseExplain[c.dataset.p]||'（暫無解釋）';
    autoShrink();
  }));
}
renderChips();
syncBanner();
const ss1=document.getElementById('ss1'),ss2=document.getElementById('ss2'),ss3=document.getElementById('ss3');
function setStepState(el,state,label){
  el.classList.remove('is-active','is-pending','is-done');
  el.classList.add(state);
  el.querySelector('.sub-step-status').textContent=label;
}
function updateStepStatuses(){
  const has關係=!!inRel.value;
  const has先人名=!!inName.value.trim();
  const has輓詞=!!document.querySelector('.chip[data-p].is-active');
  const senders=getSenders();
  const has送花人=senders.some(s=>s.name);
  if(has關係 && has先人名){setStepState(ss1,'is-done','已完成 ✓');}
  else if(has關係 || has先人名){setStepState(ss1,'is-active','進行中');}
  else{setStepState(ss1,'is-active','進行中');}
  if(has關係 && has先人名 && has輓詞){setStepState(ss2,'is-done','已完成 ✓');}
  else if(has關係 && has先人名){setStepState(ss2,'is-active','進行中');}
  else{setStepState(ss2,'is-pending','待填');}
  if(has關係 && has先人名 && has輓詞 && has送花人){setStepState(ss3,'is-done','已完成 ✓');}
  else if(has關係 && has先人名 && has輓詞){setStepState(ss3,'is-active','進行中');}
  else{setStepState(ss3,'is-pending','待填');}
}
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('input',updateStepStatuses));
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('change',updateStepStatuses));
sendersGroup.addEventListener('input',updateStepStatuses);
sendersGroup.addEventListener('change',updateStepStatuses);
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))setTimeout(updateStepStatuses,50)});
function pulse(el){if(!el)return;el.classList.remove('bnr-pulse');void el.offsetWidth;el.classList.add('bnr-pulse');}
inName.addEventListener('input',()=>pulse(document.querySelector('.bnr-line1')));
inRel.addEventListener('change',()=>{pulse(document.querySelector('.bnr-line1'));setTimeout(()=>pulse(bpSenders),300);setTimeout(()=>pulse(document.querySelector('.bnr-suffix')),550);});
inSuffix.addEventListener('change',()=>pulse(document.querySelector('.bnr-suffix')));
sendersGroup.addEventListener('input',()=>pulse(bpSenders));
sendersGroup.addEventListener('change',()=>pulse(bpSenders));
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))pulse(bp);});
const origRelHandler=inRel.onchange;
inRel.addEventListener('change',()=>{
  if(!inRel.value||!relationMap[inRel.value])return;
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  [primaryPrefix,inSuffix].forEach(el=>{
    el.classList.remove('is-autofilled');void el.offsetWidth;el.classList.add('is-autofilled');
  });
});
updateStepStatuses();
(function setupTimeCutoff(){
  const W = document.querySelector('.bouquet-pdp-v2a-wrap');
  if(!W) return;
  const PREP_MIN = 150; // 2.5 hours
  const CAT_CUTOFFS = {
    '早晨': 10*60,        // 8-10am · 送到 10am 為止 (key 對返實際 .cn 名)
    '日間': 18*60,        // 10am-6pm 免費 · 送到 6pm 為止
    '晚間': 21*60,        // 6-9pm · 送到 9pm 為止
    '特晚': 23*60,        // 9-11pm · 送到 11pm 為止
  };
  const WIN_CUTOFFS = {
    '上午': 12*60+30,     // 10-12:30 · 送到 12:30
    '中午': 15*60+30,     // 12:30-15:30 · 送到 15:30
    '下午': 18*60,        // 15:30-18:00 · 送到 18:00
    '9:00': 22*60,        // 9-10pm
    '10:30': 23*60,       // 10-11pm
  };
  function parseSlotStart(txt){
    const m = txt.match(/(\d+):(\d+)/);
    if(!m) return null;
    let h = +m[1], min = +m[2];
    if(h < 8) h += 12; // assume PM if h < 8 (1:00 = 13:00)
    return h * 60 + min;
  }
  function isToday(){
    const dateRow = W.querySelector('.quick-row');
    if(!dateRow) return true;
    const active = dateRow.querySelector('.quick.is-active');
    if(!active) return true;
    return active.textContent.includes('今日');
  }
  function nowMinutes(){
    const n = new Date();
    return n.getHours()*60 + n.getMinutes();
  }
  function disableOrEnable(btn, startMin, nowM, today){
    const tooLate = today && (nowM + PREP_MIN > startMin);
    btn.classList.toggle('is-disabled', tooLate);
    if(btn.querySelector('.tl-row, .tl-fee, .tl-main, .tl-detail, .tl-hint')) return;
    const baseText = btn.dataset.baseText || btn.textContent.trim();
    if(!btn.dataset.baseText) btn.dataset.baseText = baseText;
    if(tooLate && !baseText.includes('來不及')){
      if(btn.classList.contains('quick')){
        btn.textContent = baseText + ' · 製作來不及';
      }
    }else{
      btn.textContent = baseText;
    }
  }
  function autoPickFirstAvailable(group, activeClass='is-active', disabledClass='is-disabled'){
    const all = Array.from(group.children);
    const current = all.find(b => b.classList.contains(activeClass));
    if(current && current.classList.contains(disabledClass)){
      current.classList.remove(activeClass);
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    } else if(!current){
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    }
  }
  function applyTimeCutoffs(){
    const today = isToday();
    const nowM = nowMinutes();
    W.querySelectorAll('.time-cats .time-cat').forEach(btn => {
      const cn = btn.querySelector('.cn')?.textContent.trim();
      const start = CAT_CUTOFFS[cn];
      if(start !== undefined) disableOrEnable(btn, start, nowM, today);
    });
    W.querySelectorAll('.quick-row').forEach(row => {
      const buttons = Array.from(row.querySelectorAll('.quick'));
      const firstText = buttons[0]?.textContent.trim() || '';
      const isWindowRow = ['上午','中午','下午'].some(w => firstText.startsWith(w));
      if(!isWindowRow) return;
      buttons.forEach(btn => {
        const txt = btn.textContent.trim();
        let win = null;
        Object.keys(WIN_CUTOFFS).forEach(k => { if(txt.startsWith(k)) win = k; });
        if(win) disableOrEnable(btn, WIN_CUTOFFS[win], nowM, today);
      });
      autoPickFirstAvailable(row);
    });
    W.querySelectorAll('.time-cats').forEach(g => autoPickFirstAvailable(g));
    if(today){
      const allCatDisabled = Array.from(W.querySelectorAll('.time-cats .time-cat')).every(b => b.classList.contains('is-disabled'));
      if(allCatDisabled){
        const dateRow = W.querySelector('.quick-row');
        const todayChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('今日'));
        const tmrChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('明日'));
        if(todayChip && tmrChip){
          todayChip.classList.remove('is-active');
          tmrChip.classList.add('is-active');
          setTimeout(applyTimeCutoffs, 30);
        }
      }
    }
    const slot30 = W.querySelector('#slot30');
    if(slot30 && slot30.style.display !== 'none'){
      const slots = Array.from(slot30.querySelectorAll('.hour'));
      slots.forEach(btn => {
        const start = parseSlotStart(btn.textContent);
        if(start) disableOrEnable(btn, start, nowM, today);
      });
    }
  }
  applyTimeCutoffs();
  W.querySelectorAll('.quick-row .quick').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 50));
  });
  W.querySelectorAll('.time-cat, .upgrade').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 100));
  });
})();
(function(){
  const W = document.querySelector('.bouquet-pdp-v2a-wrap');
  if(!W) return;
  const form = document.getElementById('v2a-bouquet-form');
  if(!form) return;
  W.querySelectorAll('.size').forEach(btn => {
    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if(vid){
        const idInput = document.getElementById('v2a-variant-id');
        if(idInput) idInput.value = vid;
      }
    });
  });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    const errors = [];
    const sizeActive = W.querySelector('.size.is-active');
    if(!sizeActive) errors.push('請揀尺寸');
    const dateActive = W.querySelector('.quick-row .quick.is-active');
    if(!dateActive) errors.push('請揀送花日期');
    const timeCatActive = W.querySelector('.time-cat.is-active');
    const urgentActive = W.querySelector('.upgrade[data-upgrade="urgent"].is-active');
    if(!timeCatActive && !urgentActive) errors.push('請揀送花時段');
    let timeWinActive = null;
    if(timeCatActive){
      const winPanel = timeCatActive.querySelector('.tl-windows');
      if(winPanel){
        timeWinActive = winPanel.querySelector('.quick.is-active');
        if(!timeWinActive) errors.push('請揀送花時段內 window');
      } else {
        timeWinActive = timeCatActive;
      }
    }
    const venueName = document.getElementById('venue-name')?.value?.trim() || '';
    if(!venueName) errors.push('請填場所名稱');
    const phoneIn = W.querySelector('input[type="tel"]');
    const phone = phoneIn?.value?.trim() || '';
    if(!phone) errors.push('請填訂花人電話');
    const relSel = document.getElementById('in-relation');
    const relValue = relSel?.value || '';
    if(!relValue) errors.push('請揀與先人關係');
    const name = document.getElementById('in-name')?.value?.trim() || '';
    if(!name) errors.push('請填先人名稱');
    const primaryRow = W.querySelector('.sender-row.primary') || W.querySelector('.sender-row');
    const primaryPrefix = primaryRow?.querySelector('.sender-prefix')?.value || '';
    const primaryName = primaryRow?.querySelector('.sender-name')?.value?.trim() || '';
    if(!primaryPrefix || !primaryName) errors.push('請填送花人（關係 + 姓名）');
    if(errors.length){
      showError(errors.join(' · '));
      const target = !dateActive ? W.querySelector('.quick-row')
                   : (!timeWinActive && !urgentActive) ? (timeCatActive?.querySelector('.tl-windows') || timeCatActive)
                   : !venueName ? document.getElementById('venue-name')
                   : !phone ? phoneIn
                   : !relValue ? relSel
                   : !name ? document.getElementById('in-name')
                   : (!primaryPrefix || !primaryName) ? primaryRow?.querySelector('.sender-name')
                   : null;
      if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    try {
      const relText = relSel.options[relSel.selectedIndex]?.text || '';
      document.getElementById('prop-relation').value = relText;
      const m = relationMap[relValue] || {};
      const upperLine = ((m.title ? m.title + ' ' : '') + name + ' ' + (m.hon || '千古')).trim();
      document.getElementById('prop-upper').value = upperLine;
      const phraseEl = document.querySelector('.chip[data-p].is-active');
      const phrase = phraseEl?.dataset.p || '永遠懷念';
      document.getElementById('prop-phrase').value = phrase;
      const senders = (typeof getSenders === 'function') ? sortSenders(getSenders()) : [];
      const firstLevel = senders.length ? (prefixLevel[senders[0].prefix] ?? 99) : 99;
      const senderLines = senders.map((s, idx) => {
        const dispP = (typeof applyRank === 'function') ? applyRank(s.prefix, s.rank) : s.prefix;
        const senderLevel = prefixLevel[s.prefix] ?? 99;
        const rate = (idx > 0 && senderLevel !== firstLevel) ? '率 ' : '';
        return (rate + dispP + ' ' + s.name).trim();
      });
      document.getElementById('prop-lower').value = senderLines.join(' · ');
      const suffix = document.getElementById('in-suffix')?.value || '敬輓';
      document.getElementById('prop-suffix-prop').value = suffix;
      document.getElementById('prop-date').value = dateActive.textContent.trim().replace(/ · 製作來不及/, '');
      document.getElementById('prop-time-cat').value = timeCatActive ? timeCatActive.textContent.trim() : '加急 · 即時製作派送';
      document.getElementById('prop-time-win').value = timeWinActive ? timeWinActive.textContent.trim().replace(/ · 製作來不及/, '') : '';
      const time30Active = W.querySelector('.hour.is-active');
      document.getElementById('prop-time-30').value = time30Active?.textContent.trim() || '';
      const upgradeActive = W.querySelector('.upgrade.is-active');
      document.getElementById('prop-upgrade').value = upgradeActive?.querySelector('.cn')?.textContent.trim() || '';
      const venueTypeSel = W.querySelectorAll('.sub-block select.uline')[0];
      document.getElementById('prop-venue-type').value = venueTypeSel?.value || '';
      document.getElementById('prop-venue-name').value = venueName;
      const floorIn = W.querySelector('input[placeholder*="樓"]');
      document.getElementById('prop-floor').value = floorIn?.value || '';
      const hallIn = W.querySelector('input[placeholder*="A 號"]');
      document.getElementById('prop-hall').value = hallIn?.value || '';
      document.getElementById('prop-phone').value = phone;
      const params = new URLSearchParams({
        reltitle: m.title || '',
        name: name,
        hon: m.hon || '千古',
        phrase: phrase,
        senders: JSON.stringify(senders.map(s => ({prefix: applyRank(s.prefix, s.rank), name: s.name, level: prefixLevel[s.prefix] ?? 99}))),
        suffix: suffix,
      });
      document.getElementById('prop-print-url').value = location.origin + '/pages/funeral-print?' + params.toString();
    } catch(err){
      console.error('V2A property gather error:', err);
      showError('資料整理出錯：' + err.message);
      return;
    }
    const ctaBtn = form.querySelector('.cta');
    if(ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.6'; }
    const properties = {};
    form.querySelectorAll('input[name^="properties"]').forEach(inp => {
      const key = inp.name.match(/\[(.+)\]/)?.[1];
      if(key && inp.value) properties[key] = inp.value;
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        id: document.getElementById('v2a-variant-id').value,
        quantity: 1,
        properties: properties
      })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
    .then(data => {
      showSuccess();
      setTimeout(() => { location.href = '/cart'; }, 1600);
    })
    .catch(err => {
      console.error('Cart add error:', err);
      showError('加入購物車失敗：' + (err.description || err.message || '請再試一次'));
      if(ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = '1'; }
    });
  });
  function showSuccess(){
    let overlay = document.querySelector('.v2a-cart-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'v2a-cart-overlay';
      overlay.innerHTML = '<div class="v2a-cart-card"><div class="v2a-cart-check"><svg viewBox="0 0 24 24"><polyline points="4,12 10,18 20,6"/></svg></div><h3 class="v2a-cart-title">已加入購物車</h3><p class="v2a-cart-sub">Added to cart<br/>正在前往結算頁面…</p></div>';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function showError(msg){
    let bar = document.querySelector('.v2a-cart-error');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'v2a-cart-error';
      document.body.appendChild(bar);
    }
    bar.textContent = '⚠ ' + msg;
    bar.classList.add('is-visible');
    clearTimeout(bar._t);
    bar._t = setTimeout(() => bar.classList.remove('is-visible'), 5000);
  }
})();
(function(){
  const pm = document.getElementById('phrase-meaning');
  if(!pm) return;
  const wrap = pm.closest('.bouquet-pdp-v2a-wrap') || document;
  wrap.addEventListener('click', function(e){
    const chip = e.target.closest('.chip[data-p]');
    if(!chip) return;
    pm.classList.remove('is-flying');
    void pm.offsetWidth; // force reflow
    pm.classList.add('is-flying');
  });
})();
(function(){
  const inRel2 = document.getElementById('in-relation');
  const inSuf = document.getElementById('in-suffix');
  if(!inRel2 || !inSuf) return;
  inRel2.addEventListener('change', () => {
    setTimeout(() => {
      inSuf.classList.remove('is-autofilled');
      void inSuf.offsetWidth;
      inSuf.classList.add('is-autofilled');
    }, 50);
  });
})();
(function(){
  const W = document.querySelector('.bouquet-pdp-v2a-wrap');
  if(!W) return;
  W.addEventListener('click', function(e){
    const btn = e.target.closest('.time-cat, .quick, .hour');
    if(!btn) return;
    if(btn.classList.contains('is-disabled')) return;
    const parent = btn.parentElement;
    if(!parent) return;
    let peers;
    if(btn.classList.contains('time-cat')){
      peers = parent.querySelectorAll(':scope > .time-cat');
    } else if(btn.classList.contains('quick')){
      peers = parent.querySelectorAll(':scope > .quick');
    } else if(btn.classList.contains('hour')){
      peers = parent.querySelectorAll(':scope > .hour');
    }
    if(!peers) return;
    peers.forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true); // capture phase so we win over any broken listeners
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funeral-pdp-v2a"] && !Shopify.designMode) return;
  try {
    
// ─── RELATION MAP (上聯稱謂 + 敬稱 + 下款前綴 + 後綴) ───
const relationMap = {
  '父親':{title:'父親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '母親':{title:'母親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '丈夫':{title:'夫君大人',hon:'千古',prefix:'妻',suffix:'哀輓'},
  '妻子':{title:'賢妻',hon:'千古',prefix:'夫',suffix:'哀輓'},
  '兄':{title:'胞兄大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '弟':{title:'賢弟',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '姊':{title:'胞姊大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '妹':{title:'賢妹',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '家翁':{title:'家翁大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '家姑':{title:'家姑大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '岳父':{title:'岳父大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '岳母':{title:'岳母大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '伯父':{title:'伯父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '叔父':{title:'叔父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '伯娘':{title:'伯娘',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑姐':{title:'姑媽',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑丈':{title:'姑丈',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '舅父':{title:'舅父大人',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '舅母':{title:'舅母',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨媽':{title:'姨媽',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨丈':{title:'姨丈',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '祖父':{title:'祖父大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '祖母':{title:'祖母大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '外祖父':{title:'外祖父大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '外祖母':{title:'外祖母大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '朋友男':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '朋友女':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '同事男':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '同事女':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '公司':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '教會弟兄':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '教會姊妹':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '子姪男':{title:'賢姪',hon:'千古',prefix:'',suffix:'痛輓'},
  '子姪女':{title:'賢姪女',hon:'千古',prefix:'',suffix:'痛輓'},
};

// ─── RELATION → 先人 GENDER (auto-derived · no need to ask) ───
const relationGender = {
  '父親':'M','母親':'F','丈夫':'M','妻子':'F',
  '兄':'M','弟':'M','姊':'F','妹':'F',
  '家翁':'M','家姑':'F','岳父':'M','岳母':'F',
  '伯父':'M','叔父':'M','伯娘':'F','姑姐':'F','姑丈':'M',
  '舅父':'M','舅母':'F','姨媽':'F','姨丈':'M',
  '祖父':'M','祖母':'F','外祖父':'M','外祖母':'F',
  '表兄弟':'M','表姊妹':'F','姐夫':'M',
  '朋友男':'M','朋友女':'F','同事男':'M','同事女':'F',
  '公司':'M','教會弟兄':'M','教會姊妹':'F',
  '子姪男':'M','子姪女':'F',
};

// ─── PREFIX 輩分 LEVEL (for 率字 conditional + sort) ───
// 0 = 同輩 / 配偶 · 1 = 子女 / 姪 / 外甥 / 表 · 2 = 孫 · 3 = 曾孫 · 4 = 玄孫
const prefixLevel = {
  '妻':0,'夫':0,
  '胞兄':0,'胞弟':0,'胞姊':0,'胞妹':0,
  '孝子':1,'孝女':1,'孝媳':1,'孝婿':1,
  '姪':1,'姪女':1,'外甥':1,'外甥女':1,
  '表兄':1,'表弟':1,'表姊':1,'表妹':1,
  '孫男':2,'孫女':2,'外孫男':2,'外孫女':2,
  '孝孫':2,'孝孫女':2,'孝外孫':2,'孝外孫女':2,
  '姪孫':2,'姪孫女':2,'外甥孫':2,'外甥孫女':2,
  '表姪':2,'表姪女':2,
  '曾孫男':3,'曾孫女':3,'外曾孫男':3,'外曾孫女':3,
  '姪曾孫':3,'姪曾孫女':3,
  '玄孫男':4,'玄孫女':4,
};

// ─── PREFIXES 支持排行 (Rank splice insertion · 孝子 + 長 → 孝長子) ───
const rankableSet = new Set(['孝子','孝女','孝媳','孝婿','孝孫','孝孫女','孝外孫','孝外孫女']);
function applyRank(prefix, rank){
  if(!rank||!rankableSet.has(prefix))return prefix;
  // 「孝子」(2 chars) → 孝[rank]子 ; 「孝孫女」(3 chars) → 孝[rank]孫女
  return prefix[0]+rank+prefix.slice(1);
}

// ─── GENDER from prefix (for sort: 男先女後) ───
function prefixGender(p){
  if(/(妻|女|媳|姊|妹|姪女|甥女|孫女|曾孫女|玄孫女|姪曾孫女|外甥孫女|姪孫女)/.test(p))return 1;
  return 0;
}
const rankOrder={'長':1,'次':2,'三':3,'四':4,'五':5,'六':6,'':7};

// ─── PHRASE DATA · BY RELIGION + GENDER (re-categorized per HK funeral tradition) ───
const phrases = {
  '通用': {
    neutral: ['永遠懷念','沈痛悼念','千古不朽','一路好走','駕鶴西歸','福壽全歸','哀思永念','風範長存'],
    male: ['典範長存','德澤永存','英名永存','浩氣長存','流芳百世','萬古流芳','英靈不泯','典型猶存'],
    female: ['母儀千古','懿範永存','慈暉永昭','音容宛在','音容宛存','寶婺光寒','慈雲歸西','慈竹風悲'],
  },
  '佛教': {
    neutral: ['蓮邦極樂','往生極樂','西方接引','倒駕慈航','早登蓮邦','同登彼岸','早歸極樂','蓮座飄香'],
    male: [],
    female: [],
  },
  '基督教': {
    neutral: ['主懷安息','蒙主恩召','安息主懷','永居天家','平安歸主','主賜安寧','永生安息','在主裡睡了'],
    male: [],
    female: [],
  },
  '天主教': {
    neutral: ['蒙主寵召','永享主光','安息天國','復活享福','永享天國','諸聖之福'],
    male: [],
    female: [],
  },
};

// ─── PHRASE EXPLANATIONS ───
const phraseExplain = {
  '永遠懷念':'長存於心的思念 · 最普世的悼念詞 · 適用所有親疏關係',
  '沈痛悼念':'表達深切哀痛之意 · 適用所有關係',
  '千古不朽':'永世長存 · 永不磨滅 · 中性通用',
  '一路好走':'願先人一路平安 · 口語親切 · 中性通用',
  '駕鶴西歸':'仙鶴載歸西方 · 典雅 · 適合長者善終',
  '福壽全歸':'福分壽命圓滿 · 適合高壽善終',
  '哀思永念':'哀痛思念永遠長存',
  '風範長存':'先人風範永存後人心中',
  '典範長存':'先人風範永存 · 多用於男性長輩',
  '德澤永存':'恩德與蔭澤永遠存在 · 適合男性',
  '英名永存':'英明事跡永誌不忘 · 適合男性 / 英雄人物',
  '浩氣長存':'浩然正氣永存 · 適合公職 / 英烈男性',
  '流芳百世':'美好聲名流傳百世 · 多用於男性',
  '萬古流芳':'美名永遠流傳 · 多用於男性',
  '英靈不泯':'英魂永不磨滅 · 適合男性',
  '典型猶存':'典範樣本尚存 · 適合男性長輩',
  '母儀千古':'慈母典範永流傳 · 適合母親',
  '懿範永存':'美好德行典範永存 · 適合女性長輩',
  '慈暉永昭':'慈愛光輝永遠照耀 · 適合母親',
  '音容宛在':'容貌聲音猶如尚存 · 傳統用於女性 · 形容深切思念',
  '音容宛存':'容貌音聲尚在 · 女性異體',
  '寶婺光寒':'婺女星（女性星宿）光暗 · 形容德高女性離世',
  '慈雲歸西':'慈愛之雲歸西 · 適合女性長輩',
  '慈竹風悲':'慈母如竹 · 風中悲傷 · 適合母親',
  '蓮邦極樂':'蓮邦即西方極樂淨土',
  '往生極樂':'往生阿彌陀佛西方極樂世界',
  '西方接引':'阿彌陀佛接引往西方淨土',
  '倒駕慈航':'已脫生死返回度化眾生',
  '早登蓮邦':'早日登入極樂蓮花世界',
  '同登彼岸':'共同到達覺悟彼岸',
  '早歸極樂':'早日歸於極樂淨土',
  '蓮座飄香':'蓮花座發出芬芳',
  '主懷安息':'安睡在主懷抱',
  '蒙主恩召':'蒙主慈愛召喚回天家',
  '安息主懷':'安睡在主懷抱',
  '永居天家':'永遠居住天國家中',
  '平安歸主':'安然回歸主裡',
  '主賜安寧':'主賜予永遠安寧',
  '永生安息':'永恆生命中的安息',
  '在主裡睡了':'聖經用語 · 指逝世（哥前 15:18）',
  '蒙主寵召':'蒙主寵愛召喚回天家',
  '永享主光':'永遠享有主的榮光',
  '安息天國':'在天國中安息',
  '復活享福':'復活並享永福',
  '永享天國':'永遠享有天國之福',
  '諸聖之福':'與諸聖一同享福',
};

// ─── REFS ───
const banner=document.querySelector('.banner-canvas');
const bp=document.getElementById('bp-phrase');
const bpReltitle=document.getElementById('bp-reltitle'),bpName=document.getElementById('bp-name'),bpHon=document.getElementById('bp-hon');
const bpSenders=document.getElementById('bp-senders'),bpSuffix=document.getElementById('bp-suffix');
const inRel=document.getElementById('in-relation'),inName=document.getElementById('in-name'),inGender=document.getElementById('in-gender'),inSuffix=document.getElementById('in-suffix');
const sendersGroup=document.getElementById('senders-group'),addSenderBtn=document.getElementById('add-sender');
const autoHint=document.getElementById('auto-hint'),autoHintText=document.getElementById('auto-hint-text');
const chipContainer=document.getElementById('chip-container'),chipSuggested=document.getElementById('chip-suggested');
const pmPhrase=document.getElementById('pm-phrase'),pmText=document.getElementById('pm-text');
const slot30=document.getElementById('slot30');
const priceDisp=document.getElementById('price-display'),priceSize=document.getElementById('price-size');
const sumSize=document.getElementById('sum-size'),sumFlower=document.getElementById('sum-flower'),sumZone=document.getElementById('sum-zone'),sumShip=document.getElementById('sum-ship'),sumUpLabel=document.getElementById('sum-up-label'),sumUp=document.getElementById('sum-up'),sumTotal=document.getElementById('sum-total');
const zoneName=document.getElementById('zone-name'),zoneFee=document.getElementById('zone-fee'),venueName=document.getElementById('venue-name');

const state={flower:950,sizeLabel:'中 M · 高 55 cm',ship:0,shipLabel:'免費',upLabel:'—',up:0,timeFee:0,timeLabel:'',religion:'通用',gender:'M',activePhrase:''}; window.__tfkState=state;   /* TFK 2026-08-25 Gary：輓詞唔要預設，客人必須自己揀 */
function recalc(){
  const t=state.flower+state.ship+state.up+(state.timeFee||0);
  sumSize.textContent=state.sizeLabel;sumFlower.textContent=`HK$${state.flower.toLocaleString()}`;
  sumShip.textContent=state.shipLabel;var _ad=state.up+(state.timeFee||0);sumUpLabel.textContent=[state.timeLabel,(state.upLabel&&state.upLabel!=='—')?state.upLabel:''].filter(Boolean).join(' + ')||'—';sumUp.textContent=_ad?`HK$${_ad}`:'—';
  sumTotal.textContent=`HK$${t.toLocaleString()}`;
}
/* TFK 2026-06-03: 用真 variant 價初始化訂單明細(純JS讀DOM · javascript tag 入面唔可以用Liquid所以唔可以注入價) · 修「單一variant帛事產品明細凍結HK$950」顯示bug · 純顯示唔影響cart/submit/後台 */
window.tfkRecalc=recalc;
(function(){try{
  var rs=document.querySelector('.size.is-active:not(.tfk-sizefix)[data-price]')||document.querySelector('.size:not(.tfk-sizefix)[data-price]');
  if(rs){var p=parseFloat((rs.dataset.price||'').replace(/,/g,''));if(isFinite(p)){state.flower=p;var cn=rs.querySelector('.cn'),en=rs.querySelector('.en');state.sizeLabel=(cn?cn.textContent:'')+(en?' '+en.textContent.charAt(0):'');}}
  else{var pd=document.getElementById('price-display'),ps=document.getElementById('price-size');if(pd){var pp=parseFloat((pd.textContent||'').replace(/[^0-9.]/g,''));if(isFinite(pp))state.flower=pp;}if(ps&&ps.textContent.trim())state.sizeLabel=ps.textContent.trim();}
  recalc();
}catch(e){}})();

// ─── SIZE (skip bouquet multi-option .opt-btn · Gary 2026-05-27) ───
document.querySelectorAll('.size').forEach(s=>s.addEventListener('click',()=>{
  if(s.hasAttribute('data-opt-value')) return;
  const grid=s.parentElement;
  if(grid) grid.querySelectorAll('.size').forEach(x=>x.classList.remove('is-active'));s.classList.add('is-active');
  // Parse price · strip commas to avoid NaN (e.g. "1,750.00" → 1750)
  const raw=(s.dataset.price||'').replace(/,/g,'');
  const p=parseFloat(raw);
  if(!isFinite(p)) return;
  state.flower=p;
  state.sizeLabel=s.querySelector('.cn').textContent+' '+s.querySelector('.en').textContent.charAt(0);
  priceDisp.textContent='HK$'+p.toLocaleString();priceSize.textContent=s.dataset.cn;
  // Update hidden cart variant-id so the right variant gets added
  const idIn=document.getElementById('v2a-variant-id');if(idIn)idIn.value=s.dataset.variantId;
  recalc();
}));

// ─── ZONE ───
const zoneFees={1:[0,'免費','Zone 1 · 港島 + 九龍','Same-day standard'],2:[150,'HK$150','Zone 2 · 新界主區','New Territories'],3:[250,'HK$250','Zone 3 · 新界遠郊 + 離島','Outer NT / islands']};
/* TFK 2026-08-25 · 「其他場地」分支：zone 由客人自己揀嘅地區決定。
   ⚠️ 未揀地區時 **唔可以當免費** —— 顯示「—」，validation 會擋住落單。 */
const venueOtherBlock=document.getElementById('venue-other-block');
const venueZoneSel=document.getElementById('in-venue-zone');
function tfkIsOtherVenue(){
  const o=venueName.options[venueName.selectedIndex];
  return !!(o && o.dataset.zone==='0');
}
function tfkCurrentZone(){
  if(tfkIsOtherVenue()){
    const o=venueZoneSel && venueZoneSel.options[venueZoneSel.selectedIndex];
    return (o && +o.dataset.zone) || 0;   /* 0 = 仲未揀地區 */
  }
  const o=venueName.options[venueName.selectedIndex];
  return (o && +o.dataset.zone) || 1;
}
function tfkApplyZone(){
  if(venueOtherBlock) venueOtherBlock.style.display = tfkIsOtherVenue() ? '' : 'none';
  const z=tfkCurrentZone();
  if(!z){
    state.ship=0;state.shipLabel='—';
    zoneName.innerHTML='請揀送貨地區 <em>Select district to calculate</em>';
    zoneFee.textContent='—';zoneFee.classList.remove('free');
    sumZone.textContent='—';recalc();return;
  }
  const [fee,feeLabel,zname,zsub]=zoneFees[z];
  state.ship=fee;state.shipLabel=feeLabel;
  zoneName.innerHTML=zname+' <em>'+zsub+'</em>';zoneFee.textContent=feeLabel+(fee===0?' · Free':'');
  zoneFee.classList.toggle('free',fee===0);sumZone.textContent=zname;recalc();
}
window.tfkCurrentZone=tfkCurrentZone;   /* 落單寫 cart attribute 嗰段要用 */
venueName.addEventListener('change',tfkApplyZone);
if(venueZoneSel) venueZoneSel.addEventListener('change',tfkApplyZone);

// ─── UPGRADE ───
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',()=>{
  if(u.classList.contains('is-active')){u.classList.remove('is-active');state.up=0;state.upLabel='—';}
  else{document.querySelectorAll('.upgrade').forEach(x=>x.classList.remove('is-active'));u.classList.add('is-active');state.up=+u.dataset.fee;state.upLabel=u.querySelector('.cn').textContent;}
  recalc();
}));

// ─── TIME selectors ───
document.querySelectorAll('.quick,.time-cat,.hour').forEach(b=>b.addEventListener('click',()=>{
  if(b.classList.contains('is-disabled'))return;
  const peers=b.parentElement.querySelectorAll('.quick,.time-cat,.hour');
  peers.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
}));
/* TFK 2026-08-24 · 時段附加費即時反映落訂單明細（原時段 handler 唔會叫 recalc）*/
(function(){
  function syncTimeFee(){
    try{
      var tc=document.querySelector('.time-cats .time-cat.is-active'), tf=0, tl='';
      if(tc){
        var fe=tc.querySelector('.tl-fee');
        if(fe && !fe.classList.contains('tl-free') && !fe.classList.contains('free')){
          var mm=(fe.textContent||'').match(/(\d[\d,]*)/);
          tf=mm?parseInt(mm[1].replace(/,/g,''),10):0;
        }
        if(tf>0){ var c=tc.querySelector('.cn'); tl=(c?c.textContent.trim():'')+'時段'; }
      }
      if(window.__tfkState && (window.__tfkState.timeFee!==tf || window.__tfkState.timeLabel!==tl)){
        window.__tfkState.timeFee=tf; window.__tfkState.timeLabel=tl;
        if(typeof window.tfkRecalc==='function') window.tfkRecalc();
      }
    }catch(e){}
  }
  document.addEventListener('click',function(e){
    if(e.target&&e.target.closest&&e.target.closest('.time-cat')) setTimeout(syncTimeFee,0);
  },true);
  setInterval(syncTimeFee,700);
  syncTimeFee();
})();

// ─── BANNER sync (4-line · multi-sender · auto-shrink · 「同」connector) ───
function getSenders(){
  return Array.from(sendersGroup.querySelectorAll('.sender-row')).map(row=>({
    prefix:row.querySelector('.sender-prefix').value,
    rank:row.querySelector('.sender-rank')?.value||'',
    name:row.querySelector('.sender-name').value.trim(),
  })).filter(s=>s.name||s.prefix);
}

// Sort senders by (level ASC · gender 男先女後 · 排行 長次三...)
function sortSenders(senders){
  return senders.slice().sort((a,b)=>{
    const la=prefixLevel[a.prefix]??99, lb=prefixLevel[b.prefix]??99;
    if(la!==lb)return la-lb;
    const ga=prefixGender(a.prefix),gb=prefixGender(b.prefix);
    if(ga!==gb)return ga-gb;
    return (rankOrder[a.rank]||7)-(rankOrder[b.rank]||7);
  });
}

function syncBanner(){
  const m=relationMap[inRel.value];
  bpReltitle.textContent=m?.title?m.title:'';
  bpName.textContent=inName.value||'先人名稱';
  bpHon.textContent=m?.hon||'千古';

  // build sender lines · auto-sort by (level/gender/rank) · 率字只用喺不同輩
  const rawSenders=getSenders();
  const senders=sortSenders(rawSenders);
  bpSenders.innerHTML='';
  if(senders.length===0){
    bpSenders.innerHTML=`<div class="bnr-sender"><span class="sname" style="color:var(--muted)">送花人名稱</span></div>`;
  }else{
    const firstLevel=prefixLevel[senders[0].prefix]??99;
    senders.forEach((s,idx)=>{
      const div=document.createElement('div');
      div.className='bnr-sender';
      // Apply rank splice (孝子 + 長 → 孝長子)
      const displayPrefix=applyRank(s.prefix,s.rank);
      const senderLevel=prefixLevel[s.prefix]??99;
      // 「率」字只喺不同輩時加（同輩 e.g. 孝子+孝女 唔加）
      const rate=(idx>0&&senderLevel!==firstLevel)?`<span class="srate">率</span>`:'';
      const px=displayPrefix?`<span class="sprefix">${displayPrefix}</span>`:'';
      const nm=`<span class="sname">${s.name||'（未填名稱）'}</span>`;
      div.innerHTML=rate+px+nm;
      bpSenders.appendChild(div);
    });
  }
  // suffix · 跟舊設計 · 唔自動加「同」字
  bpSuffix.textContent=inSuffix.value;

  autoShrink();
}

// ─── AUTO-SHRINK + LINE 1 AUTO-FIT TO WIDTH (per Gary · 從左到右最大) ───
function autoShrink(){
  const senderCount=Math.max(1,getSenders().length);
  let scale=1;
  if(senderCount>=5)scale=.62;
  else if(senderCount===4)scale=.72;
  else if(senderCount===3)scale=.82;
  else if(senderCount===2)scale=.92;
  // suffix penalty
  const suffixLen=bpSuffix.textContent.length;
  let l4Scale=scale;
  if(suffixLen>=4)l4Scale*=.92;

  // Line 1 base = 15cqw (BIG · fills width by default · scales down via overflow detection)
  const L1_MAX=15;
  banner.style.setProperty('--l1',`${L1_MAX}cqw`);
  banner.style.setProperty('--l2',`${17*scale}cqw`);
  banner.style.setProperty('--l3',`${8*scale}cqw`);
  banner.style.setProperty('--l4',`${6*l4Scale}cqw`);
  banner.style.setProperty('--gap',`${2.5*scale}cqw`);

  // FIT-TO-WIDTH for Line 1 via BINARY SEARCH (deterministic · precise)
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    const cw=banner.clientWidth;
    if(cw<10)return;
    const availW=cw*0.84; // 84% safety margin
    const l1El=document.querySelector('.bnr-line1');
    const l2El=bp;
    const l3Els=Array.from(bpSenders.querySelectorAll('.bnr-sender'));
    const l4El=bpSuffix;

    // Line 1: BINARY SEARCH for largest font-size that fits availW
    let lo=3,hi=L1_MAX,best=3;
    for(let i=0;i<10;i++){
      const mid=(lo+hi)/2;
      banner.style.setProperty('--l1',`${mid}cqw`);
      void l1El.offsetWidth; // force reflow
      if(l1El.scrollWidth<=availW){best=mid;lo=mid;}
      else{hi=mid;}
    }
    banner.style.setProperty('--l1',`${best}cqw`);

    // Other lines: overflow shrink only
    let furtherL2=1,furtherL3=1,furtherL4=1;
    if(l2El.scrollWidth>availW)furtherL2=Math.max(.55,availW/l2El.scrollWidth);
    l3Els.forEach(e=>{if(e.scrollWidth>availW){furtherL3=Math.min(furtherL3,Math.max(.55,availW/e.scrollWidth));}});
    if(l4El.scrollWidth>availW)furtherL4=Math.max(.55,availW/l4El.scrollWidth);
    if(furtherL2<1)banner.style.setProperty('--l2',`${17*scale*furtherL2}cqw`);
    if(furtherL3<1)banner.style.setProperty('--l3',`${8*scale*furtherL3}cqw`);
    if(furtherL4<1)banner.style.setProperty('--l4',`${6*l4Scale*furtherL4}cqw`);
    const overflowReduced=Math.min(furtherL2,furtherL3,furtherL4);
    updateShrinkBadge(scale,overflowReduced);
  }));

  function updateShrinkBadge(senderScale,overflowScale){
    const tag=document.querySelector('.preview-foot .shrink-tag');
    const totalScale=senderScale*overflowScale;
    if(totalScale<.99){
      let label=`Auto-shrink ${Math.round(totalScale*100)}%`;
      if(overflowScale<.99 && senderScale<.99)label+=' (多人+名長)';
      else if(overflowScale<.99)label+=' (字過長)';
      else label+=` (${getSenders().length} 位送花人)`;
      if(!tag){
        const t=document.createElement('span');t.className='shrink-tag';t.textContent=label;
        document.querySelector('.preview-foot').appendChild(t);
      }else{tag.textContent=label;}
    }else if(tag){tag.remove();}
  }
}

// ─── BANNER input listeners ───
inName.addEventListener('input',syncBanner);
inSuffix.addEventListener('change',syncBanner);
sendersGroup.addEventListener('input',syncBanner);
sendersGroup.addEventListener('change',syncBanner);

// ─── RELATION → ALLOWED SENDER CATEGORIES (filter add-sender prefix list) ───
// Each relation → which prefix optgroup labels are allowed for ADDITIONAL senders
const relSenderCats = {
  // 父母 / 公婆 / 岳父母 — 喪偶/子女/孫一齊送
  '父親':['子女輩','孫輩','曾孫 / 玄孫'],
  '母親':['子女輩','孫輩','曾孫 / 玄孫'],
  '家翁':['子女輩','孫輩'],
  '家姑':['子女輩','孫輩'],
  '岳父':['子女輩','孫輩'],
  '岳母':['子女輩','孫輩'],
  // 夫妻 — 主要係妻/夫單獨送 + 可能子女合送
  '丈夫':['子女輩','孫輩'],
  '妻子':['子女輩','孫輩'],
  // 兄弟姊妹 — 同輩 + 姪輩
  '兄':['兄弟姊妹','父系姪輩'],
  '弟':['兄弟姊妹','父系姪輩'],
  '姊':['兄弟姊妹','父系姪輩'],
  '妹':['兄弟姊妹','父系姪輩'],
  // 親戚長輩 父系 → 姪輩
  '伯父':['父系姪輩'],
  '叔父':['父系姪輩'],
  '伯娘':['父系姪輩'],
  '姑姐':['父系姪輩'],
  '姑丈':['父系姪輩'],
  // 親戚長輩 母系 → 外甥輩
  '舅父':['母系外甥輩'],
  '舅母':['母系外甥輩'],
  '姨媽':['母系外甥輩'],
  '姨丈':['母系外甥輩'],
  // 祖父母 → 孫 + 曾孫 + 率字
  '祖父':['孫輩','曾孫 / 玄孫'],
  '祖母':['孫輩','曾孫 / 玄孫'],
  '外祖父':['孫輩','曾孫 / 玄孫'],
  '外祖母':['孫輩','曾孫 / 玄孫'],
  // 表親
  '表兄弟':['表親'],
  '表姊妹':['表親'],
  '姐夫':['表親'],
  // 朋友 / 同事 / 公司 — 純名字 · 唔需 prefix
  '朋友男':[],
  '朋友女':[],
  '同事男':[],
  '同事女':[],
  '公司':[],
  '教會弟兄':[],
  '教會姊妹':[],
  // 長輩送晚輩
  '子姪男':[],
  '子姪女':[],
};

// Build filtered prefix select HTML based on relation
function buildPrefixSelectHTML(relation, includeBlank=true){
  const allowedCats=relSenderCats[relation];
  // If no relation set or no restriction: return full list
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  let html='';
  if(includeBlank){
    html+=`<option value="">（無前綴）</option>`;
    html+=`<option value="（不指定排行）">（不指定排行）</option>`;
  }
  if(!relation||!allowedCats||allowedCats.length===0){
    // No relation: show all categories (full list as before)
    return primary.innerHTML; // fall back to primary's full list
  }
  // Otherwise reconstruct from full list filtering optgroups by label
  const fullOpts=primary.querySelectorAll('optgroup');
  fullOpts.forEach(og=>{
    if(allowedCats.includes(og.label)){
      html+=`<optgroup label="${og.label}">`;
      og.querySelectorAll('option').forEach(o=>html+=`<option value="${o.value}">${o.textContent}</option>`);
      html+=`</optgroup>`;
    }
  });
  return html;
}

// ─── MULTI-SENDER add / remove ───
const rankOptsHTML=`<option value="">不指定</option><option value="長">長</option><option value="次">次</option><option value="三">三</option><option value="四">四</option><option value="五">五</option><option value="六">六</option>`;

function addSenderRow(prefix='',name='',rank=''){
  const row=document.createElement('div');
  row.className='sender-row';
  const opts=buildPrefixSelectHTML(inRel.value,true);
  row.innerHTML=`
    <div>
      <span class="sender-row-label">前綴</span>
      <select class="uline sender-prefix">${opts}</select>
    </div>
    <div>
      <span class="sender-row-label">排行</span>
      <select class="uline sender-rank">${rankOptsHTML}</select>
    </div>
    <div>
      <span class="sender-row-label">姓名 / 公司</span>
      <input class="uline sender-name" placeholder="例：陳小明" />
    </div>
    <button class="remove" type="button">×</button>
  `;
  sendersGroup.appendChild(row);
  if(prefix)row.querySelector('.sender-prefix').value=prefix;
  if(rank)row.querySelector('.sender-rank').value=rank;
  if(name)row.querySelector('.sender-name').value=name;
  row.querySelector('.remove').addEventListener('click',()=>{row.remove();syncBanner();updateAddSenderHint();});
  // disable rank dropdown if prefix doesn't support
  updateRowRankAvailability(row);
  syncBanner();
  updateAddSenderHint();
}

function updateRowRankAvailability(row){
  const sel=row.querySelector('.sender-prefix');
  const rank=row.querySelector('.sender-rank');
  if(!rank)return;
  if(!rankableSet.has(sel.value)){
    rank.value='';
    rank.classList.add('is-disabled');
    rank.title='此前綴不支持排行（長/次/三...）';
  }else{
    rank.classList.remove('is-disabled');
    rank.title='';
  }
}

sendersGroup.addEventListener('change',e=>{
  if(e.target.classList.contains('sender-prefix')){
    updateRowRankAvailability(e.target.closest('.sender-row'));
  }
});
addSenderBtn.addEventListener('click',()=>addSenderRow());
sendersGroup.querySelector('.sender-row.primary .remove').addEventListener('click',()=>{});

// ─── Add-sender hint message (relation-aware) ───
function updateAddSenderHint(){
  const v=inRel.value;
  let oldHint=document.getElementById('add-sender-hint');
  if(oldHint)oldHint.remove();
  if(!v)return;
  const cats=relSenderCats[v]||[];
  const senderCount=getSenders().length;
  let msg='',color='var(--muted)';
  if(v==='丈夫'||v==='妻子'){
    msg=`💡 夫妻互送一般係 1 位送花人（${v==='丈夫'?'妻':'夫'}）獨送 · 若子女合送可加多人`;
    color='var(--gold-deep)';
  }else if(cats.length===0){
    msg=`💡 朋友 / 同事 / 公司一般唔需要送花人前綴 · 直接輸入姓名 / 公司名`;
    color='var(--gold-deep)';
  }else{
    msg=`💡 揀「${inRel.options[inRel.selectedIndex].text}」· 可加 ${cats.join(' / ')} 嘅親屬合送`;
  }
  const hint=document.createElement('div');hint.id='add-sender-hint';
  hint.style.cssText=`font-family:var(--cjk);font-size:12px;color:${color};letter-spacing:.06em;margin-top:8px;padding:8px 12px;background:rgba(184,153,104,.08);border-left:2px solid var(--gold);line-height:1.6`;
  hint.textContent=msg;
  addSenderBtn.insertAdjacentElement('afterend',hint);
}

// Update primary sender prefix list + all secondary rows when relation changes
function syncAllPrefixLists(){
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  const primaryVal=primary.value;
  // Primary: keep full list (relation auto-fills its value)
  // Secondary rows: filter by relation
  Array.from(sendersGroup.querySelectorAll('.sender-row')).forEach((row,i)=>{
    if(i===0)return; // primary
    const sel=row.querySelector('.sender-prefix');
    const oldVal=sel.value;
    sel.innerHTML=buildPrefixSelectHTML(inRel.value,true);
    sel.value=oldVal;
  });
}
inRel.addEventListener('change',()=>{syncAllPrefixLists();updateAddSenderHint();});

// ─── RELATION → AUTO-FILL 上聯 + 主送花人前綴 + 後綴 + DERIVED GENDER ───
inRel.addEventListener('change',()=>{
  const v=inRel.value;
  // auto-derive gender + update derived gender badge + re-filter 輓詞 chips
  if(v && relationGender[v]){
    const g=relationGender[v];
    document.getElementById('in-gender').value=g;
    state.gender=g;
    const dg=document.getElementById('derived-gender');
    if(dg){
      const gLabel=g==='M'?'男 ♂':'女 ♀';
      dg.textContent=gLabel+'（由關係推導）';
      dg.style.color=g==='M'?'var(--male)':'var(--female)';
      dg.style.borderColor=g==='M'?'var(--male)':'var(--female)';
    }
    renderChips();
  }
  if(!v||!relationMap[v]){autoHint.style.display='none';syncBanner();return;}
  const m=relationMap[v];
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  primaryPrefix.value=m.prefix||'';
  inSuffix.value=m.suffix;
  // update primary row rank availability
  updateRowRankAvailability(sendersGroup.querySelector('.sender-row.primary'));
  syncBanner();
  autoHint.style.display='block';
  let txt=`揀「${inRel.options[inRel.selectedIndex].text}」 → 已自動填：<br/>`;
  if(m.title)txt+=`• 上聯稱謂：<span class="tag">${m.title}</span> + 先人名 + 敬稱 <span class="tag">${m.hon}</span><br/>`;
  else txt+=`• 上聯：（先人名）+ 敬稱 <span class="tag">${m.hon}</span><br/>`;
  if(m.prefix)txt+=`• 主送花人前綴：<span class="tag">${m.prefix}</span>`;
  if(m.altPrefix)txt+=` <em>· 若送花人為女性可改用「${m.altPrefix}」</em>`;
  txt+=`<br/>• 下款後綴：<span class="tag">${m.suffix}</span>`;
  txt+=`<br/><em>↺ 仍可手動修改 · 可按「＋ 添加家庭成員」加多人</em>`;
  autoHintText.innerHTML=txt;
});

// ─── 30 MIN SLOT · conditional on upgrade ───
function update30Min(){
  const has30min=document.querySelector('.upgrade[data-shows-30min].is-active');
  slot30.style.display=has30min?'block':'none';
  if(!has30min){
    slot30.querySelectorAll('.hour').forEach(h=>h.classList.remove('is-active'));
  }
}
// hook into existing upgrade click handler
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',update30Min));
update30Min();

// ─── RELIGION TOGGLE ───
document.querySelectorAll('.religion button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.religion button').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
  state.religion=b.dataset.rel;renderChips();
}));

// ─── GENDER toggle ───
inGender.addEventListener('change',()=>{state.gender=inGender.value;renderChips();});

// ─── CHIP renderer (by religion + gender) ───
function renderChips(){
  const data=phrases[state.religion];
  let html='';
  if(state.gender==='M' && data.male.length){
    html+=`<div class="chip-section male"><div class="chip-section-label">男性 ♂ Male · ${state.religion}</div><div class="chip-row">`;
    data.male.forEach(p=>html+=`<button type="button" class="chip gM ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♂</span></button>`);
    html+=`</div></div>`;
  }
  if(state.gender==='F' && data.female.length){
    html+=`<div class="chip-section female"><div class="chip-section-label">女性 ♀ Female · ${state.religion}</div><div class="chip-row">`;
    data.female.forEach(p=>html+=`<button type="button" class="chip gF ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♀</span></button>`);
    html+=`</div></div>`;
  }
  html+=`<div class="chip-section neutral"><div class="chip-section-label">中性 ◆ Neutral · ${state.religion}</div><div class="chip-row">`;
  data.neutral.forEach(p=>html+=`<button type="button" class="chip gN ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">◆</span></button>`);
  html+=`</div></div>`;
  chipContainer.innerHTML=html;
  if(state.religion==='通用'){
    chipSuggested.innerHTML=state.gender==='M'?`💡 先人為男性 · 上方建議用男性詞（♂）或中性詞（◆）`:`💡 先人為女性 · 上方建議用女性詞（♀）或中性詞（◆）`;
  }else{
    chipSuggested.innerHTML=`💡 ${state.religion}輓詞通常不分男女 · 任揀`;
  }
  chipContainer.querySelectorAll('.chip[data-p]').forEach(c=>c.addEventListener('click',()=>{
    chipContainer.querySelectorAll('.chip[data-p]').forEach(x=>x.classList.remove('is-active'));
    c.classList.add('is-active');state.activePhrase=c.dataset.p;bp.textContent=c.dataset.p;
    // update phrase meaning panel
    pmPhrase.textContent=c.dataset.p;
    pmText.textContent=phraseExplain[c.dataset.p]||'（暫無解釋）';
    autoShrink();
  }));
}

renderChips();
syncBanner();

// ─── STEP STATUS TRACKING (ss1 → ss2 → ss3 progression) ───
const ss1=document.getElementById('ss1'),ss2=document.getElementById('ss2'),ss3=document.getElementById('ss3');
function setStepState(el,state,label){
  el.classList.remove('is-active','is-pending','is-done');
  el.classList.add(state);
  el.querySelector('.sub-step-status').textContent=label;
}
function updateStepStatuses(){
  const has關係=!!inRel.value;
  const has先人名=!!inName.value.trim();
  const has輓詞=!!document.querySelector('.chip[data-p].is-active');
  const senders=getSenders();
  const has送花人=senders.some(s=>s.name);

  // ss1
  if(has關係 && has先人名){setStepState(ss1,'is-done','已完成 ✓');}
  else if(has關係 || has先人名){setStepState(ss1,'is-active','進行中');}
  else{setStepState(ss1,'is-active','進行中');}

  // ss2
  if(has關係 && has先人名 && has輓詞){setStepState(ss2,'is-done','已完成 ✓');}
  else if(has關係 && has先人名){setStepState(ss2,'is-active','進行中');}
  else{setStepState(ss2,'is-pending','待填');}

  // ss3
  if(has關係 && has先人名 && has輓詞 && has送花人){setStepState(ss3,'is-done','已完成 ✓');}
  else if(has關係 && has先人名 && has輓詞){setStepState(ss3,'is-active','進行中');}
  else{setStepState(ss3,'is-pending','待填');}
}
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('input',updateStepStatuses));
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('change',updateStepStatuses));
sendersGroup.addEventListener('input',updateStepStatuses);
sendersGroup.addEventListener('change',updateStepStatuses);
// hook chip clicks (use event delegation after renderChips)
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))setTimeout(updateStepStatuses,50)});

// ─── BANNER ELEMENT PULSE on input change ───
function pulse(el){if(!el)return;el.classList.remove('bnr-pulse');void el.offsetWidth;el.classList.add('bnr-pulse');}
inName.addEventListener('input',()=>pulse(document.querySelector('.bnr-line1')));
inRel.addEventListener('change',()=>{pulse(document.querySelector('.bnr-line1'));setTimeout(()=>pulse(bpSenders),300);setTimeout(()=>pulse(document.querySelector('.bnr-suffix')),550);});
inSuffix.addEventListener('change',()=>pulse(document.querySelector('.bnr-suffix')));
sendersGroup.addEventListener('input',()=>pulse(bpSenders));
sendersGroup.addEventListener('change',()=>pulse(bpSenders));
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))pulse(bp);});

// ─── AUTO-FILL FLASH on form fields when relation triggers fill ───
const origRelHandler=inRel.onchange;
inRel.addEventListener('change',()=>{
  if(!inRel.value||!relationMap[inRel.value])return;
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  [primaryPrefix,inSuffix].forEach(el=>{
    el.classList.remove('is-autofilled');void el.offsetWidth;el.classList.add('is-autofilled');
  });
});

// initial state
updateStepStatuses();


// ─── TIME CUTOFF · auto-disable past + auto-pick first available (per Gary 舊設計) ───
(function setupTimeCutoff(){
  const W = document.querySelector('.funeral-pdp-v2a-wrap');
  if(!W) return;
  
  // Min lead time for arrangement preparation
  const PREP_MIN = 150; // 2.5 hours
  
  // Time category cutoffs (start time in minutes from midnight)
  /* TFK 2026-08-25 · Gary 揀 B：cutoff = 時段【結束】時間（結束前送到就得）
     ⚠️ 必須同第 3324 行嘅 CATCUT 一模一樣 —— 兩個 timer 用緊同一條公式
        (now + PREP > cutoff)，數值唔同就會每 300ms 互相開關同一粒掣，
        客人撳咗「標準」會被彈走去「晚間」（免費變 +$120）。 */
  const CAT_CUTOFFS = {
    '特早': 9*60,         // 09:00 — 8–9am 結束
    '標準': 18*60+30,     // 18:30 — 10am–6:30pm 結束
    '晚間': 21*60,        // 21:00 — 7–9pm 結束
    '特晚': 24*60,        // 24:00 — 9pm–12am 結束
  };
  
  // 3-hour window cutoffs
  const WIN_CUTOFFS = {
    '上午': 10*60,        // 10am · 標準 window
    '中午': 12*60+30,     // 12:30 · 標準 window
    '下午': 15*60+30,     // 15:30 · 標準 window
    '9:00': 21*60,        // 9pm · 特晚 window
    '10:30': 22*60+30,    // 22:30 · 特晚 window
  };
  
  // 30-min slot cutoffs (parse from text "12:30 – 1:00" etc)
  function parseSlotStart(txt){
    const m = txt.match(/(\d+):(\d+)/);
    if(!m) return null;
    let h = +m[1], min = +m[2];
    if(h < 8) h += 12; // assume PM if h < 8 (1:00 = 13:00)
    return h * 60 + min;
  }
  
  function isToday(){
    const dateRow = W.querySelector('.quick-row');
    if(!dateRow) return true;
    const active = dateRow.querySelector('.quick.is-active');
    if(!active) return true;
    return active.textContent.includes('今日');
  }
  
  function nowMinutes(){
    const n = new Date();
    return n.getHours()*60 + n.getMinutes();
  }
  
  function disableOrEnable(btn, startMin, nowM, today){
    const tooLate = today && (nowM + PREP_MIN > startMin);
    btn.classList.toggle('is-disabled', tooLate);

    // CRITICAL: skip text manipulation if element has nested children.
    if(btn.querySelector('.tl-row, .tl-fee, .tl-main, .tl-detail, .tl-hint')) return;

    const baseText = btn.dataset.baseText || btn.textContent.trim();
    if(!btn.dataset.baseText) btn.dataset.baseText = baseText;
    if(tooLate && !baseText.includes('來不及')){
      if(btn.classList.contains('quick')){
        btn.textContent = baseText + ' · 製作來不及';
      }
    }else{
      btn.textContent = baseText;
    }
  }

  
  
  function autoPickFirstAvailable(group, activeClass='is-active', disabledClass='is-disabled'){
    const all = Array.from(group.children);
    const current = all.find(b => b.classList.contains(activeClass));
    if(current && current.classList.contains(disabledClass)){
      current.classList.remove(activeClass);
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    } else if(!current){
      // No active · pick first available
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    }
  }
  
  function applyTimeCutoffs(){
    const today = isToday();
    const nowM = nowMinutes();
    
    // Time categories
    W.querySelectorAll('.time-cats .time-cat').forEach(btn => {
      const cn = btn.querySelector('.cn')?.textContent.trim();
      const start = CAT_CUTOFFS[cn];
      if(start !== undefined) disableOrEnable(btn, start, nowM, today);
    });
    
    // 3-hour windows (in second .quick-row · check via parent label)
    W.querySelectorAll('.quick-row').forEach(row => {
      const buttons = Array.from(row.querySelectorAll('.quick'));
      // Check if this row is a 3hr-window row (button text starts with 上午/中午/下午)
      const firstText = buttons[0]?.textContent.trim() || '';
      const isWindowRow = ['上午','中午','下午'].some(w => firstText.startsWith(w));
      if(!isWindowRow) return;
      
      buttons.forEach(btn => {
        const txt = btn.textContent.trim();
        let win = null;
        Object.keys(WIN_CUTOFFS).forEach(k => { if(txt.startsWith(k)) win = k; });
        if(win) disableOrEnable(btn, WIN_CUTOFFS[win], nowM, today);
      });
      
      autoPickFirstAvailable(row);
    });
    
    /* TFK 2026-08-25 Gary：送花時段唔要預設 —— 客人必須自己揀。
       ⚠️ 但唔可以成條 autoPickFirstAvailable 拆走：嗰個函數仲負責
          「已揀嘅時段變成趕唔切 → 幫客人取消」。冇咗呢part，客人會留住
          一個實際上送唔到嘅時段，落單先發現，仲差過有預設。
       所以只保留「取消趕唔切嘅選擇」，唔再自動幫佢揀。 */
    W.querySelectorAll('.time-cats').forEach(g => {
      const cur = Array.from(g.children).find(b => b.classList.contains('is-active'));
      if(cur && cur.classList.contains('is-disabled')) cur.classList.remove('is-active');
    });
    
    // SMART: if today + ALL time categories disabled · auto-switch to 明日
    if(today){
      const allCatDisabled = Array.from(W.querySelectorAll('.time-cats .time-cat')).every(b => b.classList.contains('is-disabled'));
      if(allCatDisabled){
        const dateRow = W.querySelector('.quick-row');
        const todayChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('今日'));
        const tmrChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('明日'));
        if(todayChip && tmrChip){
          todayChip.classList.remove('is-active');
          tmrChip.classList.add('is-active');
          // Re-run with new date · no longer today · all enabled
          setTimeout(applyTimeCutoffs, 30);
        }
      }
    }
    
    // 30-min slots (inside #slot30 · only visible when upgrade chosen)
    const slot30 = W.querySelector('#slot30');
    if(slot30 && slot30.style.display !== 'none'){
      const slots = Array.from(slot30.querySelectorAll('.hour'));
      slots.forEach(btn => {
        const start = parseSlotStart(btn.textContent);
        if(start) disableOrEnable(btn, start, nowM, today);
      });
    }
  }
  
  // Initial run
  applyTimeCutoffs();
  
  // Re-run when date chip changes
  W.querySelectorAll('.quick-row .quick').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 50));
  });
  // Re-run when category changes (in case 30min slots become visible)
  W.querySelectorAll('.time-cat, .upgrade').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 100));
  });
})();


// ─── PHASE 2 #1+#2: Cart submit + variant sync ───
(function(){
  const W = document.querySelector('.funeral-pdp-v2a-wrap');
  if(!W) return;
  const form = document.getElementById('v2a-funeral-form');
  if(!form) return;
  
  // Size variant sync: when user clicks size, update hidden variant id
  W.querySelectorAll('.size').forEach(btn => {
    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if(vid){
        const idInput = document.getElementById('v2a-variant-id');
        if(idInput) idInput.value = vid;
      }
    });
  });
  
  // On submit, gather all form state into hidden inputs
  form.addEventListener('submit', function(e){
    e.preventDefault();

    // ===== VALIDATION =====
    const errors = [];

    // 1. Size selected (Part 1)
    const sizeActive = W.querySelector('.size.is-active');
    if(!sizeActive) errors.push('請揀尺寸');

    // 2. Date selected (Part 2)
    const dateActive = W.querySelector('.quick-row .quick.is-active');
    if(!dateActive) errors.push('請揀送花日期');

    // 3. Time category selected (Part 2)
    const timeCatActive = W.querySelector('.time-cat.is-active');
    if(!timeCatActive) errors.push('請揀送花時段');

    // 4. 3hr Window selected (Part 2) — only required if active time-cat has .tl-windows panel
    let timeWinActive = null;
    if(timeCatActive){
      const winPanel = timeCatActive.querySelector('.tl-windows');
      if(winPanel){
        timeWinActive = winPanel.querySelector('.quick.is-active');
        if(!timeWinActive) errors.push('請揀送花時段內 window');
      } else {
        timeWinActive = timeCatActive; /* no sub-window needed */
      }
    }

    // 5. Venue name (Part 2)
    const venueSel = document.getElementById('venue-name');
    const venueName = venueSel?.value?.trim() || '';
    if(!venueName) errors.push('請填場所名稱');
    /* TFK 2026-08-25 · 其他場地：三格都要齊。⚠️ 地區冇揀就唔可以放行 —— 運費會計少咗。 */
    const vOptEl = venueSel && venueSel.options[venueSel.selectedIndex];
    const isOtherVenue = !!(vOptEl && vOptEl.dataset.zone === '0');
    const otherVenueName = (document.getElementById('in-venue-other')?.value||'').trim();
    const otherVenueAddr = (document.getElementById('in-venue-addr')?.value||'').trim();
    const otherVenueZone = (document.getElementById('in-venue-zone')?.value||'').trim();
    if(isOtherVenue){
      if(!otherVenueName) errors.push('請填場地名稱');
      if(!otherVenueAddr) errors.push('請填完整地址');
      if(!otherVenueZone) errors.push('請揀送貨地區（用嚟計運費）');
    }

    // 6. Phone (Part 2)
    const phoneIn = W.querySelector('input[type="tel"]');
    const phone = phoneIn?.value?.trim() || '';
    if(!phone) errors.push('請填訂花人電話');
    if(!(document.getElementById('in-orderer-name')?.value||'').trim()) errors.push('請填訂花人姓名');

    // 7. Relation (Part 3)
    const relSel = document.getElementById('in-relation');
    const relValue = relSel?.value || '';
    if(!relValue) errors.push('請揀與先人關係');

    /* TFK 2026-08-25 · 輓詞必揀。⚠️ 原本冇任何 validation 管呢格，
       全靠 state 預設「永遠懷念」頂住；拆咗預設就一定要補呢條，
       否則客人乜都唔揀，系統會靜靜哋幫佢揀「永遠懷念」印落花牌。 */
    if(!document.querySelector('.chip[data-p].is-active')) errors.push('請揀一個輓詞');

    // 8. Deceased name (Part 3)
    const name = document.getElementById('in-name')?.value?.trim() || '';
    if(!name) errors.push('請填先人名稱');

    // 9. Sender (Part 3) - must have at least primary
    const primaryRow = W.querySelector('.sender-row.primary') || W.querySelector('.sender-row');
    const primaryPrefix = primaryRow?.querySelector('.sender-prefix')?.value || '';
    const primaryName = primaryRow?.querySelector('.sender-name')?.value?.trim() || '';
    if(!primaryName) errors.push('請填送花人姓名');

    if(errors.length){
      showError(errors.join(' · '));
      // Scroll to first invalid - prefer date if missing, then relation
      const target = !dateActive ? W.querySelector('.quick-row')
                   : !timeWinActive ? (timeCatActive?.querySelector('.tl-windows') || timeCatActive)
                   : !venueName ? document.getElementById('venue-name')
                   : !phone ? phoneIn
                   : !relValue ? relSel
                   : !name ? document.getElementById('in-name')
                   : !primaryName ? primaryRow?.querySelector('.sender-name')
                   : null;
      if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }

    // ===== GATHER PROPERTIES =====
    try {
      const relText = relSel.options[relSel.selectedIndex]?.text || '';
      document.getElementById('prop-relation').value = relText;
      const m = relationMap[relValue] || {};
      const upperLine = ((m.title ? m.title + ' ' : '') + name + ' ' + (m.hon || '千古')).trim();
      document.getElementById('prop-upper').value = upperLine;

      const phraseEl = document.querySelector('.chip[data-p].is-active');
      const phrase = phraseEl?.dataset.p || '';   /* ⚠️ 唔可以有 fallback —— validation 已經擋住空白 */
      document.getElementById('prop-phrase').value = phrase;

      const senders = (typeof getSenders === 'function') ? sortSenders(getSenders()) : [];
      const firstLevel = senders.length ? (prefixLevel[senders[0].prefix] ?? 99) : 99;
      const senderLines = senders.map((s, idx) => {
        const dispP = (typeof applyRank === 'function') ? applyRank(s.prefix, s.rank) : s.prefix;
        const senderLevel = prefixLevel[s.prefix] ?? 99;
        const rate = (idx > 0 && senderLevel !== firstLevel) ? '率 ' : '';
        return (rate + dispP + ' ' + s.name).trim();
      });
      document.getElementById('prop-lower').value = senderLines.join(' · ');

      const suffix = document.getElementById('in-suffix')?.value || '敬輓';
      document.getElementById('prop-suffix-prop').value = suffix;

      var __dlabel = dateActive.textContent.trim().replace(/ · 製作來不及/, '');
      var __dd = dateActive.getAttribute('data-date'), __dreal = '';
      (function(){ function __p(n){return (n<10?'0':'')+n;} function __f(d){return d.getFullYear()+'-'+__p(d.getMonth()+1)+'-'+__p(d.getDate());} var __n=new Date(); if(__dd==='today'){__dreal=__f(__n);} else if(__dd==='tomorrow'){__n.setDate(__n.getDate()+1);__dreal=__f(__n);} else if(__dd==='day-after'){__n.setDate(__n.getDate()+2);__dreal=__f(__n);} else if(__dd==='custom'){var __tg=document.getElementById('custom-date-trigger'); var __m=__tg&&__tg.textContent.match(/(\d{4})-(\d{2})-(\d{2})/); if(__m){__dreal=__m[0];} else { var __pd=document.getElementById('prop-date'); var __m2=__pd&&String(__pd.value).match(/(\d{4})-(\d{2})-(\d{2})/); if(__m2){__dreal=__m2[0];} } } })();
      document.getElementById('prop-date').value = (__dreal && __dlabel.indexOf(__dreal) < 0) ? (__dlabel + '（' + __dreal + '）') : (__dreal || __dlabel);
      var __tcEl=timeCatActive,__cn=__tcEl.querySelector('.cn'),__en=__tcEl.querySelector('.en'),__lbl=((__cn?__cn.textContent.trim():'')+(__en?' '+__en.textContent.trim():'')).trim(); document.getElementById('prop-time-cat').value = __lbl || timeCatActive.textContent.trim();
      document.getElementById('prop-time-win').value = timeWinActive.textContent.trim().replace(/ · 製作來不及/, '');

      const time30Active = W.querySelector('.hour.is-active');
      document.getElementById('prop-time-30').value = time30Active?.textContent.trim() || '';
      const upgradeActive = W.querySelector('.upgrade.is-active');
      document.getElementById('prop-upgrade').value = upgradeActive?.querySelector('.cn')?.textContent.trim() || '';

      const venueTypeSel = W.querySelectorAll('.sub-block select.uline')[0];
      document.getElementById('prop-venue-type').value = venueTypeSel?.value || '';
      /* 其他場地 → 名 + 地址 + 地區 一齊寫入現有 property，唔另開新 property，
         咁購物車顯示／結帳預填／後台全部唔使改。 */
      document.getElementById('prop-venue-name').value = isOtherVenue
        ? (otherVenueName + ' · ' + otherVenueAddr + '（' + otherVenueZone + '）')
        : venueName;
      const floorIn = W.querySelector('#in-floor');
      document.getElementById('prop-floor').value = floorIn?.value || '';
      const hallIn = W.querySelector('#in-hall');
      document.getElementById('prop-hall').value = hallIn?.value || '';
      document.getElementById('prop-phone').value = phone;
      document.getElementById('prop-orderer-name').value = (document.getElementById('in-orderer-name')?.value||'').trim();

      const params = new URLSearchParams({
        reltitle: m.title || '',
        name: name,
        hon: m.hon || '千古',
        phrase: phrase,
        senders: JSON.stringify(senders.map(s => ({prefix: applyRank(s.prefix, s.rank), name: s.name, level: prefixLevel[s.prefix] ?? 99}))),
        suffix: suffix,
      });
      document.getElementById('prop-print-url').value = location.origin + '/pages/funeral-print?' + params.toString();
    } catch(err){
      console.error('V2A property gather error:', err);
      showError('資料整理出錯：' + err.message);
      return;
    }

    // ===== AJAX SUBMIT TO /cart/add.js =====
    const ctaBtn = form.querySelector('.cta');
    if(ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.6'; }

    if(typeof window.__tfkSnapOrder==='function') window.__tfkSnapOrder();
    const properties = {};
    form.querySelectorAll('input[name^="properties"]').forEach(inp => {
      const key = inp.name.match(/\[(.+)\]/)?.[1];
      if(key && inp.value) properties[key] = inp.value;
    });

    /* TFK 2026-08-24 · 白事時段／升級附加費真收（修 #2901 特早 +$200 收唔到）
       跟花籃做法：附加費 = 「升級服務」產品嘅獨立 line item，唔改主商品價。 */
    var TFK_SUR = {early:'53973973172408', evening:'53459121471672', late:'53459121504440',
                   exact30:'53459063177400', urgent:'53459063210168'};
    var TFK_SUR_ALL = ['53973973172408','53459121438904','53459121471672','53459121504440',
                       '53459063177400','53459063210168'];
    var _items = [{ id: document.getElementById('v2a-variant-id').value, quantity: 1, properties: properties }];
    try {
      var _tc = document.querySelector('.time-cats .time-cat.is-active');
      if(_tc && !_tc.classList.contains('is-disabled')){
        var _fe = _tc.querySelector('.tl-fee'), _dc = _tc.getAttribute('data-cat');
        if(_fe && !_fe.classList.contains('tl-free') && !_fe.classList.contains('free') && TFK_SUR[_dc]){
          _items.push({ id: Number(TFK_SUR[_dc]), quantity: 1,
            properties: {'附加於': '本訂單 · ' + (((_tc.querySelector('.cn')||{}).textContent)||'').trim() + '時段'} });
        }
      }
      var _up = document.querySelector('.upgrade.is-active');
      if(_up){
        var _uk = _up.getAttribute('data-upgrade');
        if(TFK_SUR[_uk]) _items.push({ id: Number(TFK_SUR[_uk]), quantity: 1,
          properties: {'附加於': '本訂單 · ' + (((_up.querySelector('.cn')||{}).textContent)||'').trim()} });
      }
    } catch(_se){ console.error('TFK surcharge build error', _se); }

    var _editKey=window.__tfkEditKey||null;
    window.TFKCartGroups.add(_items,_editKey)
    .then(data => {
      showSuccess();
      /* TFK 2026-08 送貨區 → cart attribute（畀 checkout Delivery Customization 用） */
      /* ⚠️ TFK 2026-08-25 · 唔可以再直接讀 venue-name 個 option 嘅 data-zone ——
         「其他場地」嗰個 option data-zone="0"，會令真收費嗰層當免運費。
         一定要行 tfkCurrentZone()（其他場地會攞返地區 select 嘅 zone）。 */
      try{ var __z='';
        try{ __z = String((window.tfkCurrentZone&&window.tfkCurrentZone())||''); }catch(_e1){
          var __vn=document.getElementById('venue-name');
          if(__vn && __vn.tagName==='SELECT'){ var __o=__vn.options[__vn.selectedIndex]; __z=(__o&&__o.dataset&&__o.dataset.zone)?String(__o.dataset.zone):''; }
        }
        if(__z && __z!=='0'){ fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'zone':__z}})}); }
      }catch(_z){}
      window.__tfkEditKey=null;
      location.href='/cart';
    })
    .catch(err => {
      console.error('Cart add error:', err);
      showError('加入購物車失敗：' + (err.description || err.message || '請再試一次'));
      if(ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = '1'; }
    });
  });

  // ===== ANIMATION HELPERS =====
  function showSuccess(){
    let overlay = document.querySelector('.v2a-cart-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'v2a-cart-overlay';
      overlay.innerHTML = '<div class="v2a-cart-card"><div class="v2a-cart-check"><svg viewBox="0 0 24 24"><polyline points="4,12 10,18 20,6"/></svg></div><h3 class="v2a-cart-title">已加入購物車</h3><p class="v2a-cart-sub">Added to cart<br/>正在前往結算頁面…</p></div>';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function showError(msg){
    let bar = document.querySelector('.v2a-cart-error');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'v2a-cart-error';
      document.body.appendChild(bar);
    }
    bar.textContent = '⚠ ' + msg;
    bar.classList.add('is-visible');
    clearTimeout(bar._t);
    bar._t = setTimeout(() => bar.classList.remove('is-visible'), 5000);
  }
})();


// ─── PHASE-MEANING fly-in animation hook ───
(function(){
  const pm = document.getElementById('phrase-meaning');
  if(!pm) return;
  const wrap = pm.closest('.funeral-pdp-v2a-wrap') || document;
  wrap.addEventListener('click', function(e){
    const chip = e.target.closest('.chip[data-p]');
    if(!chip) return;
    // Re-trigger animation by toggling class
    pm.classList.remove('is-flying');
    void pm.offsetWidth; // force reflow
    pm.classList.add('is-flying');
  });
})();

// ─── SUFFIX auto-fill flash animation ───
(function(){
  const inRel2 = document.getElementById('in-relation');
  const inSuf = document.getElementById('in-suffix');
  if(!inRel2 || !inSuf) return;
  inRel2.addEventListener('change', () => {
    setTimeout(() => {
      inSuf.classList.remove('is-autofilled');
      void inSuf.offsetWidth;
      inSuf.classList.add('is-autofilled');
    }, 50);
  });
})();


// (move-windows IIFE removed: pools now inlined inside time-cats)

// ─── DEFENSIVE event delegation · ensures click always works for time-cat / quick / hour ───
(function(){
  const W = document.querySelector('.funeral-pdp-v2a-wrap');
  if(!W) return;
  W.addEventListener('click', function(e){
    const btn = e.target.closest('.time-cat, .quick, .hour');
    if(!btn) return;
    if(btn.classList.contains('is-disabled')) return;
    // Get peers within same parent container
    const parent = btn.parentElement;
    if(!parent) return;
    // For .time-cat: peers are other .time-cat siblings (don't toggle nested .quick descendants)
    let peers;
    if(btn.classList.contains('time-cat')){
      peers = parent.querySelectorAll(':scope > .time-cat');
    } else if(btn.classList.contains('quick')){
      peers = parent.querySelectorAll(':scope > .quick');
    } else if(btn.classList.contains('hour')){
      peers = parent.querySelectorAll(':scope > .hour');
    }
    if(!peers) return;
    peers.forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true); // capture phase so we win over any broken listeners
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funeral-pdp-v2b"] && !Shopify.designMode) return;
  try {
    
// ─── RELATION MAP (上聯稱謂 + 敬稱 + 下款前綴 + 後綴) ───
const relationMap = {
  '父親':{title:'父親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '母親':{title:'母親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '丈夫':{title:'夫君大人',hon:'千古',prefix:'妻',suffix:'哀輓'},
  '妻子':{title:'賢妻',hon:'千古',prefix:'夫',suffix:'哀輓'},
  '兄':{title:'胞兄大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '弟':{title:'賢弟',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '姊':{title:'胞姊大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '妹':{title:'賢妹',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '家翁':{title:'家翁大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '家姑':{title:'家姑大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '岳父':{title:'岳父大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '岳母':{title:'岳母大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '伯父':{title:'伯父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '叔父':{title:'叔父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '伯娘':{title:'伯娘',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑姐':{title:'姑媽',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑丈':{title:'姑丈',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '舅父':{title:'舅父大人',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '舅母':{title:'舅母',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨媽':{title:'姨媽',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨丈':{title:'姨丈',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '祖父':{title:'祖父大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '祖母':{title:'祖母大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '外祖父':{title:'外祖父大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '外祖母':{title:'外祖母大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '朋友男':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '朋友女':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '同事男':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '同事女':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '公司':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '教會弟兄':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '教會姊妹':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '子姪男':{title:'賢姪',hon:'千古',prefix:'',suffix:'痛輓'},
  '子姪女':{title:'賢姪女',hon:'千古',prefix:'',suffix:'痛輓'},
};

// ─── RELATION → 先人 GENDER (auto-derived · no need to ask) ───
const relationGender = {
  '父親':'M','母親':'F','丈夫':'M','妻子':'F',
  '兄':'M','弟':'M','姊':'F','妹':'F',
  '家翁':'M','家姑':'F','岳父':'M','岳母':'F',
  '伯父':'M','叔父':'M','伯娘':'F','姑姐':'F','姑丈':'M',
  '舅父':'M','舅母':'F','姨媽':'F','姨丈':'M',
  '祖父':'M','祖母':'F','外祖父':'M','外祖母':'F',
  '表兄弟':'M','表姊妹':'F','姐夫':'M',
  '朋友男':'M','朋友女':'F','同事男':'M','同事女':'F',
  '公司':'M','教會弟兄':'M','教會姊妹':'F',
  '子姪男':'M','子姪女':'F',
};

// ─── PREFIX 輩分 LEVEL (for 率字 conditional + sort) ───
// 0 = 同輩 / 配偶 · 1 = 子女 / 姪 / 外甥 / 表 · 2 = 孫 · 3 = 曾孫 · 4 = 玄孫
const prefixLevel = {
  '妻':0,'夫':0,
  '胞兄':0,'胞弟':0,'胞姊':0,'胞妹':0,
  '孝子':1,'孝女':1,'孝媳':1,'孝婿':1,
  '姪':1,'姪女':1,'外甥':1,'外甥女':1,
  '表兄':1,'表弟':1,'表姊':1,'表妹':1,
  '孫男':2,'孫女':2,'外孫男':2,'外孫女':2,
  '孝孫':2,'孝孫女':2,'孝外孫':2,'孝外孫女':2,
  '姪孫':2,'姪孫女':2,'外甥孫':2,'外甥孫女':2,
  '表姪':2,'表姪女':2,
  '曾孫男':3,'曾孫女':3,'外曾孫男':3,'外曾孫女':3,
  '姪曾孫':3,'姪曾孫女':3,
  '玄孫男':4,'玄孫女':4,
};

// ─── PREFIXES 支持排行 (Rank splice insertion · 孝子 + 長 → 孝長子) ───
const rankableSet = new Set(['孝子','孝女','孝媳','孝婿','孝孫','孝孫女','孝外孫','孝外孫女']);
function applyRank(prefix, rank){
  if(!rank||!rankableSet.has(prefix))return prefix;
  // 「孝子」(2 chars) → 孝[rank]子 ; 「孝孫女」(3 chars) → 孝[rank]孫女
  return prefix[0]+rank+prefix.slice(1);
}

// ─── GENDER from prefix (for sort: 男先女後) ───
function prefixGender(p){
  if(/(妻|女|媳|姊|妹|姪女|甥女|孫女|曾孫女|玄孫女|姪曾孫女|外甥孫女|姪孫女)/.test(p))return 1;
  return 0;
}
const rankOrder={'長':1,'次':2,'三':3,'四':4,'五':5,'六':6,'':7};

// ─── PHRASE DATA · BY RELIGION + GENDER (re-categorized per HK funeral tradition) ───
const phrases = {
  '通用': {
    neutral: ['永遠懷念','沈痛悼念','千古不朽','一路好走','駕鶴西歸','福壽全歸','哀思永念','風範長存'],
    male: ['典範長存','德澤永存','英名永存','浩氣長存','流芳百世','萬古流芳','英靈不泯','典型猶存'],
    female: ['母儀千古','懿範永存','慈暉永昭','音容宛在','音容宛存','寶婺光寒','慈雲歸西','慈竹風悲'],
  },
  '佛教': {
    neutral: ['蓮邦極樂','往生極樂','西方接引','倒駕慈航','早登蓮邦','同登彼岸','早歸極樂','蓮座飄香'],
    male: [],
    female: [],
  },
  '基督教': {
    neutral: ['主懷安息','蒙主恩召','安息主懷','永居天家','平安歸主','主賜安寧','永生安息','在主裡睡了'],
    male: [],
    female: [],
  },
  '天主教': {
    neutral: ['蒙主寵召','永享主光','安息天國','復活享福','永享天國','諸聖之福'],
    male: [],
    female: [],
  },
};

// ─── PHRASE EXPLANATIONS ───
const phraseExplain = {
  '永遠懷念':'長存於心的思念 · 最普世的悼念詞 · 適用所有親疏關係',
  '沈痛悼念':'表達深切哀痛之意 · 適用所有關係',
  '千古不朽':'永世長存 · 永不磨滅 · 中性通用',
  '一路好走':'願先人一路平安 · 口語親切 · 中性通用',
  '駕鶴西歸':'仙鶴載歸西方 · 典雅 · 適合長者善終',
  '福壽全歸':'福分壽命圓滿 · 適合高壽善終',
  '哀思永念':'哀痛思念永遠長存',
  '風範長存':'先人風範永存後人心中',
  '典範長存':'先人風範永存 · 多用於男性長輩',
  '德澤永存':'恩德與蔭澤永遠存在 · 適合男性',
  '英名永存':'英明事跡永誌不忘 · 適合男性 / 英雄人物',
  '浩氣長存':'浩然正氣永存 · 適合公職 / 英烈男性',
  '流芳百世':'美好聲名流傳百世 · 多用於男性',
  '萬古流芳':'美名永遠流傳 · 多用於男性',
  '英靈不泯':'英魂永不磨滅 · 適合男性',
  '典型猶存':'典範樣本尚存 · 適合男性長輩',
  '母儀千古':'慈母典範永流傳 · 適合母親',
  '懿範永存':'美好德行典範永存 · 適合女性長輩',
  '慈暉永昭':'慈愛光輝永遠照耀 · 適合母親',
  '音容宛在':'容貌聲音猶如尚存 · 傳統用於女性 · 形容深切思念',
  '音容宛存':'容貌音聲尚在 · 女性異體',
  '寶婺光寒':'婺女星（女性星宿）光暗 · 形容德高女性離世',
  '慈雲歸西':'慈愛之雲歸西 · 適合女性長輩',
  '慈竹風悲':'慈母如竹 · 風中悲傷 · 適合母親',
  '蓮邦極樂':'蓮邦即西方極樂淨土',
  '往生極樂':'往生阿彌陀佛西方極樂世界',
  '西方接引':'阿彌陀佛接引往西方淨土',
  '倒駕慈航':'已脫生死返回度化眾生',
  '早登蓮邦':'早日登入極樂蓮花世界',
  '同登彼岸':'共同到達覺悟彼岸',
  '早歸極樂':'早日歸於極樂淨土',
  '蓮座飄香':'蓮花座發出芬芳',
  '主懷安息':'安睡在主懷抱',
  '蒙主恩召':'蒙主慈愛召喚回天家',
  '安息主懷':'安睡在主懷抱',
  '永居天家':'永遠居住天國家中',
  '平安歸主':'安然回歸主裡',
  '主賜安寧':'主賜予永遠安寧',
  '永生安息':'永恆生命中的安息',
  '在主裡睡了':'聖經用語 · 指逝世（哥前 15:18）',
  '蒙主寵召':'蒙主寵愛召喚回天家',
  '永享主光':'永遠享有主的榮光',
  '安息天國':'在天國中安息',
  '復活享福':'復活並享永福',
  '永享天國':'永遠享有天國之福',
  '諸聖之福':'與諸聖一同享福',
};

// ─── REFS ───
const banner=document.querySelector('.banner-canvas');
const bp=document.getElementById('bp-phrase');
const bpReltitle=document.getElementById('bp-reltitle'),bpName=document.getElementById('bp-name'),bpHon=document.getElementById('bp-hon');
const bpSenders=document.getElementById('bp-senders'),bpSuffix=document.getElementById('bp-suffix');
const inRel=document.getElementById('in-relation'),inName=document.getElementById('in-name'),inGender=document.getElementById('in-gender'),inSuffix=document.getElementById('in-suffix');
const sendersGroup=document.getElementById('senders-group'),addSenderBtn=document.getElementById('add-sender');
const autoHint=document.getElementById('auto-hint'),autoHintText=document.getElementById('auto-hint-text');
const chipContainer=document.getElementById('chip-container'),chipSuggested=document.getElementById('chip-suggested');
const pmPhrase=document.getElementById('pm-phrase'),pmText=document.getElementById('pm-text');
const slot30=document.getElementById('slot30');
const priceDisp=document.getElementById('price-display'),priceSize=document.getElementById('price-size');
const sumSize=document.getElementById('sum-size'),sumFlower=document.getElementById('sum-flower'),sumZone=document.getElementById('sum-zone'),sumShip=document.getElementById('sum-ship'),sumUpLabel=document.getElementById('sum-up-label'),sumUp=document.getElementById('sum-up'),sumTotal=document.getElementById('sum-total');
const zoneName=document.getElementById('zone-name'),zoneFee=document.getElementById('zone-fee'),venueName=document.getElementById('venue-name');

const state={flower:950,sizeLabel:'中 M · 高 55 cm',ship:0,shipLabel:'免費',upLabel:'—',up:0,religion:'通用',gender:'M',activePhrase:'永遠懷念'};
function recalc(){
  const t=state.flower+state.ship+state.up;
  sumSize.textContent=state.sizeLabel;sumFlower.textContent=`HK$${state.flower.toLocaleString()}`;
  sumShip.textContent=state.shipLabel;sumUpLabel.textContent=state.upLabel;sumUp.textContent=state.up?`HK$${state.up}`:'—';
  sumTotal.textContent=`HK$${t.toLocaleString()}`;
}

// ─── SIZE (skip bouquet multi-option .opt-btn · Gary 2026-05-27) ───
document.querySelectorAll('.size').forEach(s=>s.addEventListener('click',()=>{
  if(s.hasAttribute('data-opt-value')) return;
  const grid=s.parentElement;
  if(grid) grid.querySelectorAll('.size').forEach(x=>x.classList.remove('is-active'));s.classList.add('is-active');
  const p=+s.dataset.price;state.flower=p;
  state.sizeLabel=s.querySelector('.cn').textContent+' '+s.querySelector('.en').textContent.charAt(0)+' · '+s.querySelector('.h').textContent;
  priceDisp.textContent='HK$'+p.toLocaleString();priceSize.textContent=s.dataset.cn;recalc();
}));

// ─── ZONE ───
const zoneFees={1:[0,'免費','Zone 1 · 港島 + 九龍','Same-day standard'],2:[150,'HK$150','Zone 2 · 新界主區','New Territories'],3:[250,'HK$250','Zone 3 · 新界遠郊 + 離島','Outer NT / islands']};
venueName.addEventListener('change',()=>{
  const z=+venueName.options[venueName.selectedIndex].dataset.zone||1;
  const [fee,feeLabel,zname,zsub]=zoneFees[z];
  state.ship=fee;state.shipLabel=feeLabel;
  zoneName.innerHTML=zname+' <em>'+zsub+'</em>';zoneFee.textContent=feeLabel+(fee===0?' · Free':'');
  zoneFee.classList.toggle('free',fee===0);sumZone.textContent=zname;recalc();
});

// ─── UPGRADE ───
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',()=>{
  if(u.classList.contains('is-active')){u.classList.remove('is-active');state.up=0;state.upLabel='—';}
  else{document.querySelectorAll('.upgrade').forEach(x=>x.classList.remove('is-active'));u.classList.add('is-active');state.up=+u.dataset.fee;state.upLabel=u.querySelector('.cn').textContent;}
  recalc();
}));

// ─── TIME selectors ───
document.querySelectorAll('.quick,.time-cat,.hour').forEach(b=>b.addEventListener('click',()=>{
  if(b.classList.contains('is-disabled'))return;
  const peers=b.parentElement.querySelectorAll('.quick,.time-cat,.hour');
  peers.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
}));

// ─── BANNER sync (4-line · multi-sender · auto-shrink · 「同」connector) ───
function getSenders(){
  return Array.from(sendersGroup.querySelectorAll('.sender-row')).map(row=>({
    prefix:row.querySelector('.sender-prefix').value,
    rank:row.querySelector('.sender-rank')?.value||'',
    name:row.querySelector('.sender-name').value.trim(),
  })).filter(s=>s.name||s.prefix);
}

// Sort senders by (level ASC · gender 男先女後 · 排行 長次三...)
function sortSenders(senders){
  return senders.slice().sort((a,b)=>{
    const la=prefixLevel[a.prefix]??99, lb=prefixLevel[b.prefix]??99;
    if(la!==lb)return la-lb;
    const ga=prefixGender(a.prefix),gb=prefixGender(b.prefix);
    if(ga!==gb)return ga-gb;
    return (rankOrder[a.rank]||7)-(rankOrder[b.rank]||7);
  });
}

function syncBanner(){
  const m=relationMap[inRel.value];
  bpReltitle.textContent=m?.title?m.title:'';
  bpName.textContent=inName.value||'先人名稱';
  bpHon.textContent=m?.hon||'千古';

  // build sender lines · auto-sort by (level/gender/rank) · 率字只用喺不同輩
  const rawSenders=getSenders();
  const senders=sortSenders(rawSenders);
  bpSenders.innerHTML='';
  if(senders.length===0){
    bpSenders.innerHTML=`<div class="bnr-sender"><span class="sname" style="color:var(--muted)">送花人名稱</span></div>`;
  }else{
    const firstLevel=prefixLevel[senders[0].prefix]??99;
    senders.forEach((s,idx)=>{
      const div=document.createElement('div');
      div.className='bnr-sender';
      // Apply rank splice (孝子 + 長 → 孝長子)
      const displayPrefix=applyRank(s.prefix,s.rank);
      const senderLevel=prefixLevel[s.prefix]??99;
      // 「率」字只喺不同輩時加（同輩 e.g. 孝子+孝女 唔加）
      const rate=(idx>0&&senderLevel!==firstLevel)?`<span class="srate">率</span>`:'';
      const px=displayPrefix?`<span class="sprefix">${displayPrefix}</span>`:'';
      const nm=`<span class="sname">${s.name||'（未填名稱）'}</span>`;
      div.innerHTML=rate+px+nm;
      bpSenders.appendChild(div);
    });
  }
  // suffix · 跟舊設計 · 唔自動加「同」字
  bpSuffix.textContent=inSuffix.value;

  autoShrink();
}

// ─── AUTO-SHRINK + LINE 1 AUTO-FIT TO WIDTH (per Gary · 從左到右最大) ───
function autoShrink(){
  const senderCount=Math.max(1,getSenders().length);
  let scale=1;
  if(senderCount>=5)scale=.62;
  else if(senderCount===4)scale=.72;
  else if(senderCount===3)scale=.82;
  else if(senderCount===2)scale=.92;
  // suffix penalty
  const suffixLen=bpSuffix.textContent.length;
  let l4Scale=scale;
  if(suffixLen>=4)l4Scale*=.92;

  // Line 1 base = 15cqw (BIG · fills width by default · scales down via overflow detection)
  const L1_MAX=15;
  banner.style.setProperty('--l1',`${L1_MAX}cqw`);
  banner.style.setProperty('--l2',`${17*scale}cqw`);
  banner.style.setProperty('--l3',`${8*scale}cqw`);
  banner.style.setProperty('--l4',`${6*l4Scale}cqw`);
  banner.style.setProperty('--gap',`${2.5*scale}cqw`);

  // FIT-TO-WIDTH for Line 1 via BINARY SEARCH (deterministic · precise)
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    const cw=banner.clientWidth;
    if(cw<10)return;
    const availW=cw*0.84; // 84% safety margin
    const l1El=document.querySelector('.bnr-line1');
    const l2El=bp;
    const l3Els=Array.from(bpSenders.querySelectorAll('.bnr-sender'));
    const l4El=bpSuffix;

    // Line 1: BINARY SEARCH for largest font-size that fits availW
    let lo=3,hi=L1_MAX,best=3;
    for(let i=0;i<10;i++){
      const mid=(lo+hi)/2;
      banner.style.setProperty('--l1',`${mid}cqw`);
      void l1El.offsetWidth; // force reflow
      if(l1El.scrollWidth<=availW){best=mid;lo=mid;}
      else{hi=mid;}
    }
    banner.style.setProperty('--l1',`${best}cqw`);

    // Other lines: overflow shrink only
    let furtherL2=1,furtherL3=1,furtherL4=1;
    if(l2El.scrollWidth>availW)furtherL2=Math.max(.55,availW/l2El.scrollWidth);
    l3Els.forEach(e=>{if(e.scrollWidth>availW){furtherL3=Math.min(furtherL3,Math.max(.55,availW/e.scrollWidth));}});
    if(l4El.scrollWidth>availW)furtherL4=Math.max(.55,availW/l4El.scrollWidth);
    if(furtherL2<1)banner.style.setProperty('--l2',`${17*scale*furtherL2}cqw`);
    if(furtherL3<1)banner.style.setProperty('--l3',`${8*scale*furtherL3}cqw`);
    if(furtherL4<1)banner.style.setProperty('--l4',`${6*l4Scale*furtherL4}cqw`);
    const overflowReduced=Math.min(furtherL2,furtherL3,furtherL4);
    updateShrinkBadge(scale,overflowReduced);
  }));

  function updateShrinkBadge(senderScale,overflowScale){
    const tag=document.querySelector('.preview-foot .shrink-tag');
    const totalScale=senderScale*overflowScale;
    if(totalScale<.99){
      let label=`Auto-shrink ${Math.round(totalScale*100)}%`;
      if(overflowScale<.99 && senderScale<.99)label+=' (多人+名長)';
      else if(overflowScale<.99)label+=' (字過長)';
      else label+=` (${getSenders().length} 位送花人)`;
      if(!tag){
        const t=document.createElement('span');t.className='shrink-tag';t.textContent=label;
        document.querySelector('.preview-foot').appendChild(t);
      }else{tag.textContent=label;}
    }else if(tag){tag.remove();}
  }
}

// ─── BANNER input listeners ───
inName.addEventListener('input',syncBanner);
inSuffix.addEventListener('change',syncBanner);
sendersGroup.addEventListener('input',syncBanner);
sendersGroup.addEventListener('change',syncBanner);

// ─── RELATION → ALLOWED SENDER CATEGORIES (filter add-sender prefix list) ───
// Each relation → which prefix optgroup labels are allowed for ADDITIONAL senders
const relSenderCats = {
  // 父母 / 公婆 / 岳父母 — 喪偶/子女/孫一齊送
  '父親':['子女輩','孫輩','曾孫 / 玄孫'],
  '母親':['子女輩','孫輩','曾孫 / 玄孫'],
  '家翁':['子女輩','孫輩'],
  '家姑':['子女輩','孫輩'],
  '岳父':['子女輩','孫輩'],
  '岳母':['子女輩','孫輩'],
  // 夫妻 — 主要係妻/夫單獨送 + 可能子女合送
  '丈夫':['子女輩','孫輩'],
  '妻子':['子女輩','孫輩'],
  // 兄弟姊妹 — 同輩 + 姪輩
  '兄':['兄弟姊妹','父系姪輩'],
  '弟':['兄弟姊妹','父系姪輩'],
  '姊':['兄弟姊妹','父系姪輩'],
  '妹':['兄弟姊妹','父系姪輩'],
  // 親戚長輩 父系 → 姪輩
  '伯父':['父系姪輩'],
  '叔父':['父系姪輩'],
  '伯娘':['父系姪輩'],
  '姑姐':['父系姪輩'],
  '姑丈':['父系姪輩'],
  // 親戚長輩 母系 → 外甥輩
  '舅父':['母系外甥輩'],
  '舅母':['母系外甥輩'],
  '姨媽':['母系外甥輩'],
  '姨丈':['母系外甥輩'],
  // 祖父母 → 孫 + 曾孫 + 率字
  '祖父':['孫輩','曾孫 / 玄孫'],
  '祖母':['孫輩','曾孫 / 玄孫'],
  '外祖父':['孫輩','曾孫 / 玄孫'],
  '外祖母':['孫輩','曾孫 / 玄孫'],
  // 表親
  '表兄弟':['表親'],
  '表姊妹':['表親'],
  '姐夫':['表親'],
  // 朋友 / 同事 / 公司 — 純名字 · 唔需 prefix
  '朋友男':[],
  '朋友女':[],
  '同事男':[],
  '同事女':[],
  '公司':[],
  '教會弟兄':[],
  '教會姊妹':[],
  // 長輩送晚輩
  '子姪男':[],
  '子姪女':[],
};

// Build filtered prefix select HTML based on relation
function buildPrefixSelectHTML(relation, includeBlank=true){
  const allowedCats=relSenderCats[relation];
  // If no relation set or no restriction: return full list
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  let html='';
  if(includeBlank){
    html+=`<option value="">（無前綴）</option>`;
    html+=`<option value="（不指定排行）">（不指定排行）</option>`;
  }
  if(!relation||!allowedCats||allowedCats.length===0){
    // No relation: show all categories (full list as before)
    return primary.innerHTML; // fall back to primary's full list
  }
  // Otherwise reconstruct from full list filtering optgroups by label
  const fullOpts=primary.querySelectorAll('optgroup');
  fullOpts.forEach(og=>{
    if(allowedCats.includes(og.label)){
      html+=`<optgroup label="${og.label}">`;
      og.querySelectorAll('option').forEach(o=>html+=`<option value="${o.value}">${o.textContent}</option>`);
      html+=`</optgroup>`;
    }
  });
  return html;
}

// ─── MULTI-SENDER add / remove ───
const rankOptsHTML=`<option value="">不指定</option><option value="長">長</option><option value="次">次</option><option value="三">三</option><option value="四">四</option><option value="五">五</option><option value="六">六</option>`;

function addSenderRow(prefix='',name='',rank=''){
  const row=document.createElement('div');
  row.className='sender-row';
  const opts=buildPrefixSelectHTML(inRel.value,true);
  row.innerHTML=`
    <div>
      <span class="sender-row-label">前綴</span>
      <select class="uline sender-prefix">${opts}</select>
    </div>
    <div>
      <span class="sender-row-label">排行</span>
      <select class="uline sender-rank">${rankOptsHTML}</select>
    </div>
    <div>
      <span class="sender-row-label">姓名 / 公司</span>
      <input class="uline sender-name" placeholder="例：陳小明" />
    </div>
    <button class="remove" type="button">×</button>
  `;
  sendersGroup.appendChild(row);
  if(prefix)row.querySelector('.sender-prefix').value=prefix;
  if(rank)row.querySelector('.sender-rank').value=rank;
  if(name)row.querySelector('.sender-name').value=name;
  row.querySelector('.remove').addEventListener('click',()=>{row.remove();syncBanner();updateAddSenderHint();});
  // disable rank dropdown if prefix doesn't support
  updateRowRankAvailability(row);
  syncBanner();
  updateAddSenderHint();
}

function updateRowRankAvailability(row){
  const sel=row.querySelector('.sender-prefix');
  const rank=row.querySelector('.sender-rank');
  if(!rank)return;
  if(!rankableSet.has(sel.value)){
    rank.value='';
    rank.classList.add('is-disabled');
    rank.title='此前綴不支持排行（長/次/三...）';
  }else{
    rank.classList.remove('is-disabled');
    rank.title='';
  }
}

sendersGroup.addEventListener('change',e=>{
  if(e.target.classList.contains('sender-prefix')){
    updateRowRankAvailability(e.target.closest('.sender-row'));
  }
});
addSenderBtn.addEventListener('click',()=>addSenderRow());
sendersGroup.querySelector('.sender-row.primary .remove').addEventListener('click',()=>{});

// ─── Add-sender hint message (relation-aware) ───
function updateAddSenderHint(){
  const v=inRel.value;
  let oldHint=document.getElementById('add-sender-hint');
  if(oldHint)oldHint.remove();
  if(!v)return;
  const cats=relSenderCats[v]||[];
  const senderCount=getSenders().length;
  let msg='',color='var(--muted)';
  if(v==='丈夫'||v==='妻子'){
    msg=`💡 夫妻互送一般係 1 位送花人（${v==='丈夫'?'妻':'夫'}）獨送 · 若子女合送可加多人`;
    color='var(--gold-deep)';
  }else if(cats.length===0){
    msg=`💡 朋友 / 同事 / 公司一般唔需要送花人前綴 · 直接輸入姓名 / 公司名`;
    color='var(--gold-deep)';
  }else{
    msg=`💡 揀「${inRel.options[inRel.selectedIndex].text}」· 可加 ${cats.join(' / ')} 嘅親屬合送`;
  }
  const hint=document.createElement('div');hint.id='add-sender-hint';
  hint.style.cssText=`font-family:var(--cjk);font-size:12px;color:${color};letter-spacing:.06em;margin-top:8px;padding:8px 12px;background:rgba(184,153,104,.08);border-left:2px solid var(--gold);line-height:1.6`;
  hint.textContent=msg;
  addSenderBtn.insertAdjacentElement('afterend',hint);
}

// Update primary sender prefix list + all secondary rows when relation changes
function syncAllPrefixLists(){
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  const primaryVal=primary.value;
  // Primary: keep full list (relation auto-fills its value)
  // Secondary rows: filter by relation
  Array.from(sendersGroup.querySelectorAll('.sender-row')).forEach((row,i)=>{
    if(i===0)return; // primary
    const sel=row.querySelector('.sender-prefix');
    const oldVal=sel.value;
    sel.innerHTML=buildPrefixSelectHTML(inRel.value,true);
    sel.value=oldVal;
  });
}
inRel.addEventListener('change',()=>{syncAllPrefixLists();updateAddSenderHint();});

// ─── RELATION → AUTO-FILL 上聯 + 主送花人前綴 + 後綴 + DERIVED GENDER ───
inRel.addEventListener('change',()=>{
  const v=inRel.value;
  // auto-derive gender + update derived gender badge + re-filter 輓詞 chips
  if(v && relationGender[v]){
    const g=relationGender[v];
    document.getElementById('in-gender').value=g;
    state.gender=g;
    const dg=document.getElementById('derived-gender');
    if(dg){
      const gLabel=g==='M'?'男 ♂':'女 ♀';
      dg.textContent=gLabel+'（由關係推導）';
      dg.style.color=g==='M'?'var(--male)':'var(--female)';
      dg.style.borderColor=g==='M'?'var(--male)':'var(--female)';
    }
    renderChips();
  }
  if(!v||!relationMap[v]){autoHint.style.display='none';syncBanner();return;}
  const m=relationMap[v];
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  primaryPrefix.value=m.prefix||'';
  inSuffix.value=m.suffix;
  // update primary row rank availability
  updateRowRankAvailability(sendersGroup.querySelector('.sender-row.primary'));
  syncBanner();
  autoHint.style.display='block';
  let txt=`揀「${inRel.options[inRel.selectedIndex].text}」 → 已自動填：<br/>`;
  if(m.title)txt+=`• 上聯稱謂：<span class="tag">${m.title}</span> + 先人名 + 敬稱 <span class="tag">${m.hon}</span><br/>`;
  else txt+=`• 上聯：（先人名）+ 敬稱 <span class="tag">${m.hon}</span><br/>`;
  if(m.prefix)txt+=`• 主送花人前綴：<span class="tag">${m.prefix}</span>`;
  if(m.altPrefix)txt+=` <em>· 若送花人為女性可改用「${m.altPrefix}」</em>`;
  txt+=`<br/>• 下款後綴：<span class="tag">${m.suffix}</span>`;
  txt+=`<br/><em>↺ 仍可手動修改 · 可按「＋ 添加家庭成員」加多人</em>`;
  autoHintText.innerHTML=txt;
});

// ─── 30 MIN SLOT · conditional on upgrade ───
function update30Min(){
  const has30min=document.querySelector('.upgrade[data-shows-30min].is-active');
  slot30.style.display=has30min?'block':'none';
  if(!has30min){
    slot30.querySelectorAll('.hour').forEach(h=>h.classList.remove('is-active'));
  }
}
// hook into existing upgrade click handler
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',update30Min));
update30Min();

// ─── RELIGION TOGGLE ───
document.querySelectorAll('.religion button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.religion button').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
  state.religion=b.dataset.rel;renderChips();
}));

// ─── GENDER toggle ───
inGender.addEventListener('change',()=>{state.gender=inGender.value;renderChips();});

// ─── CHIP renderer (by religion + gender) ───
function renderChips(){
  const data=phrases[state.religion];
  let html='';
  if(state.gender==='M' && data.male.length){
    html+=`<div class="chip-section male"><div class="chip-section-label">男性 ♂ Male · ${state.religion}</div><div class="chip-row">`;
    data.male.forEach(p=>html+=`<button type="button" class="chip gM ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♂</span></button>`);
    html+=`</div></div>`;
  }
  if(state.gender==='F' && data.female.length){
    html+=`<div class="chip-section female"><div class="chip-section-label">女性 ♀ Female · ${state.religion}</div><div class="chip-row">`;
    data.female.forEach(p=>html+=`<button type="button" class="chip gF ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♀</span></button>`);
    html+=`</div></div>`;
  }
  html+=`<div class="chip-section neutral"><div class="chip-section-label">中性 ◆ Neutral · ${state.religion}</div><div class="chip-row">`;
  data.neutral.forEach(p=>html+=`<button type="button" class="chip gN ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">◆</span></button>`);
  html+=`</div></div>`;
  chipContainer.innerHTML=html;
  if(state.religion==='通用'){
    chipSuggested.innerHTML=state.gender==='M'?`💡 先人為男性 · 上方建議用男性詞（♂）或中性詞（◆）`:`💡 先人為女性 · 上方建議用女性詞（♀）或中性詞（◆）`;
  }else{
    chipSuggested.innerHTML=`💡 ${state.religion}輓詞通常不分男女 · 任揀`;
  }
  chipContainer.querySelectorAll('.chip[data-p]').forEach(c=>c.addEventListener('click',()=>{
    chipContainer.querySelectorAll('.chip[data-p]').forEach(x=>x.classList.remove('is-active'));
    c.classList.add('is-active');state.activePhrase=c.dataset.p;bp.textContent=c.dataset.p;
    // update phrase meaning panel
    pmPhrase.textContent=c.dataset.p;
    pmText.textContent=phraseExplain[c.dataset.p]||'（暫無解釋）';
    autoShrink();
  }));
}

renderChips();
syncBanner();

// ─── STEP STATUS TRACKING (ss1 → ss2 → ss3 progression) ───
const ss1=document.getElementById('ss1'),ss2=document.getElementById('ss2'),ss3=document.getElementById('ss3');
function setStepState(el,state,label){
  el.classList.remove('is-active','is-pending','is-done');
  el.classList.add(state);
  el.querySelector('.sub-step-status').textContent=label;
}
function updateStepStatuses(){
  const has關係=!!inRel.value;
  const has先人名=!!inName.value.trim();
  const has輓詞=!!document.querySelector('.chip[data-p].is-active');
  const senders=getSenders();
  const has送花人=senders.some(s=>s.name);

  // ss1
  if(has關係 && has先人名){setStepState(ss1,'is-done','已完成 ✓');}
  else if(has關係 || has先人名){setStepState(ss1,'is-active','進行中');}
  else{setStepState(ss1,'is-active','進行中');}

  // ss2
  if(has關係 && has先人名 && has輓詞){setStepState(ss2,'is-done','已完成 ✓');}
  else if(has關係 && has先人名){setStepState(ss2,'is-active','進行中');}
  else{setStepState(ss2,'is-pending','待填');}

  // ss3
  if(has關係 && has先人名 && has輓詞 && has送花人){setStepState(ss3,'is-done','已完成 ✓');}
  else if(has關係 && has先人名 && has輓詞){setStepState(ss3,'is-active','進行中');}
  else{setStepState(ss3,'is-pending','待填');}
}
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('input',updateStepStatuses));
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('change',updateStepStatuses));
sendersGroup.addEventListener('input',updateStepStatuses);
sendersGroup.addEventListener('change',updateStepStatuses);
// hook chip clicks (use event delegation after renderChips)
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))setTimeout(updateStepStatuses,50)});

// ─── BANNER ELEMENT PULSE on input change ───
function pulse(el){if(!el)return;el.classList.remove('bnr-pulse');void el.offsetWidth;el.classList.add('bnr-pulse');}
inName.addEventListener('input',()=>pulse(document.querySelector('.bnr-line1')));
inRel.addEventListener('change',()=>{pulse(document.querySelector('.bnr-line1'));setTimeout(()=>pulse(bpSenders),300);setTimeout(()=>pulse(document.querySelector('.bnr-suffix')),550);});
inSuffix.addEventListener('change',()=>pulse(document.querySelector('.bnr-suffix')));
sendersGroup.addEventListener('input',()=>pulse(bpSenders));
sendersGroup.addEventListener('change',()=>pulse(bpSenders));
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))pulse(bp);});

// ─── AUTO-FILL FLASH on form fields when relation triggers fill ───
const origRelHandler=inRel.onchange;
inRel.addEventListener('change',()=>{
  if(!inRel.value||!relationMap[inRel.value])return;
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  [primaryPrefix,inSuffix].forEach(el=>{
    el.classList.remove('is-autofilled');void el.offsetWidth;el.classList.add('is-autofilled');
  });
});

// initial state
updateStepStatuses();


// ─── TIME CUTOFF · auto-disable past + auto-pick first available (per Gary 舊設計) ───
(function setupTimeCutoff(){
  const W = document.querySelector('.funeral-pdp-v2b-wrap');
  if(!W) return;
  
  // Min lead time for arrangement preparation
  const PREP_MIN = 120; // 2 hours
  
  // Time category cutoffs (start time in minutes from midnight)
  const CAT_CUTOFFS = {
    '特早': 8*60,         // 8am — single slot
    '標準': 15*60+30,     // 15:30 (last 3hr window start) — category enabled if 下午 still possible
    '晚間': 19*60,        // 7pm — single slot
    '特晚': 22*60+30,     // 22:30 (last 1.5hr window start) — category enabled if 10:30 still possible
  };
  
  // 3-hour window cutoffs
  const WIN_CUTOFFS = {
    '上午': 10*60,        // 10am · 標準 window
    '中午': 12*60+30,     // 12:30 · 標準 window
    '下午': 15*60+30,     // 15:30 · 標準 window
    '9:00': 21*60,        // 9pm · 特晚 window
    '10:30': 22*60+30,    // 22:30 · 特晚 window
  };
  
  // 30-min slot cutoffs (parse from text "12:30 – 1:00" etc)
  function parseSlotStart(txt){
    const m = txt.match(/(\d+):(\d+)/);
    if(!m) return null;
    let h = +m[1], min = +m[2];
    if(h < 8) h += 12; // assume PM if h < 8 (1:00 = 13:00)
    return h * 60 + min;
  }
  
  function isToday(){
    const dateRow = W.querySelector('.quick-row');
    if(!dateRow) return true;
    const active = dateRow.querySelector('.quick.is-active');
    if(!active) return true;
    return active.textContent.includes('今日');
  }
  
  function nowMinutes(){
    const n = new Date();
    return n.getHours()*60 + n.getMinutes();
  }
  
  function disableOrEnable(btn, startMin, nowM, today){
    const tooLate = today && (nowM + PREP_MIN > startMin);
    btn.classList.toggle('is-disabled', tooLate);

    // CRITICAL: skip text manipulation if element has nested children.
    if(btn.querySelector('.tl-row, .tl-fee, .tl-main, .tl-detail, .tl-hint')) return;

    const baseText = btn.dataset.baseText || btn.textContent.trim();
    if(!btn.dataset.baseText) btn.dataset.baseText = baseText;
    if(tooLate && !baseText.includes('來不及')){
      if(btn.classList.contains('quick')){
        btn.textContent = baseText + ' · 製作來不及';
      }
    }else{
      btn.textContent = baseText;
    }
  }

  
  
  function autoPickFirstAvailable(group, activeClass='is-active', disabledClass='is-disabled'){
    const all = Array.from(group.children);
    const current = all.find(b => b.classList.contains(activeClass));
    if(current && current.classList.contains(disabledClass)){
      current.classList.remove(activeClass);
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    } else if(!current){
      // No active · pick first available
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    }
  }
  
  function applyTimeCutoffs(){
    const today = isToday();
    const nowM = nowMinutes();
    
    // Time categories
    W.querySelectorAll('.time-cats .time-cat').forEach(btn => {
      const cn = btn.querySelector('.cn')?.textContent.trim();
      const start = CAT_CUTOFFS[cn];
      if(start !== undefined) disableOrEnable(btn, start, nowM, today);
    });
    
    // 3-hour windows (in second .quick-row · check via parent label)
    W.querySelectorAll('.quick-row').forEach(row => {
      const buttons = Array.from(row.querySelectorAll('.quick'));
      // Check if this row is a 3hr-window row (button text starts with 上午/中午/下午)
      const firstText = buttons[0]?.textContent.trim() || '';
      const isWindowRow = ['上午','中午','下午'].some(w => firstText.startsWith(w));
      if(!isWindowRow) return;
      
      buttons.forEach(btn => {
        const txt = btn.textContent.trim();
        let win = null;
        Object.keys(WIN_CUTOFFS).forEach(k => { if(txt.startsWith(k)) win = k; });
        if(win) disableOrEnable(btn, WIN_CUTOFFS[win], nowM, today);
      });
      
      autoPickFirstAvailable(row);
    });
    
    // Time category group auto-pick
    W.querySelectorAll('.time-cats').forEach(g => autoPickFirstAvailable(g));
    
    // SMART: if today + ALL time categories disabled · auto-switch to 明日
    if(today){
      const allCatDisabled = Array.from(W.querySelectorAll('.time-cats .time-cat')).every(b => b.classList.contains('is-disabled'));
      if(allCatDisabled){
        const dateRow = W.querySelector('.quick-row');
        const todayChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('今日'));
        const tmrChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('明日'));
        if(todayChip && tmrChip){
          todayChip.classList.remove('is-active');
          tmrChip.classList.add('is-active');
          // Re-run with new date · no longer today · all enabled
          setTimeout(applyTimeCutoffs, 30);
        }
      }
    }
    
    // 30-min slots (inside #slot30 · only visible when upgrade chosen)
    const slot30 = W.querySelector('#slot30');
    if(slot30 && slot30.style.display !== 'none'){
      const slots = Array.from(slot30.querySelectorAll('.hour'));
      slots.forEach(btn => {
        const start = parseSlotStart(btn.textContent);
        if(start) disableOrEnable(btn, start, nowM, today);
      });
    }
  }
  
  // Initial run
  applyTimeCutoffs();
  
  // Re-run when date chip changes
  W.querySelectorAll('.quick-row .quick').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 50));
  });
  // Re-run when category changes (in case 30min slots become visible)
  W.querySelectorAll('.time-cat, .upgrade').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 100));
  });
})();


// ─── PHASE 2 #1+#2: Cart submit + variant sync ───
(function(){
  const W = document.querySelector('.funeral-pdp-v2b-wrap');
  if(!W) return;
  const form = document.getElementById('v2a-funeral-form');
  if(!form) return;
  
  // Size variant sync: when user clicks size, update hidden variant id
  W.querySelectorAll('.size').forEach(btn => {
    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if(vid){
        const idInput = document.getElementById('v2a-variant-id');
        if(idInput) idInput.value = vid;
      }
    });
  });
  
  // On submit, gather all form state into hidden inputs
  form.addEventListener('submit', function(e){
    e.preventDefault();

    // ===== VALIDATION =====
    const errors = [];

    // 1. Size selected (Part 1)
    const sizeActive = W.querySelector('.size.is-active');
    if(!sizeActive) errors.push('請揀尺寸');

    // 2. Date selected (Part 2)
    const dateActive = W.querySelector('.quick-row .quick.is-active');
    if(!dateActive) errors.push('請揀送花日期');

    // 3. Time category selected (Part 2)
    const timeCatActive = W.querySelector('.time-cat.is-active');
    if(!timeCatActive) errors.push('請揀送花時段');

    // 4. 3hr Window selected (Part 2)
    const timeWinActive = W.querySelectorAll('.quick-row')[1]?.querySelector('.quick.is-active');
    if(!timeWinActive) errors.push('請揀送花時段內 3 小時 window');

    // 5. Venue name (Part 2)
    const venueName = document.getElementById('venue-name')?.value?.trim() || '';
    if(!venueName) errors.push('請填場所名稱');

    // 6. Phone (Part 2)
    const phoneIn = W.querySelector('input[type="tel"]');
    const phone = phoneIn?.value?.trim() || '';
    if(!phone) errors.push('請填訂花人電話');

    // 7. Relation (Part 3)
    const relSel = document.getElementById('in-relation');
    const relValue = relSel?.value || '';
    if(!relValue) errors.push('請揀與先人關係');

    // 8. Deceased name (Part 3)
    const name = document.getElementById('in-name')?.value?.trim() || '';
    if(!name) errors.push('請填先人名稱');

    // 9. Sender (Part 3) - must have at least primary
    const primaryPrefix = document.getElementById('primary-prefix')?.value || '';
    const primaryName = document.getElementById('primary-name')?.value?.trim() || '';
    if(!primaryPrefix || !primaryName) errors.push('請填送花人（關係 + 姓名）');

    if(errors.length){
      showError(errors.join(' · '));
      // Scroll to first invalid - prefer date if missing, then relation
      const target = !dateActive ? W.querySelector('.quick-row')
                   : !timeWinActive ? W.querySelectorAll('.quick-row')[1]
                   : !venueName ? document.getElementById('venue-name')
                   : !phone ? phoneIn
                   : !relValue ? relSel
                   : !name ? document.getElementById('in-name')
                   : (!primaryPrefix || !primaryName) ? document.getElementById('primary-name')
                   : null;
      if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }

    // ===== GATHER PROPERTIES =====
    try {
      const relText = relSel.options[relSel.selectedIndex]?.text || '';
      document.getElementById('prop-relation').value = relText;
      const m = relationMap[relValue] || {};
      const upperLine = ((m.title ? m.title + ' ' : '') + name + ' ' + (m.hon || '千古')).trim();
      document.getElementById('prop-upper').value = upperLine;

      const phraseEl = document.querySelector('.chip[data-p].is-active');
      const phrase = phraseEl?.dataset.p || '永遠懷念';
      document.getElementById('prop-phrase').value = phrase;

      const senders = (typeof getSenders === 'function') ? sortSenders(getSenders()) : [];
      const firstLevel = senders.length ? (prefixLevel[senders[0].prefix] ?? 99) : 99;
      const senderLines = senders.map((s, idx) => {
        const dispP = (typeof applyRank === 'function') ? applyRank(s.prefix, s.rank) : s.prefix;
        const senderLevel = prefixLevel[s.prefix] ?? 99;
        const rate = (idx > 0 && senderLevel !== firstLevel) ? '率 ' : '';
        return (rate + dispP + ' ' + s.name).trim();
      });
      document.getElementById('prop-lower').value = senderLines.join(' · ');

      const suffix = document.getElementById('in-suffix')?.value || '敬輓';
      document.getElementById('prop-suffix-prop').value = suffix;

      document.getElementById('prop-date').value = dateActive.textContent.trim().replace(/ · 製作來不及/, '');
      document.getElementById('prop-time-cat').value = timeCatActive.textContent.trim();
      document.getElementById('prop-time-win').value = timeWinActive.textContent.trim().replace(/ · 製作來不及/, '');

      const time30Active = W.querySelector('.hour.is-active');
      document.getElementById('prop-time-30').value = time30Active?.textContent.trim() || '';
      const upgradeActive = W.querySelector('.upgrade.is-active');
      document.getElementById('prop-upgrade').value = upgradeActive?.querySelector('.cn')?.textContent.trim() || '';

      const venueTypeSel = W.querySelectorAll('.sub-block select.uline')[0];
      document.getElementById('prop-venue-type').value = venueTypeSel?.value || '';
      document.getElementById('prop-venue-name').value = venueName;
      const floorIn = W.querySelector('input[placeholder*="樓"]');
      document.getElementById('prop-floor').value = floorIn?.value || '';
      const hallIn = W.querySelector('input[placeholder*="A 號"]');
      document.getElementById('prop-hall').value = hallIn?.value || '';
      document.getElementById('prop-phone').value = phone;

      const params = new URLSearchParams({
        reltitle: m.title || '',
        name: name,
        hon: m.hon || '千古',
        phrase: phrase,
        senders: JSON.stringify(senders.map(s => ({prefix: applyRank(s.prefix, s.rank), name: s.name, level: prefixLevel[s.prefix] ?? 99}))),
        suffix: suffix,
      });
      document.getElementById('prop-print-url').value = location.origin + '/pages/funeral-print?' + params.toString();
    } catch(err){
      console.error('V2A property gather error:', err);
      showError('資料整理出錯：' + err.message);
      return;
    }

    // ===== AJAX SUBMIT TO /cart/add.js =====
    const ctaBtn = form.querySelector('.cta');
    if(ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.6'; }

    const properties = {};
    form.querySelectorAll('input[name^="properties"]').forEach(inp => {
      const key = inp.name.match(/\[(.+)\]/)?.[1];
      if(key && inp.value) properties[key] = inp.value;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        id: document.getElementById('v2a-variant-id').value,
        quantity: 1,
        properties: properties
      })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
    .then(data => {
      showSuccess();
      setTimeout(() => { location.href = '/cart'; }, 1600);
    })
    .catch(err => {
      console.error('Cart add error:', err);
      showError('加入購物車失敗：' + (err.description || err.message || '請再試一次'));
      if(ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = '1'; }
    });
  });

  // ===== ANIMATION HELPERS =====
  function showSuccess(){
    let overlay = document.querySelector('.v2a-cart-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'v2a-cart-overlay';
      overlay.innerHTML = '<div class="v2a-cart-card"><div class="v2a-cart-check"><svg viewBox="0 0 24 24"><polyline points="4,12 10,18 20,6"/></svg></div><h3 class="v2a-cart-title">已加入購物車</h3><p class="v2a-cart-sub">Added to cart<br/>正在前往結算頁面…</p></div>';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function showError(msg){
    let bar = document.querySelector('.v2a-cart-error');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'v2a-cart-error';
      document.body.appendChild(bar);
    }
    bar.textContent = '⚠ ' + msg;
    bar.classList.add('is-visible');
    clearTimeout(bar._t);
    bar._t = setTimeout(() => bar.classList.remove('is-visible'), 5000);
  }
})();


// ─── PHASE-MEANING fly-in animation hook ───
(function(){
  const pm = document.getElementById('phrase-meaning');
  if(!pm) return;
  const wrap = pm.closest('.funeral-pdp-v2b-wrap') || document;
  wrap.addEventListener('click', function(e){
    const chip = e.target.closest('.chip[data-p]');
    if(!chip) return;
    // Re-trigger animation by toggling class
    pm.classList.remove('is-flying');
    void pm.offsetWidth; // force reflow
    pm.classList.add('is-flying');
  });
})();

// ─── SUFFIX auto-fill flash animation ───
(function(){
  const inRel2 = document.getElementById('in-relation');
  const inSuf = document.getElementById('in-suffix');
  if(!inRel2 || !inSuf) return;
  inRel2.addEventListener('change', () => {
    setTimeout(() => {
      inSuf.classList.remove('is-autofilled');
      void inSuf.offsetWidth;
      inSuf.classList.add('is-autofilled');
    }, 50);
  });
})();


// (move-windows IIFE removed: pools now inlined inside time-cats)

// ─── DEFENSIVE event delegation · ensures click always works for time-cat / quick / hour ───
(function(){
  const W = document.querySelector('.funeral-pdp-v2b-wrap');
  if(!W) return;
  W.addEventListener('click', function(e){
    const btn = e.target.closest('.time-cat, .quick, .hour');
    if(!btn) return;
    if(btn.classList.contains('is-disabled')) return;
    // Get peers within same parent container
    const parent = btn.parentElement;
    if(!parent) return;
    // For .time-cat: peers are other .time-cat siblings (don't toggle nested .quick descendants)
    let peers;
    if(btn.classList.contains('time-cat')){
      peers = parent.querySelectorAll(':scope > .time-cat');
    } else if(btn.classList.contains('quick')){
      peers = parent.querySelectorAll(':scope > .quick');
    } else if(btn.classList.contains('hour')){
      peers = parent.querySelectorAll(':scope > .hour');
    }
    if(!peers) return;
    peers.forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true); // capture phase so we win over any broken listeners
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orchid-pdp-v2a"] && !Shopify.designMode) return;
  try {
    
const relationMap = {
  '父親':{title:'父親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '母親':{title:'母親大人',hon:'冥鑒',prefix:'孝子',altPrefix:'孝女',suffix:'泣叩'},
  '丈夫':{title:'夫君大人',hon:'千古',prefix:'妻',suffix:'哀輓'},
  '妻子':{title:'賢妻',hon:'千古',prefix:'夫',suffix:'哀輓'},
  '兄':{title:'胞兄大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '弟':{title:'賢弟',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '姊':{title:'胞姊大人',hon:'千古',prefix:'胞弟',altPrefix:'胞妹',suffix:'敬輓'},
  '妹':{title:'賢妹',hon:'千古',prefix:'胞兄',altPrefix:'胞姊',suffix:'敬輓'},
  '家翁':{title:'家翁大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '家姑':{title:'家姑大人',hon:'冥鑒',prefix:'孝媳',suffix:'泣叩'},
  '岳父':{title:'岳父大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '岳母':{title:'岳母大人',hon:'冥鑒',prefix:'孝婿',suffix:'泣叩'},
  '伯父':{title:'伯父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '叔父':{title:'叔父大人',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '伯娘':{title:'伯娘',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑姐':{title:'姑媽',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '姑丈':{title:'姑丈',hon:'千古',prefix:'姪',altPrefix:'姪女',suffix:'拜輓'},
  '舅父':{title:'舅父大人',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '舅母':{title:'舅母',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨媽':{title:'姨媽',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '姨丈':{title:'姨丈',hon:'千古',prefix:'外甥',altPrefix:'外甥女',suffix:'拜輓'},
  '祖父':{title:'祖父大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '祖母':{title:'祖母大人',hon:'千古',prefix:'孝孫',altPrefix:'孝孫女',suffix:'泣叩'},
  '外祖父':{title:'外祖父大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '外祖母':{title:'外祖母大人',hon:'千古',prefix:'孝外孫',altPrefix:'孝外孫女',suffix:'泣叩'},
  '朋友男':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '朋友女':{title:'',hon:'千古',prefix:'',suffix:'敬輓'},
  '同事男':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '同事女':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '公司':{title:'',hon:'千古',prefix:'',suffix:'鞠躬'},
  '教會弟兄':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '教會姊妹':{title:'',hon:'安息主懷',prefix:'',suffix:'敬輓'},
  '子姪男':{title:'賢姪',hon:'千古',prefix:'',suffix:'痛輓'},
  '子姪女':{title:'賢姪女',hon:'千古',prefix:'',suffix:'痛輓'},
};
const relationGender = {
  '父親':'M','母親':'F','丈夫':'M','妻子':'F',
  '兄':'M','弟':'M','姊':'F','妹':'F',
  '家翁':'M','家姑':'F','岳父':'M','岳母':'F',
  '伯父':'M','叔父':'M','伯娘':'F','姑姐':'F','姑丈':'M',
  '舅父':'M','舅母':'F','姨媽':'F','姨丈':'M',
  '祖父':'M','祖母':'F','外祖父':'M','外祖母':'F',
  '表兄弟':'M','表姊妹':'F','姐夫':'M',
  '朋友男':'M','朋友女':'F','同事男':'M','同事女':'F',
  '公司':'M','教會弟兄':'M','教會姊妹':'F',
  '子姪男':'M','子姪女':'F',
};
const prefixLevel = {
  '妻':0,'夫':0,
  '胞兄':0,'胞弟':0,'胞姊':0,'胞妹':0,
  '孝子':1,'孝女':1,'孝媳':1,'孝婿':1,
  '姪':1,'姪女':1,'外甥':1,'外甥女':1,
  '表兄':1,'表弟':1,'表姊':1,'表妹':1,
  '孫男':2,'孫女':2,'外孫男':2,'外孫女':2,
  '孝孫':2,'孝孫女':2,'孝外孫':2,'孝外孫女':2,
  '姪孫':2,'姪孫女':2,'外甥孫':2,'外甥孫女':2,
  '表姪':2,'表姪女':2,
  '曾孫男':3,'曾孫女':3,'外曾孫男':3,'外曾孫女':3,
  '姪曾孫':3,'姪曾孫女':3,
  '玄孫男':4,'玄孫女':4,
};
const rankableSet = new Set(['孝子','孝女','孝媳','孝婿','孝孫','孝孫女','孝外孫','孝外孫女']);
function applyRank(prefix, rank){
  if(!rank||!rankableSet.has(prefix))return prefix;
  return prefix[0]+rank+prefix.slice(1);
}
function prefixGender(p){
  if(/(妻|女|媳|姊|妹|姪女|甥女|孫女|曾孫女|玄孫女|姪曾孫女|外甥孫女|姪孫女)/.test(p))return 1;
  return 0;
}
const rankOrder={'長':1,'次':2,'三':3,'四':4,'五':5,'六':6,'':7};
const phrases = {
  '通用': {
    neutral: ['永遠懷念','沈痛悼念','千古不朽','一路好走','駕鶴西歸','福壽全歸','哀思永念','風範長存'],
    male: ['典範長存','德澤永存','英名永存','浩氣長存','流芳百世','萬古流芳','英靈不泯','典型猶存'],
    female: ['母儀千古','懿範永存','慈暉永昭','音容宛在','音容宛存','寶婺光寒','慈雲歸西','慈竹風悲'],
  },
  '佛教': {
    neutral: ['蓮邦極樂','往生極樂','西方接引','倒駕慈航','早登蓮邦','同登彼岸','早歸極樂','蓮座飄香'],
    male: [],
    female: [],
  },
  '基督教': {
    neutral: ['主懷安息','蒙主恩召','安息主懷','永居天家','平安歸主','主賜安寧','永生安息','在主裡睡了'],
    male: [],
    female: [],
  },
  '天主教': {
    neutral: ['蒙主寵召','永享主光','安息天國','復活享福','永享天國','諸聖之福'],
    male: [],
    female: [],
  },
};
const phraseExplain = {
  '永遠懷念':'長存於心的思念 · 最普世的悼念詞 · 適用所有親疏關係',
  '沈痛悼念':'表達深切哀痛之意 · 適用所有關係',
  '千古不朽':'永世長存 · 永不磨滅 · 中性通用',
  '一路好走':'願先人一路平安 · 口語親切 · 中性通用',
  '駕鶴西歸':'仙鶴載歸西方 · 典雅 · 適合長者善終',
  '福壽全歸':'福分壽命圓滿 · 適合高壽善終',
  '哀思永念':'哀痛思念永遠長存',
  '風範長存':'先人風範永存後人心中',
  '典範長存':'先人風範永存 · 多用於男性長輩',
  '德澤永存':'恩德與蔭澤永遠存在 · 適合男性',
  '英名永存':'英明事跡永誌不忘 · 適合男性 / 英雄人物',
  '浩氣長存':'浩然正氣永存 · 適合公職 / 英烈男性',
  '流芳百世':'美好聲名流傳百世 · 多用於男性',
  '萬古流芳':'美名永遠流傳 · 多用於男性',
  '英靈不泯':'英魂永不磨滅 · 適合男性',
  '典型猶存':'典範樣本尚存 · 適合男性長輩',
  '母儀千古':'慈母典範永流傳 · 適合母親',
  '懿範永存':'美好德行典範永存 · 適合女性長輩',
  '慈暉永昭':'慈愛光輝永遠照耀 · 適合母親',
  '音容宛在':'容貌聲音猶如尚存 · 傳統用於女性 · 形容深切思念',
  '音容宛存':'容貌音聲尚在 · 女性異體',
  '寶婺光寒':'婺女星（女性星宿）光暗 · 形容德高女性離世',
  '慈雲歸西':'慈愛之雲歸西 · 適合女性長輩',
  '慈竹風悲':'慈母如竹 · 風中悲傷 · 適合母親',
  '蓮邦極樂':'蓮邦即西方極樂淨土',
  '往生極樂':'往生阿彌陀佛西方極樂世界',
  '西方接引':'阿彌陀佛接引往西方淨土',
  '倒駕慈航':'已脫生死返回度化眾生',
  '早登蓮邦':'早日登入極樂蓮花世界',
  '同登彼岸':'共同到達覺悟彼岸',
  '早歸極樂':'早日歸於極樂淨土',
  '蓮座飄香':'蓮花座發出芬芳',
  '主懷安息':'安睡在主懷抱',
  '蒙主恩召':'蒙主慈愛召喚回天家',
  '安息主懷':'安睡在主懷抱',
  '永居天家':'永遠居住天國家中',
  '平安歸主':'安然回歸主裡',
  '主賜安寧':'主賜予永遠安寧',
  '永生安息':'永恆生命中的安息',
  '在主裡睡了':'聖經用語 · 指逝世（哥前 15:18）',
  '蒙主寵召':'蒙主寵愛召喚回天家',
  '永享主光':'永遠享有主的榮光',
  '安息天國':'在天國中安息',
  '復活享福':'復活並享永福',
  '永享天國':'永遠享有天國之福',
  '諸聖之福':'與諸聖一同享福',
};
const banner=document.querySelector('.banner-canvas');
const bp=document.getElementById('bp-phrase');
const bpReltitle=document.getElementById('bp-reltitle'),bpName=document.getElementById('bp-name'),bpHon=document.getElementById('bp-hon');
const bpSenders=document.getElementById('bp-senders'),bpSuffix=document.getElementById('bp-suffix');
const inRel=document.getElementById('in-relation'),inName=document.getElementById('in-name'),inGender=document.getElementById('in-gender'),inSuffix=document.getElementById('in-suffix');
const sendersGroup=document.getElementById('senders-group'),addSenderBtn=document.getElementById('add-sender');
const autoHint=document.getElementById('auto-hint'),autoHintText=document.getElementById('auto-hint-text');
const chipContainer=document.getElementById('chip-container'),chipSuggested=document.getElementById('chip-suggested');
const pmPhrase=document.getElementById('pm-phrase'),pmText=document.getElementById('pm-text');
const slot30=document.getElementById('slot30');
const priceDisp=document.getElementById('price-display'),priceSize=document.getElementById('price-size');
const sumSize=document.getElementById('sum-size'),sumFlower=document.getElementById('sum-flower'),sumZone=document.getElementById('sum-zone'),sumShip=document.getElementById('sum-ship'),sumUpLabel=document.getElementById('sum-up-label'),sumUp=document.getElementById('sum-up'),sumTotal=document.getElementById('sum-total');
const zoneName=document.getElementById('zone-name'),zoneFee=document.getElementById('zone-fee'),venueName=document.getElementById('venue-name');
let _initPrice = 0, _initLabel = '—';
const _multiData = document.getElementById('tfk-variants-data');
if(_multiData){
  try {
    const _d = JSON.parse(_multiData.textContent);
    const _opt1 = document.querySelector('.opt1-grid .opt-size-btn.is-active');
    const _opt2 = document.querySelector('.opt2-grid .cv-btn.is-active');
    const _v1 = _opt1 ? _opt1.getAttribute('data-opt-value') : null;
    const _v2 = _opt2 ? _opt2.getAttribute('data-opt-value') : null;
    let _match = (_d.variants||[]).find(v => v.opt1===_v1 && v.opt2===_v2);
    if(!_match && _v1){ var _cand=(_d.variants||[]).filter(function(v){return v.opt1===_v1;}); _cand.sort(function(a,b){return a.price-b.price;}); if(_cand.length) _match=_cand[0]; }
    if(_match){ _initPrice = _match.price; _initLabel = _v1 + (_v2? ' · ' + _v2 : ''); }
  } catch(e){}
} else {
  const _activeSize=document.querySelector('.size.is-active')||document.querySelector('.size');
  _initPrice=_activeSize?parseFloat((_activeSize.dataset.price||'0').replace(/,/g,'')):0;
  _initLabel=_activeSize?(_activeSize.dataset.cn||(_activeSize.querySelector('.cn')?_activeSize.querySelector('.cn').textContent:'—')):'—';
}
const state={flower:_initPrice||0,sizeLabel:_initLabel,ship:0,shipLabel:'免費',upLabel:'—',up:0,timeFee:0,timeLabel:'',activePhrase:''}; window.__tfkState=state;
function recalc(){
  const t=state.flower+state.ship+state.up+(state.timeFee||0);
  sumSize.textContent=state.sizeLabel;sumFlower.textContent=`HK$${state.flower.toLocaleString()}`;
  sumShip.textContent=state.shipLabel;var _ad=state.up+(state.timeFee||0);sumUpLabel.textContent=[state.timeLabel,(state.upLabel&&state.upLabel!=='—')?state.upLabel:''].filter(Boolean).join(' + ')||'—';sumUp.textContent=_ad?'HK$'+_ad.toLocaleString():'—';
  sumTotal.textContent=`HK$${t.toLocaleString()}`;
}
recalc();
window.tfkRecalc=recalc;
document.querySelectorAll('.size').forEach(s=>s.addEventListener('click',()=>{
  if(s.hasAttribute('data-opt-value')) return;
  const grid=s.parentElement;
  if(grid) grid.querySelectorAll('.size').forEach(x=>x.classList.remove('is-active'));
  s.classList.add('is-active');
  const raw=(s.dataset.price||'').replace(/,/g,'');
  const p=parseFloat(raw);
  if(!isFinite(p)) return;
  state.flower=p;
  state.sizeLabel=s.dataset.cn||s.querySelector('.cn').textContent;
  priceDisp.textContent='HK$'+p.toLocaleString();priceSize.textContent=s.dataset.cn;
  const idIn=document.getElementById('v2a-variant-id');if(idIn)idIn.value=s.dataset.variantId;
  recalc();
}));
const zoneFees={1:[0,'免費','Zone 1 · 港島 + 九龍','Same-day standard'],2:[150,'HK$150','Zone 2 · 新界主區','New Territories'],3:[250,'HK$250','Zone 3 · 新界遠郊 + 離島','Outer NT / islands']};
venueName.addEventListener('change',()=>{
  const z=+venueName.options[venueName.selectedIndex].dataset.zone||1;
  const [fee,feeLabel,zname,zsub]=zoneFees[z];
  state.ship=fee;state.shipLabel=feeLabel;
  zoneName.innerHTML=zname+' <em>'+zsub+'</em>';zoneFee.textContent=feeLabel+(fee===0?' · Free':'');
  zoneFee.classList.toggle('free',fee===0);sumZone.textContent=zname;recalc();
});
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',()=>{
  if(u.classList.contains('is-active')){u.classList.remove('is-active');state.up=0;state.upLabel='—';}
  else{document.querySelectorAll('.upgrade').forEach(x=>x.classList.remove('is-active'));u.classList.add('is-active');state.up=+u.dataset.fee;state.upLabel=u.querySelector('.cn').textContent;}
  recalc();
}));
document.querySelectorAll('.quick,.time-cat,.hour').forEach(b=>b.addEventListener('click',(e)=>{
  if(b.classList.contains('is-disabled'))return;
  e.stopPropagation();
  const peers=b.parentElement.querySelectorAll(':scope > .quick, :scope > .time-cat, :scope > .hour');
  peers.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
}));
function getSenders(){
  return Array.from(sendersGroup.querySelectorAll('.sender-row')).map(row=>({
    prefix:row.querySelector('.sender-prefix').value,
    rank:row.querySelector('.sender-rank')?.value||'',
    name:row.querySelector('.sender-name').value.trim(),
  })).filter(s=>s.name||s.prefix);
}
function sortSenders(senders){
  return senders.slice().sort((a,b)=>{
    const la=prefixLevel[a.prefix]??99, lb=prefixLevel[b.prefix]??99;
    if(la!==lb)return la-lb;
    const ga=prefixGender(a.prefix),gb=prefixGender(b.prefix);
    if(ga!==gb)return ga-gb;
    return (rankOrder[a.rank]||7)-(rankOrder[b.rank]||7);
  });
}
function syncBanner(){
  const m=relationMap[inRel.value];
  bpReltitle.textContent=m?.title?m.title:'';
  bpName.textContent=inName.value||'先人名稱';
  bpHon.textContent=m?.hon||'千古';
  const rawSenders=getSenders();
  const senders=sortSenders(rawSenders);
  bpSenders.innerHTML='';
  if(senders.length===0){
    bpSenders.innerHTML=`<div class="bnr-sender"><span class="sname" style="color:var(--muted)">送花人名稱</span></div>`;
  }else{
    const firstLevel=prefixLevel[senders[0].prefix]??99;
    senders.forEach((s,idx)=>{
      const div=document.createElement('div');
      div.className='bnr-sender';
      const displayPrefix=applyRank(s.prefix,s.rank);
      const senderLevel=prefixLevel[s.prefix]??99;
      const rate=(idx>0&&senderLevel!==firstLevel)?`<span class="srate">率</span>`:'';
      const px=displayPrefix?`<span class="sprefix">${displayPrefix}</span>`:'';
      const nm=`<span class="sname">${s.name||'（未填名稱）'}</span>`;
      div.innerHTML=rate+px+nm;
      bpSenders.appendChild(div);
    });
  }
  bpSuffix.textContent=inSuffix.value;
  autoShrink();
}
function autoShrink(){
  const senderCount=Math.max(1,getSenders().length);
  let scale=1;
  if(senderCount>=5)scale=.62;
  else if(senderCount===4)scale=.72;
  else if(senderCount===3)scale=.82;
  else if(senderCount===2)scale=.92;
  const suffixLen=bpSuffix.textContent.length;
  let l4Scale=scale;
  if(suffixLen>=4)l4Scale*=.92;
  const L1_MAX=15;
  banner.style.setProperty('--l1',`${L1_MAX}cqw`);
  banner.style.setProperty('--l2',`${17*scale}cqw`);
  banner.style.setProperty('--l3',`${8*scale}cqw`);
  banner.style.setProperty('--l4',`${6*l4Scale}cqw`);
  banner.style.setProperty('--gap',`${2.5*scale}cqw`);
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    const cw=banner.clientWidth;
    if(cw<10)return;
    const availW=cw*0.84; // 84% safety margin
    const l1El=document.querySelector('.bnr-line1');
    const l2El=bp;
    const l3Els=Array.from(bpSenders.querySelectorAll('.bnr-sender'));
    const l4El=bpSuffix;
    let lo=3,hi=L1_MAX,best=3;
    for(let i=0;i < 10;i++){
      const mid=(lo+hi)/2;
      banner.style.setProperty('--l1',`${mid}cqw`);
      void l1El.offsetWidth; // force reflow
      if(l1El.scrollWidth<=availW){best=mid;lo=mid;}
      else{hi=mid;}
    }
    banner.style.setProperty('--l1',`${best}cqw`);
    let furtherL2=1,furtherL3=1,furtherL4=1;
    if(l2El.scrollWidth>availW)furtherL2=Math.max(.55,availW/l2El.scrollWidth);
    l3Els.forEach(e=>{if(e.scrollWidth>availW){furtherL3=Math.min(furtherL3,Math.max(.55,availW/e.scrollWidth));}});
    if(l4El.scrollWidth>availW)furtherL4=Math.max(.55,availW/l4El.scrollWidth);
    if(furtherL2<1)banner.style.setProperty('--l2',`${17*scale*furtherL2}cqw`);
    if(furtherL3<1)banner.style.setProperty('--l3',`${8*scale*furtherL3}cqw`);
    if(furtherL4<1)banner.style.setProperty('--l4',`${6*l4Scale*furtherL4}cqw`);
    const overflowReduced=Math.min(furtherL2,furtherL3,furtherL4);
    updateShrinkBadge(scale,overflowReduced);
  }));
  function updateShrinkBadge(senderScale,overflowScale){
    const tag=document.querySelector('.preview-foot .shrink-tag');
    const totalScale=senderScale*overflowScale;
    if(totalScale<.99){
      let label=`Auto-shrink ${Math.round(totalScale*100)}%`;
      if(overflowScale<.99 && senderScale<.99)label+=' (多人+名長)';
      else if(overflowScale<.99)label+=' (字過長)';
      else label+=` (${getSenders().length} 位送花人)`;
      if(!tag){
        const t=document.createElement('span');t.className='shrink-tag';t.textContent=label;
        document.querySelector('.preview-foot').appendChild(t);
      }else{tag.textContent=label;}
    }else if(tag){tag.remove();}
  }
}
inName.addEventListener('input',syncBanner);
inSuffix.addEventListener('change',syncBanner);
sendersGroup.addEventListener('input',syncBanner);
sendersGroup.addEventListener('change',syncBanner);
const relSenderCats = {
  '父親':['子女輩','孫輩','曾孫 / 玄孫'],
  '母親':['子女輩','孫輩','曾孫 / 玄孫'],
  '家翁':['子女輩','孫輩'],
  '家姑':['子女輩','孫輩'],
  '岳父':['子女輩','孫輩'],
  '岳母':['子女輩','孫輩'],
  '丈夫':['子女輩','孫輩'],
  '妻子':['子女輩','孫輩'],
  '兄':['兄弟姊妹','父系姪輩'],
  '弟':['兄弟姊妹','父系姪輩'],
  '姊':['兄弟姊妹','父系姪輩'],
  '妹':['兄弟姊妹','父系姪輩'],
  '伯父':['父系姪輩'],
  '叔父':['父系姪輩'],
  '伯娘':['父系姪輩'],
  '姑姐':['父系姪輩'],
  '姑丈':['父系姪輩'],
  '舅父':['母系外甥輩'],
  '舅母':['母系外甥輩'],
  '姨媽':['母系外甥輩'],
  '姨丈':['母系外甥輩'],
  '祖父':['孫輩','曾孫 / 玄孫'],
  '祖母':['孫輩','曾孫 / 玄孫'],
  '外祖父':['孫輩','曾孫 / 玄孫'],
  '外祖母':['孫輩','曾孫 / 玄孫'],
  '表兄弟':['表親'],
  '表姊妹':['表親'],
  '姐夫':['表親'],
  '朋友男':[],
  '朋友女':[],
  '同事男':[],
  '同事女':[],
  '公司':[],
  '教會弟兄':[],
  '教會姊妹':[],
  '子姪男':[],
  '子姪女':[],
};
function buildPrefixSelectHTML(relation, includeBlank=true){
  const allowedCats=relSenderCats[relation];
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  let html='';
  if(includeBlank){
    html+=`<option value="">（無前綴）</option>`;
    html+=`<option value="（不指定排行）">（不指定排行）</option>`;
  }
  if(!relation||!allowedCats||allowedCats.length===0){
    return primary.innerHTML; // fall back to primary's full list
  }
  const fullOpts=primary.querySelectorAll('optgroup');
  fullOpts.forEach(og=>{
    if(allowedCats.includes(og.label)){
      html+=`<optgroup label="${og.label}">`;
      og.querySelectorAll('option').forEach(o=>html+=`<option value="${o.value}">${o.textContent}</option>`);
      html+=`</optgroup>`;
    }
  });
  return html;
}
const rankOptsHTML=`<option value="">不指定</option><option value="長">長</option><option value="次">次</option><option value="三">三</option><option value="四">四</option><option value="五">五</option><option value="六">六</option>`;
function addSenderRow(prefix='',name='',rank=''){
  const row=document.createElement('div');
  row.className='sender-row';
  const opts=buildPrefixSelectHTML(inRel.value,true);
  row.innerHTML=`
    <div>
      <span class="sender-row-label">前綴</span>
      <select class="uline sender-prefix">${opts}</select>
    </div>
    <div>
      <span class="sender-row-label">排行</span>
      <select class="uline sender-rank">${rankOptsHTML}</select>
    </div>
    <div>
      <span class="sender-row-label">姓名 / 公司</span>
      <input class="uline sender-name" placeholder="例：陳小明" />
    </div>
    <button class="remove" type="button">×</button>
  `;
  sendersGroup.appendChild(row);
  if(prefix)row.querySelector('.sender-prefix').value=prefix;
  if(rank)row.querySelector('.sender-rank').value=rank;
  if(name)row.querySelector('.sender-name').value=name;
  row.querySelector('.remove').addEventListener('click',()=>{row.remove();syncBanner();updateAddSenderHint();});
  updateRowRankAvailability(row);
  syncBanner();
  updateAddSenderHint();
}
function updateRowRankAvailability(row){
  const sel=row.querySelector('.sender-prefix');
  const rank=row.querySelector('.sender-rank');
  if(!rank)return;
  if(!rankableSet.has(sel.value)){
    rank.value='';
    rank.classList.add('is-disabled');
    rank.title='此前綴不支持排行（長/次/三...）';
  }else{
    rank.classList.remove('is-disabled');
    rank.title='';
  }
}
sendersGroup.addEventListener('change',e=>{
  if(e.target.classList.contains('sender-prefix')){
    updateRowRankAvailability(e.target.closest('.sender-row'));
  }
});
addSenderBtn.addEventListener('click',()=>addSenderRow());
sendersGroup.querySelector('.sender-row.primary .remove').addEventListener('click',()=>{});
function updateAddSenderHint(){
  const v=inRel.value;
  let oldHint=document.getElementById('add-sender-hint');
  if(oldHint)oldHint.remove();
  if(!v)return;
  const cats=relSenderCats[v]||[];
  const senderCount=getSenders().length;
  let msg='',color='var(--muted)';
  if(v==='丈夫'||v==='妻子'){
    msg=`💡 夫妻互送一般係 1 位送花人（${v==='丈夫'?'妻':'夫'}）獨送 · 若子女合送可加多人`;
    color='var(--gold-deep)';
  }else if(cats.length===0){
    msg=`💡 朋友 / 同事 / 公司一般唔需要送花人前綴 · 直接輸入姓名 / 公司名`;
    color='var(--gold-deep)';
  }else{
    msg=`💡 揀「${inRel.options[inRel.selectedIndex].text}」· 可加 ${cats.join(' / ')} 嘅親屬合送`;
  }
  const hint=document.createElement('div');hint.id='add-sender-hint';
  hint.style.cssText=`font-family:var(--cjk);font-size:12px;color:${color};letter-spacing:.06em;margin-top:8px;padding:8px 12px;background:rgba(184,153,104,.08);border-left:2px solid var(--gold);line-height:1.6`;
  hint.textContent=msg;
  addSenderBtn.insertAdjacentElement('afterend',hint);
}
function syncAllPrefixLists(){
  const primary=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  const primaryVal=primary.value;
  Array.from(sendersGroup.querySelectorAll('.sender-row')).forEach((row,i)=>{
    if(i===0)return; // primary
    const sel=row.querySelector('.sender-prefix');
    const oldVal=sel.value;
    sel.innerHTML=buildPrefixSelectHTML(inRel.value,true);
    sel.value=oldVal;
  });
}
inRel.addEventListener('change',()=>{syncAllPrefixLists();updateAddSenderHint();});
inRel.addEventListener('change',()=>{
  const v=inRel.value;
  if(v && relationGender[v]){
    const g=relationGender[v];
    document.getElementById('in-gender').value=g;
    state.gender=g;
    const dg=document.getElementById('derived-gender');
    if(dg){
      const gLabel=g==='M'?'男 ♂':'女 ♀';
      dg.textContent=gLabel+'（由關係推導）';
      dg.style.color=g==='M'?'var(--male)':'var(--female)';
      dg.style.borderColor=g==='M'?'var(--male)':'var(--female)';
    }
    renderChips();
  }
  if(!v||!relationMap[v]){autoHint.style.display='none';syncBanner();return;}
  const m=relationMap[v];
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  primaryPrefix.value=m.prefix||'';
  inSuffix.value=m.suffix;
  updateRowRankAvailability(sendersGroup.querySelector('.sender-row.primary'));
  syncBanner();
  autoHint.style.display='block';
  let txt=`揀「${inRel.options[inRel.selectedIndex].text}」 → 已自動填：<br/>`;
  if(m.title)txt+=`• 上聯稱謂：<span class="tag">${m.title}</span> + 先人名 + 敬稱 <span class="tag">${m.hon}</span><br/>`;
  else txt+=`• 上聯：（先人名）+ 敬稱 <span class="tag">${m.hon}</span><br/>`;
  if(m.prefix)txt+=`• 主送花人前綴：<span class="tag">${m.prefix}</span>`;
  if(m.altPrefix)txt+=` <em>· 若送花人為女性可改用「${m.altPrefix}」</em>`;
  txt+=`<br/>• 下款後綴：<span class="tag">${m.suffix}</span>`;
  txt+=`<br/><em>↺ 仍可手動修改 · 可按「＋ 添加家庭成員」加多人</em>`;
  autoHintText.innerHTML=txt;
});
function update30Min(){
  const has30min=document.querySelector('.upgrade[data-shows-30min].is-active');
  slot30.style.display=has30min?'block':'none';
  if(!has30min){
    slot30.querySelectorAll('.hour').forEach(h=>h.classList.remove('is-active'));
  }
}
document.querySelectorAll('.upgrade').forEach(u=>u.addEventListener('click',update30Min));
update30Min();
document.querySelectorAll('.religion button').forEach(b=>b.addEventListener('click',()=>{
  document.querySelectorAll('.religion button').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');
  state.religion=b.dataset.rel;renderChips();
}));
inGender.addEventListener('change',()=>{state.gender=inGender.value;renderChips();});
function renderChips(){
  const data=phrases[state.religion];
  let html='';
  if(state.gender==='M' && data.male.length){
    html+=`<div class="chip-section male"><div class="chip-section-label">男性 ♂ Male · ${state.religion}</div><div class="chip-row">`;
    data.male.forEach(p=>html+=`<button type="button" class="chip gM ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♂</span></button>`);
    html+=`</div></div>`;
  }
  if(state.gender==='F' && data.female.length){
    html+=`<div class="chip-section female"><div class="chip-section-label">女性 ♀ Female · ${state.religion}</div><div class="chip-row">`;
    data.female.forEach(p=>html+=`<button type="button" class="chip gF ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">♀</span></button>`);
    html+=`</div></div>`;
  }
  html+=`<div class="chip-section neutral"><div class="chip-section-label">中性 ◆ Neutral · ${state.religion}</div><div class="chip-row">`;
  data.neutral.forEach(p=>html+=`<button type="button" class="chip gN ${state.activePhrase===p?'is-active':''}" data-p="${p}">${p}<span class="g">◆</span></button>`);
  html+=`</div></div>`;
  chipContainer.innerHTML=html;
  if(state.religion==='通用'){
    chipSuggested.innerHTML=state.gender==='M'?`💡 先人為男性 · 上方建議用男性詞（♂）或中性詞（◆）`:`💡 先人為女性 · 上方建議用女性詞（♀）或中性詞（◆）`;
  }else{
    chipSuggested.innerHTML=`💡 ${state.religion}輓詞通常不分男女 · 任揀`;
  }
  chipContainer.querySelectorAll('.chip[data-p]').forEach(c=>c.addEventListener('click',()=>{
    chipContainer.querySelectorAll('.chip[data-p]').forEach(x=>x.classList.remove('is-active'));
    c.classList.add('is-active');state.activePhrase=c.dataset.p;bp.textContent=c.dataset.p;
    pmPhrase.textContent=c.dataset.p;
    pmText.textContent=phraseExplain[c.dataset.p]||'（暫無解釋）';
    autoShrink();
  }));
}
renderChips();
syncBanner();
const ss1=document.getElementById('ss1'),ss2=document.getElementById('ss2'),ss3=document.getElementById('ss3');
function setStepState(el,state,label){
  el.classList.remove('is-active','is-pending','is-done');
  el.classList.add(state);
  el.querySelector('.sub-step-status').textContent=label;
}
function updateStepStatuses(){
  const has關係=!!inRel.value;
  const has先人名=!!inName.value.trim();
  const has輓詞=!!document.querySelector('.chip[data-p].is-active');
  const senders=getSenders();
  const has送花人=senders.some(s=>s.name);
  if(has關係 && has先人名){setStepState(ss1,'is-done','已完成 ✓');}
  else if(has關係 || has先人名){setStepState(ss1,'is-active','進行中');}
  else{setStepState(ss1,'is-active','進行中');}
  if(has關係 && has先人名 && has輓詞){setStepState(ss2,'is-done','已完成 ✓');}
  else if(has關係 && has先人名){setStepState(ss2,'is-active','進行中');}
  else{setStepState(ss2,'is-pending','待填');}
  if(has關係 && has先人名 && has輓詞 && has送花人){setStepState(ss3,'is-done','已完成 ✓');}
  else if(has關係 && has先人名 && has輓詞){setStepState(ss3,'is-active','進行中');}
  else{setStepState(ss3,'is-pending','待填');}
}
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('input',updateStepStatuses));
[inRel,inName,inSuffix,inGender].forEach(el=>el.addEventListener('change',updateStepStatuses));
sendersGroup.addEventListener('input',updateStepStatuses);
sendersGroup.addEventListener('change',updateStepStatuses);
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))setTimeout(updateStepStatuses,50)});
function pulse(el){if(!el)return;el.classList.remove('bnr-pulse');void el.offsetWidth;el.classList.add('bnr-pulse');}
inName.addEventListener('input',()=>pulse(document.querySelector('.bnr-line1')));
inRel.addEventListener('change',()=>{pulse(document.querySelector('.bnr-line1'));setTimeout(()=>pulse(bpSenders),300);setTimeout(()=>pulse(document.querySelector('.bnr-suffix')),550);});
inSuffix.addEventListener('change',()=>pulse(document.querySelector('.bnr-suffix')));
sendersGroup.addEventListener('input',()=>pulse(bpSenders));
sendersGroup.addEventListener('change',()=>pulse(bpSenders));
chipContainer.addEventListener('click',e=>{if(e.target.closest('.chip[data-p]'))pulse(bp);});
const origRelHandler=inRel.onchange;
inRel.addEventListener('change',()=>{
  if(!inRel.value||!relationMap[inRel.value])return;
  const primaryPrefix=sendersGroup.querySelector('.sender-row.primary .sender-prefix');
  [primaryPrefix,inSuffix].forEach(el=>{
    el.classList.remove('is-autofilled');void el.offsetWidth;el.classList.add('is-autofilled');
  });
});
updateStepStatuses();
(function setupTimeCutoff(){
  const W = document.querySelector('.orchid-pdp-v2a-wrap');
  if(!W) return;
  const PREP_MIN = 150; // 2.5 hours
  const CAT_CUTOFFS = {
    '特早': 8*60,         // 8am — single slot
    '標準': 15*60+30,     // 15:30 (last 3hr window start) — category enabled if 下午 still possible
    '晚間': 19*60,        // 7pm — single slot
    '特晚': 22*60+30,     // 22:30 (last 1.5hr window start) — category enabled if 10:30 still possible
  };
  const WIN_CUTOFFS = {
    '上午': 10*60,        // 10am · 標準 window
    '中午': 12*60+30,     // 12:30 · 標準 window
    '下午': 15*60+30,     // 15:30 · 標準 window
    '9:00': 21*60,        // 9pm · 特晚 window
    '10:30': 22*60+30,    // 22:30 · 特晚 window
  };
  function parseSlotStart(txt){
    const m = txt.match(/(\d+):(\d+)/);
    if(!m) return null;
    let h = +m[1], min = +m[2];
    if(h < 8) h += 12; // assume PM if h < 8 (1:00 = 13:00)
    return h * 60 + min;
  }
  function isToday(){
    const dateRow = W.querySelector('.quick-row');
    if(!dateRow) return true;
    const active = dateRow.querySelector('.quick.is-active');
    if(!active) return true;
    return active.textContent.includes('今日');
  }
  function nowMinutes(){
    const n = new Date();
    return n.getHours()*60 + n.getMinutes();
  }
  function disableOrEnable(btn, startMin, nowM, today){
    const tooLate = today && (nowM + PREP_MIN > startMin);
    btn.classList.toggle('is-disabled', tooLate);
    if(btn.querySelector('.tl-row, .tl-fee, .tl-main, .tl-detail, .tl-hint')) return;
    const baseText = btn.dataset.baseText || btn.textContent.trim();
    if(!btn.dataset.baseText) btn.dataset.baseText = baseText;
    if(tooLate && !baseText.includes('來不及')){
      if(btn.classList.contains('quick')){
        btn.textContent = baseText + ' · 製作來不及';
      }
    }else{
      btn.textContent = baseText;
    }
  }
  function autoPickFirstAvailable(group, activeClass='is-active', disabledClass='is-disabled'){
    const all = Array.from(group.children);
    const current = all.find(b => b.classList.contains(activeClass));
    if(current && current.classList.contains(disabledClass)){
      current.classList.remove(activeClass);
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    } else if(!current){
      const first = all.find(b => !b.classList.contains(disabledClass));
      if(first) first.classList.add(activeClass);
    }
  }
  function applyTimeCutoffs(){
    const today = isToday();
    const nowM = nowMinutes();
    W.querySelectorAll('.time-cats .time-cat').forEach(btn => {
      const cn = btn.querySelector('.cn')?.textContent.trim();
      const start = CAT_CUTOFFS[cn];
      if(start !== undefined) disableOrEnable(btn, start, nowM, today);
    });
    W.querySelectorAll('.quick-row').forEach(row => {
      const buttons = Array.from(row.querySelectorAll('.quick'));
      const firstText = buttons[0]?.textContent.trim() || '';
      const isWindowRow = ['上午','中午','下午'].some(w => firstText.startsWith(w));
      if(!isWindowRow) return;
      buttons.forEach(btn => {
        const txt = btn.textContent.trim();
        let win = null;
        Object.keys(WIN_CUTOFFS).forEach(k => { if(txt.startsWith(k)) win = k; });
        if(win) disableOrEnable(btn, WIN_CUTOFFS[win], nowM, today);
      });
      autoPickFirstAvailable(row);
    });
    W.querySelectorAll('.time-cats').forEach(g => autoPickFirstAvailable(g));
    if(today){
      const allCatDisabled = Array.from(W.querySelectorAll('.time-cats .time-cat')).every(b => b.classList.contains('is-disabled'));
      if(allCatDisabled){
        const dateRow = W.querySelector('.quick-row');
        const todayChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('今日'));
        const tmrChip = Array.from(dateRow.querySelectorAll('.quick')).find(b => b.textContent.includes('明日'));
        if(todayChip && tmrChip){
          todayChip.classList.remove('is-active');
          tmrChip.classList.add('is-active');
          setTimeout(applyTimeCutoffs, 30);
        }
      }
    }
    const slot30 = W.querySelector('#slot30');
    if(slot30 && slot30.style.display !== 'none'){
      const slots = Array.from(slot30.querySelectorAll('.hour'));
      slots.forEach(btn => {
        const start = parseSlotStart(btn.textContent);
        if(start) disableOrEnable(btn, start, nowM, today);
      });
    }
  }
  applyTimeCutoffs();
  W.querySelectorAll('.quick-row .quick').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 50));
  });
  W.querySelectorAll('.time-cat, .upgrade').forEach(btn => {
    btn.addEventListener('click', () => setTimeout(applyTimeCutoffs, 100));
  });
})();
(function(){
  const W = document.querySelector('.orchid-pdp-v2a-wrap');
  if(!W) return;
  const form = document.getElementById('v2a-bouquet-form');
  if(!form) return;
  W.querySelectorAll('.size').forEach(btn => {
    btn.addEventListener('click', () => {
      const vid = btn.dataset.variantId;
      if(vid){
        const idInput = document.getElementById('v2a-variant-id');
        if(idInput) idInput.value = vid;
      }
    });
  });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    const errors = [];
    const sizeActive = W.querySelector('.size.is-active');
    if(!sizeActive) errors.push('請揀尺寸');
    const dateActive = W.querySelector('.quick-row .quick.is-active');
    if(!dateActive) errors.push('請揀送花日期');
    const timeCatActive = W.querySelector('.time-cat.is-active');
    if(!timeCatActive) errors.push('請揀送花時段');
    let timeWinActive = null;
    if(timeCatActive){
      const winPanel = timeCatActive.querySelector('.tl-windows');
      if(winPanel){
        timeWinActive = winPanel.querySelector('.quick.is-active');
        if(!timeWinActive) errors.push('請揀送花時段內 window');
      } else {
        timeWinActive = timeCatActive;
      }
    }
    const venueName = document.getElementById('venue-name')?.value?.trim() || '';
    if(!venueName) errors.push('請填場所名稱');
    const phoneIn = W.querySelector('input[type="tel"]');
    const phone = phoneIn?.value?.trim() || '';
    if(!phone) errors.push('請填訂花人電話');
    const bnrTop = document.getElementById('banner-top-name')?.value?.trim() || '';
    if(!bnrTop) errors.push('請填賀詞上款（受款方）');
    const bnrSender = document.getElementById('banner-sender-name')?.value?.trim() || '';
    if(!bnrSender) errors.push('請填賀詞下款（送禮人）');
    const relValue = '';
    const name = '';
    const primaryPrefix = '';
    const primaryName = '';
    const relSel = null;
    const primaryRow = null;
    if(errors.length){
      showError(errors.join(' · '));
      const target = !dateActive ? W.querySelector('.quick-row')
                   : !timeWinActive ? (timeCatActive?.querySelector('.tl-windows') || timeCatActive)
                   : !venueName ? document.getElementById('venue-name')
                   : !phone ? phoneIn
                   : !relValue ? relSel
                   : !name ? document.getElementById('in-name')
                   : (!primaryPrefix || !primaryName) ? primaryRow?.querySelector('.sender-name')
                   : null;
      if(target) target.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    try {
      document.getElementById('prop-date').value = dateActive.textContent.trim().replace(/ · 製作來不及/, '');
      document.getElementById('prop-time-cat').value = timeCatActive.textContent.trim();
      document.getElementById('prop-time-win').value = timeWinActive.textContent.trim().replace(/ · 製作來不及/, '');
      const time30Active = W.querySelector('.hour.is-active');
      document.getElementById('prop-time-30').value = time30Active?.textContent.trim() || '';
      const upgradeActive = W.querySelector('.upgrade.is-active');
      document.getElementById('prop-upgrade').value = upgradeActive?.querySelector('.cn')?.textContent.trim() || '';
      const venueTypeSel = W.querySelectorAll('.sub-block select.uline')[0];
      document.getElementById('prop-venue-type').value = venueTypeSel?.value || '';
      document.getElementById('prop-venue-name').value = venueName;
      const floorIn = W.querySelector('input[placeholder*="樓"]');
      document.getElementById('prop-floor').value = floorIn?.value || '';
      const hallIn = W.querySelector('input[placeholder*="A 號"]');
      document.getElementById('prop-hall').value = hallIn?.value || '';
      document.getElementById('prop-phone').value = phone;
      const params = new URLSearchParams({
        reltitle: m.title || '',
        name: name,
        hon: m.hon || '千古',
        phrase: phrase,
        senders: JSON.stringify(senders.map(s => ({prefix: applyRank(s.prefix, s.rank), name: s.name, level: prefixLevel[s.prefix] ?? 99}))),
        suffix: suffix,
      });
      document.getElementById('prop-print-url').value = location.origin + '/pages/funeral-print?' + params.toString();
    } catch(err){
      console.error('V2A property gather error:', err);
      showError('資料整理出錯：' + err.message);
      return;
    }
    const ctaBtn = form.querySelector('.cta');
    if(ctaBtn){ ctaBtn.disabled = true; ctaBtn.style.opacity = '.6'; }
    const properties = {};
    form.querySelectorAll('input[name^="properties"]').forEach(inp => {
      const key = inp.name.match(/\[(.+)\]/)?.[1];
      if(key && inp.value) properties[key] = inp.value;
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        id: document.getElementById('v2a-variant-id').value,
        quantity: 1,
        properties: properties
      })
    })
    .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
    .then(data => {
      showSuccess();
      setTimeout(() => { location.href = '/cart'; }, 1600);
    })
    .catch(err => {
      console.error('Cart add error:', err);
      showError('加入購物車失敗：' + (err.description || err.message || '請再試一次'));
      if(ctaBtn){ ctaBtn.disabled = false; ctaBtn.style.opacity = '1'; }
    });
  });
  function showSuccess(){
    let overlay = document.querySelector('.v2a-cart-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'v2a-cart-overlay';
      overlay.innerHTML = '<div class="v2a-cart-card"><div class="v2a-cart-check"><svg viewBox="0 0 24 24"><polyline points="4,12 10,18 20,6"/></svg></div><h3 class="v2a-cart-title">已加入購物車</h3><p class="v2a-cart-sub">Added to cart<br/>正在前往結算頁面…</p></div>';
      document.body.appendChild(overlay);
    }
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  }
  function showError(msg){
    let bar = document.querySelector('.v2a-cart-error');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'v2a-cart-error';
      document.body.appendChild(bar);
    }
    bar.textContent = '⚠ ' + msg;
    bar.classList.add('is-visible');
    clearTimeout(bar._t);
    bar._t = setTimeout(() => bar.classList.remove('is-visible'), 5000);
  }
})();
(function(){
  const pm = document.getElementById('phrase-meaning');
  if(!pm) return;
  const wrap = pm.closest('.orchid-pdp-v2a-wrap') || document;
  wrap.addEventListener('click', function(e){
    const chip = e.target.closest('.chip[data-p]');
    if(!chip) return;
    pm.classList.remove('is-flying');
    void pm.offsetWidth; // force reflow
    pm.classList.add('is-flying');
  });
})();
(function(){
  const inRel2 = document.getElementById('in-relation');
  const inSuf = document.getElementById('in-suffix');
  if(!inRel2 || !inSuf) return;
  inRel2.addEventListener('change', () => {
    setTimeout(() => {
      inSuf.classList.remove('is-autofilled');
      void inSuf.offsetWidth;
      inSuf.classList.add('is-autofilled');
    }, 50);
  });
})();
(function(){
  const W = document.querySelector('.orchid-pdp-v2a-wrap');
  if(!W) return;
  W.addEventListener('click', function(e){
    const btn = e.target.closest('.time-cat, .quick, .hour');
    if(!btn) return;
    if(btn.classList.contains('is-disabled')) return;
    const parent = btn.parentElement;
    if(!parent) return;
    let peers;
    if(btn.classList.contains('time-cat')){
      peers = parent.querySelectorAll(':scope > .time-cat');
    } else if(btn.classList.contains('quick')){
      peers = parent.querySelectorAll(':scope > .quick');
    } else if(btn.classList.contains('hour')){
      peers = parent.querySelectorAll(':scope > .hour');
    }
    if(!peers) return;
    peers.forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }, true); // capture phase so we win over any broken listeners
})();

  } catch(e) { console.error(e); }
})();
})();
